/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    "use strict";

    angular
        .module("A56.pages", [
            "ui.router",
            "A56.pages.home",
            "A56.pages.dashboard",
            "A56.pages.dashboard.dcbi",
            "A56.pages.attendance",
            "A56.pages.settleAccount",
            "A56.pages.settings"
        ])
        .config(routeConfig);

    routeConfig.$inject = ["$urlRouterProvider", "$stateProvider", "AbpScriptsInitializedProvider"];

    /** @ngInject */
    function routeConfig($urlRouterProvider, $stateProvider, AbpScriptsInitialized) {
        setRouter($urlRouterProvider, $stateProvider, AbpScriptsInitialized);
    }

    function setRouter($urlRouterProvider, $stateProvider, AbpScriptsInitialized) {
        if (abp.nav.menus.MainMenu.items && abp.nav.menus.MainMenu.items.length) {
            // 添加虚拟路由，如果直接在地址栏中输入[/Dashboard-Dcbi]路径则不会进入虚拟路由而直接进入非授权页
            // 如果没有直接在地址栏中输入[/Dashboard-Dcbi]路径则会进行登录验证，从而跳转到登录页
            $urlRouterProvider.otherwise("/");
            var homeState = abp.nav.menus.MainMenu.items.filter(function(i) {
                return i.name == "Home";
            })[0];
            if (!homeState) {
                $stateProvider.state("Home", {
                    url: "/",
                    // abstract 设为 true 后不会触发 stateChangeStart 事件
                    abstract: false,
                    template: "<ui-view></ui-view>"
                });
            }
        } else {
            abp.ng.http.handleUnAuthorizedRequest();
        }

        abp.nav.menus.MainMenu.items.forEach(function(item) {
            getMenu(item);
        });

        function getMenu(menu, parentMenu) {
            menu.name = parentMenu ? parentMenu.name + "." + menu.name : menu.name;
            if (menu.items) {
                menu.items.forEach(function(item) {
                    getMenu(item, menu);
                });
            }
            $stateProvider.state(menu.name, addRouter(menu));
        }

        function addRouter(menuItem) {
            var result = {
                url: menuItem.url,
                title: menuItem.displayName,
                sidebarMeta: menuItem.isVisible
                    ? {
                          icon: menuItem.icon,
                          order: menuItem.order
                      }
                    : undefined
            };
            // result.onEnter = function() {};
            if (menuItem.customData && !angular.equals({}, menuItem.customData)) {
                if (menuItem.customData.templateUrl) {
                    result.templateUrl = menuItem.customData.templateUrl;
                } else if (menuItem.customData.template) {
                    result.template = menuItem.customData.template;
                }
                if (menuItem.customData.abstract) {
                    result.abstract = menuItem.customData.abstract;
                }
                if (menuItem.customData.controller) {
                    result.controller = menuItem.customData.controller;
                    result.controllerAs = "vm";
                    extendCtrl(result, menuItem.name);
                }
            }
            return result;
        }

        function extendCtrl(item, stateName) {
            switch (stateName) {
                case "Dashboard.TotalOrderShipped":
                    setTotalOrderShippedCtrl(item);
                    break;
                case "Dashboard.TotalLineShipped":
                    setTotalLineShippedCtrl(item);
                    break;
                case "Dashboard.TotalOrderReceived":
                    setTotalOrderReceivedCtrl(item);
                    break;
                case "Dashboard.TotalLineReceived":
                    setTotalLineReceivedCtrl(item);
                    break;
                case "Dashboard.WarehouseOrderCycleTime":
                    setWarehouseOrderCycleTimeCtrl(item);
                    break;
            }
        }

        function setTotalOrderShippedCtrl(item) {
            item.resolve = {
                content: function() {
                    return {
                        statisticsID: 2,
                        barChartApiSvcName: "getHistogramSum",
                        reportName: "Total Order Shipped",
                        decActual: "Dec Actual",
                        reportFormula:
                            "*** Total Order Shipped = # of DW(SAP) and Picking order(E1),* excluded ***",
                        comments: [
                            {
                                className: "col-md-6",
                                title: "Gaps Identified",
                                items: ["N/A"]
                            },
                            {
                                className: "col-md-6",
                                title: "Root Cause",
                                items: ["N/A"]
                            },
                            {
                                className: "col-md-12",
                                title: "Countermeasure",
                                items: [
                                    "Build up regular check precess to keep the performance stable"
                                ]
                            }
                        ]
                    };
                }
            };
        }

        function setTotalLineShippedCtrl(item) {
            item.resolve = {
                content: function() {
                    return {
                        statisticsID: 3,
                        barChartApiSvcName: "getHistogramSum",
                        reportName: "Total Order Shipped",
                        decActual: "Dec Actual",
                        reportFormula:
                            "*** Total Line Shipped = # of WMS Pick-Pack Line，* excluded ***",
                        comments: [
                            {
                                className: "col-md-6",
                                title: "Gaps Identified",
                                items: ["N/A"]
                            },
                            {
                                className: "col-md-6",
                                title: "Root Cause",
                                items: ["N/A"]
                            },
                            {
                                className: "col-md-12",
                                title: "Countermeasure",
                                items: [
                                    "Build up regular check precess to keep the performance stable"
                                ]
                            }
                        ]
                    };
                }
            };
        }

        function setTotalOrderReceivedCtrl(item) {
            item.resolve = {
                content: function() {
                    return {
                        statisticsID: 21,
                        barChartApiSvcName: "getHistogramSum",
                        reportName: "Total Order Received",
                        decActual: "Dec Actual",
                        reportFormula: "*** Total Order Received ***",
                        comments: [
                            {
                                className: "col-md-6",
                                title: "Gaps Identified",
                                items: ["N/A"]
                            },
                            {
                                className: "col-md-6",
                                title: "Root Cause",
                                items: ["N/A"]
                            },
                            {
                                className: "col-md-12",
                                title: "Countermeasure",
                                items: [""]
                            }
                        ]
                    };
                }
            };
        }

        function setTotalLineReceivedCtrl(item) {
            item.resolve = {
                content: function() {
                    return {
                        statisticsID: 4,
                        barChartApiSvcName: "getHistogramSum",
                        reportName: "Total Line Received",
                        decActual: "Dec Actual",
                        reportFormula: "*** Total Line Received ***",
                        comments: [
                            {
                                className: "col-md-6",
                                title: "Gaps Identified",
                                items: ["N/A"]
                            },
                            {
                                className: "col-md-6",
                                title: "Root Cause",
                                items: ["N/A"]
                            },
                            {
                                className: "col-md-12",
                                title: "Countermeasure",
                                items: [""]
                            }
                        ]
                    };
                }
            };
        }

        function setWarehouseOrderCycleTimeCtrl(item) {
            item.resolve = {
                content: function() {
                    return {
                        statisticsID: 5,
                        lineChartApiSvcName: "getMonthlyAverageIndicator",
                        barChartApiSvcName: "getHistogramAverage",
                        reportName: "Total Line Received",
                        decActual: "Dec Actual",
                        reportFormula:
                            "*** Warehouse Order Cycle Time=The average calendar time from creation of DN to out bound in WMS ***",
                        comments: [
                            {
                                className: "col-md-6",
                                title: "Gaps Identified",
                                items: ["N/A"]
                            },
                            {
                                className: "col-md-6",
                                title: "Root Cause",
                                items: [
                                    "Order shipped from HM warehouse",
                                    "Special order by CSR: stock order before order made",
                                    "Customer self take",
                                    "Physical need repackage  "
                                ]
                            },
                            {
                                className: "col-md-12",
                                title: "Countermeasure",
                                items: ["Monitor delay DN, closed issue one by one"]
                            }
                        ]
                    };
                }
            };
        }
    }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function() {
    "use strict";

    angular.module("A56.sso", ["ui.router"]).run(ssoRun);

    ssoRun.$inject = ["$http", "$state", "$location", "$rootScope"];

    function ssoRun($http, $state, $location, $rootScope) {
        $rootScope.$on("$stateChangeStart", function(
            evt,
            toState,
            toParams,
            fromState,
            fromParams,
            options
        ) {
            if ($location.$$path.toLowerCase() == "/dashboard-dcbi") return;
            if (!abp.session || !abp.session.userId) {
                var menus;
                toState.name.split(".").forEach(function(item) {
                    if (menus) {
                        menus = menus.filter(function(menu) {
                            return menu.name == item;
                        });
                    } else {
                        menus = abp.nav.menus.MainMenu.items.filter(function(menu) {
                            return menu.name == item;
                        });
                    }
                });

                if (!menus.length) {
                    abp.ng.http.handleUnAuthorizedRequest();
                    // 停止加载页面
                    evt.preventDefault();
                }
            }
        });
    }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function() {
    "use strict";

    angular.module("A56.theme", [
        "A56.sso",
        "toastr",
        "chart.js",
        "angular-chartist",
        "angular.morris-chart",
        "textAngular",
        "ngLocale",
        "A56.theme.components",
        "A56.theme.inputs"
    ]);
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    "use strict";

    angular.module("A56.pages.attendance", []); //.config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state("attendance", {
                url: "/attendance",
                abstract: true,
                template: "<ui-view></ui-view>",
                title: "考勤",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 1
                },
                perm: "Pages.Attendance"
            })
            .state("attendance.timeSheetInput", {
                url: "/timeSheetInput",
                templateUrl: "app/pages/attendance/timeSheetInput.html",
                title: "每日工时录入",
                controller: "TimeSheetInputCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 0
                },
                perm: "Pages.Attendance.TimeSheetInput"
            })
            .state("attendance.inhouseStaff", {
                url: "/inhouseStaff",
                templateUrl: "app/pages/attendance/inhouseStaff/inhouseStaff.html",
                title: "驻仓人员考勤",
                controller: "InhouseStaffCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 1
                },
                perm: "Pages.Attendance.InhouseStaff"
            });
    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    "use strict";

    angular.module("A56.pages.dashboard", []); //.config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.when("/dashboard", "/dashboard/totalOrderShipped");

        $stateProvider
            .state("dashboard", {
                url: "/dashboard",
                // abstract: true,
                template: "<ui-view></ui-view>",
                title: "Dashboard",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 0
                },
                perm: "Pages.Dashboard"
            })
            .state("dashboard.totalOrderShipped", {
                url: "/totalOrderShipped",
                // abstract: true,
                templateUrl: "app/pages/dashboard/dashboard.html",
                title: "Total Order Shipped",
                controller: "DashboardCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 0
                },
                perm: "Pages.Dashboard.TotalOrderShipped",
                resolve: {
                    content: function() {
                        return {
                            statisticsID: 2,
                            barChartApiSvcName: "getHistogramSum",
                            // // 调用后台 Api 的回调函数
                            // barChartApiSvcCallback: function(result) {
                            //     return [
                            //         {
                            //             name: "YTD",
                            //             sum: result.preYearTotal,
                            //             colorName: "danger"
                            //         },
                            //         {
                            //             name: "Goal",
                            //             sum: result.curYearQuota,
                            //             colorName: "success"
                            //         },
                            //         {
                            //             name: "YOY",
                            //             sum: result.curYearTotal,
                            //             colorName: "warning"
                            //         }
                            //     ];
                            // },
                            reportName: "Total Order Shipped",
                            decActual: "Dec Actual",
                            reportFormula:
                                "*** Total Order Shipped = # of DW(SAP) and Picking order(E1),* excluded ***",
                            comments: [
                                {
                                    className: "col-md-6",
                                    title: "Gaps Identified",
                                    items: ["N/A"]
                                },
                                {
                                    className: "col-md-6",
                                    title: "Root Cause",
                                    items: ["N/A"]
                                },
                                {
                                    className: "col-md-12",
                                    title: "Countermeasure",
                                    items: [
                                        "Build up regular check precess to keep the performance stable"
                                    ]
                                }
                            ]
                        };
                    }
                }
            })
            .state("dashboard.totalLineShipped", {
                url: "/totalLineShipped",
                // abstract: true,
                templateUrl: "app/pages/dashboard/dashboard.html",
                title: "Total Line Shipped",
                controller: "DashboardCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 0
                },
                perm: "Pages.Dashboard.TotalLineShipped",
                resolve: {
                    content: function() {
                        return {
                            statisticsID: 3,
                            barChartApiSvcName: "getHistogramSum",
                            reportName: "Total Order Shipped",
                            decActual: "Dec Actual",
                            reportFormula:
                                "*** Total Line Shipped = # of WMS Pick-Pack Line，* excluded ***",
                            comments: [
                                {
                                    className: "col-md-6",
                                    title: "Gaps Identified",
                                    items: ["N/A"]
                                },
                                {
                                    className: "col-md-6",
                                    title: "Root Cause",
                                    items: ["N/A"]
                                },
                                {
                                    className: "col-md-12",
                                    title: "Countermeasure",
                                    items: [
                                        "Build up regular check precess to keep the performance stable"
                                    ]
                                }
                            ]
                        };
                    }
                }
            })
            .state("dashboard.totalOrderReceived", {
                url: "/totalOrderReceived",
                // abstract: true,
                templateUrl: "app/pages/dashboard/dashboard.html",
                title: "Total Order Received",
                controller: "DashboardCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 0
                },
                perm: "Pages.Dashboard.TotalOrderReceived",
                resolve: {
                    content: function() {
                        return {
                            statisticsID: 21,
                            barChartApiSvcName: "getHistogramSum",
                            reportName: "Total Order Received",
                            decActual: "Dec Actual",
                            reportFormula: "*** Total Order Received ***",
                            comments: [
                                {
                                    className: "col-md-6",
                                    title: "Gaps Identified",
                                    items: ["N/A"]
                                },
                                {
                                    className: "col-md-6",
                                    title: "Root Cause",
                                    items: ["N/A"]
                                },
                                {
                                    className: "col-md-12",
                                    title: "Countermeasure",
                                    items: [""]
                                }
                            ]
                        };
                    }
                }
            })
            .state("dashboard.totalLineReceived", {
                url: "/totalLineReceived",
                // abstract: true,
                templateUrl: "app/pages/dashboard/dashboard.html",
                title: "Total Line Received",
                controller: "DashboardCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 0
                },
                perm: "Pages.Dashboard.TotalLineReceived",
                resolve: {
                    content: function() {
                        return {
                            statisticsID: 4,
                            barChartApiSvcName: "getHistogramSum",
                            reportName: "Total Line Received",
                            decActual: "Dec Actual",
                            reportFormula: "*** Total Line Received ***",
                            comments: [
                                {
                                    className: "col-md-6",
                                    title: "Gaps Identified",
                                    items: ["N/A"]
                                },
                                {
                                    className: "col-md-6",
                                    title: "Root Cause",
                                    items: ["N/A"]
                                },
                                {
                                    className: "col-md-12",
                                    title: "Countermeasure",
                                    items: [""]
                                }
                            ]
                        };
                    }
                }
            })
            .state("dashboard.warehouseOrderCycleTime", {
                url: "/warehouseOrderCycleTime",
                // abstract: true,
                templateUrl: "app/pages/dashboard/dashboard.html",
                title: "Warehouse Order Cycle Time",
                controller: "DashboardCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 0
                },
                perm: "Pages.Dashboard.WarehouseOrderCycleTime",
                resolve: {
                    content: function() {
                        return {
                            statisticsID: 5,
                            lineChartApiSvcName: "getMonthlyAverageIndicator",
                            barChartApiSvcName: "getHistogramAverage",
                            reportName: "Total Line Received",
                            decActual: "Dec Actual",
                            reportFormula:
                                "*** Warehouse Order Cycle Time=The average calendar time from creation of DN to out bound in WMS ***",
                            comments: [
                                {
                                    className: "col-md-6",
                                    title: "Gaps Identified",
                                    items: ["N/A"]
                                },
                                {
                                    className: "col-md-6",
                                    title: "Root Cause",
                                    items: [
                                        "Order shipped from HM warehouse",
                                        "Special order by CSR: stock order before order made",
                                        "Customer self take",
                                        "Physical need repackage  "
                                    ]
                                },
                                {
                                    className: "col-md-12",
                                    title: "Countermeasure",
                                    items: ["Monitor delay DN, closed issue one by one"]
                                }
                            ]
                        };
                    }
                }
            })
            .state("dashboard.pes", {
                url: "/pes",
                // abstract: true,
                templateUrl: "app/pages/dashboard/pes.html",
                title: "生产效率统计",
                controller: "PesCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 0
                },
                perm: "Pages.Dashboard.Pes"
            });
    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    "use strict";

    angular.module("A56.pages.home", []); //.config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider.state("Welcome", {
            url: "/Welcome",
            templateUrl: "app/pages/welcome/home.html",
            title: "Home"
        });
    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    "use strict";

    angular.module("A56.pages.settings", ["A56.pages.settings.treeService"]); //.config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state("settings", {
                url: "/settings",
                template: "<ui-view></ui-view>",
                title: "设置",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 3
                },
                perm: "Pages.Settings"
            })
            .state("settings.saleTariff", {
                url: "/saleTariff",
                templateUrl: "app/pages/settings/saleTariff/saleTariff.html",
                controller: "SaleTariffCtrl",
                controllerAs: "vm",
                title: "仓储价格文件",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 0
                },
                perm: "Pages.Settings.SaleTariff"
            })
            .state("settings.saleTariffDetail", {
                url: "/saleTariff/:id",
                templateUrl: "app/pages/settings/saleTariff/saleTariffDetail.html",
                controller: "SaleTariffDetailCtrl",
                controllerAs: "vm",
                title: "仓储价格文件",
                perm: "Pages.Settings.SaleTariffDetail"
            })
            .state("settings.subject", {
                url: "/subject",
                templateUrl: "app/pages/settings/subject/subject.html",
                controller: "SubjectCtrl",
                controllerAs: "vm",
                title: "科目",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 1
                },
                perm: "Pages.Settings.Subject"
            })
            .state("settings.department", {
                url: "/department",
                templateUrl: "app/pages/settings/department/department.html",
                controller: "DepartmentCtrl",
                controllerAs: "vm",
                title: "部门",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 2
                },
                perm: "Pages.Settings.Department"
            })
            .state("settings.warehouse", {
                url: "/warehouse",
                templateUrl: "app/pages/settings/warehouse/warehouse.html",
                controller: "WarehouseCtrl",
                controllerAs: "vm",
                title: "仓库",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 3
                }
                // perm: "Pages.Settings.Warehouse"
            })
            .state("settings.customer", {
                url: "/customer",
                templateUrl: "app/pages/settings/customer/customer.html",
                controller: "CustomerCtrl",
                controllerAs: "vm",
                title: "客户",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 4
                }
                // perm: "Pages.Settings.Customer"
            })
            .state("settings.project", {
                url: "/project",
                templateUrl: "app/pages/settings/project/project.html",
                controller: "ProjectCtrl",
                controllerAs: "vm",
                title: "项目",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 5
                }
                // perm: "Pages.Settings.Project"
            })
            .state("settings.cleaingRule", {
                url: "/cleaingRule",
                templateUrl: "app/pages/settings/cleaingRule/cleaingRule.html",
                controller: "CleaingRuleCtrl",
                controllerAs: "vm",
                title: "仓储结算规则",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 5
                }
                // perm: "Pages.Settings.Project"
            })
            .state("settings.user", {
                url: "/user",
                templateUrl: "app/pages/settings/users/users.html",
                controller: "UsersCtrl",
                controllerAs: "vm",
                title: "用户管理",
                sidebarMeta: {
                    icon: "fa fa-users",
                    order: 5
                }
                // perm: "Pages.Settings.Project"
            })
            .state("settings.role", {
                url: "/role",
                templateUrl: "app/pages/settings/roles/roles.html",
                controller: "RolesCtrl",
                controllerAs: "vm",
                title: "权限管理",
                sidebarMeta: {
                    icon: "fa fa-users",
                    order: 5
                }
                // perm: "Pages.Settings.Project"
            });
    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    "use strict";

    angular.module("A56.pages.settleAccount", []);//.config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        // $urlRouterProvider.when("/settleAccount", "/settleAccount/departmentTotal");

        $stateProvider
            .state("settleAccount", {
                url: "/settleAccount",
                //表示 /settleAccount 不可访问，只能访问其子路由 settleAccount.kanban 和 settleAccount.report
                abstract: true,
                template: "<ui-view></ui-view>",
                title: "结算",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 2
                },
                perm: "Pages.SettleAccount"
            })
            .state("settleAccount.panel", {
                url: "/panel",
                //表示 /settleAccount 不可访问，只能访问其子路由 settleAccount.kanban.departmentTotal 
                abstract: false,
                templateUrl: "app/pages/settleAccount/panel/panel.html",
                controller: "PanelCtrl",
                controllerAs: "vm",
                title: "看板",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 2
                },
                perm: "Pages.SettleAccount.panel"
            })
            .state("settleAccount.kanban", {
                url: "/kanban",
                //表示 /settleAccount 不可访问，只能访问其子路由 settleAccount.kanban.departmentTotal 
                abstract: true,
                template: "<ui-view></ui-view>",
                title: "看板",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 2
                },
                perm: "Pages.SettleAccount"
            })
            .state("settleAccount.report", {
                url: "/report",
                abstract: true,
                //表示 /settleAccount 不可访问，只能访问其子路由 settleAccount.report.departmentReport
                template: "<ui-view></ui-view>",
                title: "统计",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 2
                },
                perm: "Pages.SettleAccount"
            })
            .state("settleAccount.kanban.departmentTotal", {
                url: "/departmentTotal",
                templateUrl: "app/pages/settleAccount/department/departmentTotal.html",
                controller: "DepartmentTotalCtrl",
                controllerAs: "vm",
                title: "部门营收",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 0
                },
                perm: "Pages.SettleAccount.DepartmentTotal"
            })
            .state("settleAccount.report.departmentDetail", {
                url: "/departmentDetail",
                templateUrl: "app/pages/settleAccount/department/departmentDetail.html",
                controller: "DepartmentDetailCtrl",
                controllerAs: "vm",
                title: "部门营收",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 1
                },
                perm: "Pages.SettleAccount.DepartmentDetail"
            })
            .state("settleAccount.kanban.customerTotal", {
                url: "/customerTotal",
                templateUrl: "app/pages/settleAccount/customer/customerTotal.html",
                controller: "CustomerTotalCtrl",
                controllerAs: "vm",
                title: "客户营收",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 2
                },
                perm: "Pages.SettleAccount.CustomerTotal"
            })
            .state("settleAccount.report.customerDetail", {
                url: "/customerDetail",
                templateUrl: "app/pages/settleAccount/customer/customerDetail.html",
                controller: "CustomerDetailCtrl",
                controllerAs: "vm",
                title: "客户营收",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 3
                },
                perm: "Pages.SettleAccount.CustomerDetail"
            })
            .state("settleAccount.kanban.subjectTotal", {
                url: "/subjectTotal",
                templateUrl: "app/pages/settleAccount/subject/subjectTotal.html",
                title: "科目营收",
                controller: "SubjectTotalCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 4
                },
                perm: "Pages.SettleAccount.SubjectTotal"
            })
            .state("settleAccount.report.subjectDetail", {
                url: "/subjectDetail",
                templateUrl: "app/pages/settleAccount/subject/subjectDetail.html",
                title: "科目营收",
                controller: "SubjectDetailCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 5
                },
                perm: "Pages.SettleAccount.SubjectDetail"
            })
            .state("settleAccount.saleCharge", {
                url: "/saleCharge",
                templateUrl: "app/pages/settleAccount/warehouse/saleCharge.html",
                title: "仓储临时费用录入",
                controller: "SaleChargeCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 6
                },
                perm: "Pages.SettleAccount.SaleCharge"
            })
            .state("settleAccount.orderDetail", {
                url: "/orderDetail",
                templateUrl: "app/pages/settleAccount/warehouse/orderDetail.html",
                title: "仓储出入库明细录入",
                controller: "settleAccount.orderDetailCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 7
                },
                perm: "Pages.SettleAccount.OrderDetail"
            })
            .state("settleAccount.saleBilling", {
                url: "/saleBilling",
                templateUrl: "app/pages/settleAccount/saleBilling/saleBilling.html",
                title: "账单",
                controller: "SaleBillingCtrl",
                controllerAs: "vm",
                sidebarMeta: {
                    icon: "ion-stats-bars",
                    order: 8
                },
                perm: "Pages.SettleAccount.SaleBilling"
            })
            .state("settleAccount.saleBillingDetail", {
                url: "/saleBillingDetail/:id",
                templateUrl: "app/pages/settleAccount/saleBilling/saleBillingDetail.html",
                title: "账单详情",
                controller: "SaleBillingDetailCtrl",
                controllerAs: "vm",
                perm: "Pages.SettleAccount.SaleBillingDetail"
            });
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('A56.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    "use strict";

    angular
        .module("A56.pages.dashboard.dcbi", [])
        // .config(routeConfig)
        .config(chartJsConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider.state("dashboard.dcbi", {
            url: "/dcbi",
            // abstract: true,
            templateUrl: "app/pages/dashboard/DCBI/dcbi.html",
            title: "DC",
            controller: "DcbiCtrl",
            controllerAs: "vm",
            sidebarMeta: {
                icon: "ion-stats-bars",
                order: 0
            }
            // ,
            // perm: "Pages.Dashboard.Dcbi"
        });
    }

    function chartJsConfig(ChartJsProvider, baConfigProvider) {
        var layoutColors = baConfigProvider.colors;
        // Configure all charts
        ChartJsProvider.setOptions({
            chartColors: [
                layoutColors.primary,
                layoutColors.danger,
                layoutColors.warning,
                layoutColors.success,
                layoutColors.info,
                layoutColors.default,
                layoutColors.primaryDark,
                layoutColors.successDark,
                layoutColors.warningLight,
                layoutColors.successLight,
                layoutColors.primaryLight
            ],
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 2500
            },
            scale: {
                gridLines: {
                    color: layoutColors.border
                },
                scaleLabel: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    fontColor: layoutColors.defaultText,
                    showLabelBackdrop: false
                }
            }
        });
        // Configure all line charts
        ChartJsProvider.setOptions("Line", {
            datasetFill: false
        });
        // Configure all radar charts
        ChartJsProvider.setOptions("radar", {
            scale: {
                pointLabels: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    maxTicksLimit: 5,
                    display: false
                }
            }
        });
        // Configure all bar charts
        ChartJsProvider.setOptions("bar", {
            tooltips: {
                enabled: false
            }
        });
    }
})();

"use strict";

angular.module("A56", [
    "ngFileSaver",
    "ngAnimate",
    "ui.bootstrap",
    "ui.sortable",
    "ui.router",
    "ngTouch",
    "toastr",
    "smart-table",
    "xeditable",
    "ui.slimscroll",
    "ngJsTree",
    "angular-progress-button-styles",
    "ui.select",
    "ngSanitize",
    "A56.theme",
    "A56.pages",
    "abp"
]);

"use strict";
angular.module(
    "ngLocale",
    [],
    [
        "$provide",
        function($provide) {
            var PLURAL_CATEGORY = {
                ZERO: "zero",
                ONE: "one",
                TWO: "two",
                FEW: "few",
                MANY: "many",
                OTHER: "other"
            };
            $provide.value("$locale", {
                DATETIME_FORMATS: {
                    AMPMS: ["\u4e0a\u5348", "\u4e0b\u5348"],
                    DAY: [
                        "\u661f\u671f\u65e5",
                        "\u661f\u671f\u4e00",
                        "\u661f\u671f\u4e8c",
                        "\u661f\u671f\u4e09",
                        "\u661f\u671f\u56db",
                        "\u661f\u671f\u4e94",
                        "\u661f\u671f\u516d"
                    ],
                    ERANAMES: ["\u516c\u5143\u524d", "\u516c\u5143"],
                    ERAS: ["\u516c\u5143\u524d", "\u516c\u5143"],
                    FIRSTDAYOFWEEK: 6,
                    MONTH: [
                        "\u4e00\u6708",
                        "\u4e8c\u6708",
                        "\u4e09\u6708",
                        "\u56db\u6708",
                        "\u4e94\u6708",
                        "\u516d\u6708",
                        "\u4e03\u6708",
                        "\u516b\u6708",
                        "\u4e5d\u6708",
                        "\u5341\u6708",
                        "\u5341\u4e00\u6708",
                        "\u5341\u4e8c\u6708"
                    ],
                    SHORTDAY: [
                        "\u5468\u65e5",
                        "\u5468\u4e00",
                        "\u5468\u4e8c",
                        "\u5468\u4e09",
                        "\u5468\u56db",
                        "\u5468\u4e94",
                        "\u5468\u516d"
                    ],
                    SHORTMONTH: [
                        "1\u6708",
                        "2\u6708",
                        "3\u6708",
                        "4\u6708",
                        "5\u6708",
                        "6\u6708",
                        "7\u6708",
                        "8\u6708",
                        "9\u6708",
                        "10\u6708",
                        "11\u6708",
                        "12\u6708"
                    ],
                    STANDALONEMONTH: [
                        "\u4e00\u6708",
                        "\u4e8c\u6708",
                        "\u4e09\u6708",
                        "\u56db\u6708",
                        "\u4e94\u6708",
                        "\u516d\u6708",
                        "\u4e03\u6708",
                        "\u516b\u6708",
                        "\u4e5d\u6708",
                        "\u5341\u6708",
                        "\u5341\u4e00\u6708",
                        "\u5341\u4e8c\u6708"
                    ],
                    WEEKENDRANGE: [5, 6],
                    fullDate: "y\u5e74M\u6708d\u65e5EEEE",
                    longDate: "y\u5e74M\u6708d\u65e5",
                    medium: "y\u5e74M\u6708d\u65e5 ah:mm:ss",
                    mediumDate: "y\u5e74M\u6708d\u65e5",
                    mediumTime: "ah:mm:ss",
                    short: "y/M/d ah:mm",
                    shortDate: "y/M/d",
                    shortTime: "ah:mm"
                },
                NUMBER_FORMATS: {
                    CURRENCY_SYM: "\u00a5",
                    DECIMAL_SEP: ".",
                    GROUP_SEP: ",",
                    PATTERNS: [
                        {
                            gSize: 3,
                            lgSize: 3,
                            maxFrac: 3,
                            minFrac: 0,
                            minInt: 1,
                            negPre: "-",
                            negSuf: "",
                            posPre: "",
                            posSuf: ""
                        },
                        {
                            gSize: 3,
                            lgSize: 3,
                            maxFrac: 2,
                            minFrac: 2,
                            minInt: 1,
                            negPre: "-\u00a4",
                            negSuf: "",
                            posPre: "\u00a4",
                            posSuf: ""
                        }
                    ]
                },
                id: "zh",
                localeID: "zh",
                pluralCat: function(n, opt_precision) {
                    return PLURAL_CATEGORY.OTHER;
                }
            });
        }
    ]
);

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function() {
    "use strict";

    angular.module("A56.theme").config(config);

    /** @ngInject */
    function config(baConfigProvider, colorHelper, $provide, $httpProvider) {
        $provide.decorator("$uiViewScroll", uiViewScrollDecorator);
        $httpProvider.interceptors.push("httpInterceptor"); //添加拦截器
        //baConfigProvider.changeTheme({blur: true});
        //
        //baConfigProvider.changeColors({
        //  default: 'rgba(#000000, 0.2)',
        //  defaultText: '#ffffff',
        //  dashboard: {
        //    white: '#ffffff',
        //  },
        //});
    }

    /** @ngInject */
    function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
        return function(uiViewElement) {
            if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
                $anchorScroll();
            } else {
                $delegate(uiViewElement);
            }
        };
    }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('A56.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('A56.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function() {
    "use strict";

    angular.module("A56.theme").run(themeRun);

    themeRun.$inject = [
        "$timeout",
        "$rootScope",
        "layoutPaths",
        "preloader",
        "$q",
        "baSidebarService",
        "themeLayoutSettings"
    ];
    /** @ngInject */
    function themeRun(
        $timeout,
        $rootScope,
        layoutPaths,
        preloader,
        $q,
        baSidebarService,
        themeLayoutSettings
    ) {
        var whatToWait = [preloader.loadAmCharts()];

        var theme = themeLayoutSettings;
        if (theme.blur) {
            if (theme.mobile) {
                whatToWait.unshift(
                    preloader.loadImg(layoutPaths.images.root + "blur-bg-mobile.jpg")
                );
            } else {
                whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + "blur-bg.jpg"));
                whatToWait.unshift(
                    preloader.loadImg(layoutPaths.images.root + "blur-bg-blurred.jpg")
                );
            }
        }

        $q.all(whatToWait).then(function(result) {
            $rootScope.$pageFinishedLoading = true;
        });

        $timeout(function() {
            if (!$rootScope.$pageFinishedLoading) {
                $rootScope.$pageFinishedLoading = true;
            }
        }, 1000);

        $rootScope.$baSidebarService = baSidebarService;
    }
})();

/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('A56.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function() {
    "use strict";

    angular.module("A56.pages.attendance").controller("batchModalCtrl", batchModalCtrl);

    batchModalCtrl.$inject = ["items", "$uibModalInstance"];

    /** @ngInject */
    function batchModalCtrl(items, $uibModalInstance) {
        var vm = this;
        vm.isRest = items.isRestDay;
        vm.ddlKaoQin = [].concat(items.ddlKaoQin);
        vm.ddlKaoQin.splice(0, 1);
        vm.model = {
            kaoQin: vm.ddlKaoQin[0].value,
            // 超时
            timeOut: 0,
            // 请假
            leave: 0,
            // 工时
            work: 8
        };

        // 请假录入事件
        vm.leaveChange = function() {
            vm.model.work = 8 - vm.model.leave;
        };

        vm.submit = function() {
            $uibModalInstance.close({ isRest: vm.isRest, model: vm.model });
        };

        // radio change 事件
        vm.kaoqinChange = function() {
            if (vm.model.kaoQin == vm.ddlKaoQin[0].value) {
                // 出勤
                angular.extend(vm.model, {
                    // 超时
                    timeOut: 0,
                    // 请假
                    leave: 0,
                    // 工时
                    work: 8
                });
            } else {
                angular.extend(vm.model, {
                    // 超时
                    timeOut: 0,
                    // 请假
                    leave: 8,
                    // 工时
                    work: 0
                });
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.attendance").controller("TimeSheetInputCtrl", TimeSheetInputCtrl);

    TimeSheetInputCtrl.$inject = [
        "$scope",
        "$filter",
        "editableOptions",
        "editableThemes",
        "toastr",
        "$uibModal",
        "abp.services.app.attendance",
        "koaQin",
        "warehouse",
        'dalogModal'
    ];

    /** @ngInject */
    function TimeSheetInputCtrl($scope, $filter, editableOptions, editableThemes, toastr, $uibModal, attendanceSvc, koaQin, wh, dalogModal) {
        var vm = this,
            warehouse = wh.concat(),
            pageSize = 12,
            displayedPages = 5;
        vm.ddlKaoQin = koaQin.concat();
        // 在编结果集
        vm.rpData = [];
        // 临时结果集
        vm.tempData = [];
        vm.search = {
            attendanceDate: new Date(),
            warehouseCode: "",
            isRestDay: false,
            headName: "",
            whManagerName: "",
            inSystemEmployeeNum: 0,
            warehouse: {
                selected: {}
            }
        };

        vm.pageSetting1 = {
            pageSize: pageSize,
            displayedPages: displayedPages,
            pageIndex: 1,
            pageChange: function (currentPage) {
                vm.pageSetting1.pageIndex = currentPage;
                vm.checkBox.selectAll = false;
                vm.checkBox.allSelected(vm.checkBox.selectAll);
            }
        };

        vm.pageSetting2 = {
            pageSize: pageSize,
            displayedPages: displayedPages,
            pageIndex: 1,
            pageChange: function (currentPage) {
                vm.pageSetting2.pageIndex = currentPage;
            }
        };

        vm.datepicker = {
            open: openDatepicker,
            opened: false,
            format: "yyyy-MM-dd EEEE",
            options: {
                showWeeks: false
            },
            dateChanged: function (e) {
                reloadData();
            }
        };

        vm.checkBox = {
            selectAll: false,
            selectAllClick: function () {
                vm.checkBox.allSelected(vm.checkBox.selectAll);
            },
            items: [],
            selectedOne: function () {
                var index = 0,
                    len = vm.rpData.length,
                    isAllSelected = true;
                for (index; index < len; index++) {
                    if (!vm.rpData[index].checked) {
                        isAllSelected = false;
                        break;
                    }
                }
                vm.checkBox.selectAll = isAllSelected;
            },
            allSelected: function (flag) {
                var index = 0,
                    len = vm.rpData.length;
                for (index; index < len; index++) {
                    vm.rpData[index].checked = flag;
                }
            }
        };

        initDropdown();

        // 更新【负责人、当日仓库经理】
        vm.setWhManager = function (data) {
            vm.search.warehouseCode = vm.search.warehouse.selected.value;
            var oldname = vm.search.whManagerName;
            vm.search.whManagerName = data;
            attendanceSvc
                .updateMainAttendanceInfo(vm.search)
                .then(function (res) {
                    if (res.success) {
                        toastr.success("修改成功！");
                    } else {
                        toastr.error("修改失败！");
                    }
                })
                .catch(function (res) {
                    vm.search.whManagerName = oldname;
                });
        };

        vm.showKaoQin = function (item) {
            var selected = [];
            if (item.categoryCode) {
                selected = filterKaoQin(item.categoryCode);
            }
            return selected.length ? selected[0].text : "&nbsp;&nbsp;&nbsp;&nbsp;";
        };

        // 批量处理
        vm.batchClick = function () {
            var arr = getSelectedDatas();
            var newArr = [];
            angular.forEach(arr, function (v, i) {
                newArr.push(angular.extend({}, v));
            });
            if (!newArr.length) {
                toastr.warning("请选择处理的行!");
                return;
            }
            $uibModal
                .open({
                    animation: true,
                    templateUrl: "app/pages/attendance/batchModal.html",
                    controller: "batchModalCtrl",
                    controllerAs: "vm",
                    size: "md",
                    resolve: {
                        items: function () {
                            return {
                                ddlKaoQin: vm.ddlKaoQin,
                                isRestDay: vm.search.isRestDay
                            };
                        }
                    }
                })
                .result.then(function (res) {
                    var postDataSearch = angular.extend({}, vm.search);
                    postDataSearch.isRestDay = res.isRest;
                    postDataSearch.warehouseCode = vm.search.warehouse.selected.value;
                    var t = filterKaoQin(res.model.kaoQin)[0];
                    angular.forEach(newArr, function (v, i) {
                        v.categoryCode = res.isRest ? "" : t.value;
                        v.categoryName = res.isRest ? "" : t.text;
                        v.workingHours = res.isRest ? 0 : res.model.work;
                        v.overtime = res.isRest ? 0 : res.model.timeOut;
                        v.leave = res.isRest ? 0 : res.model.leave;
                    });
                    updateInSys(newArr, postDataSearch, arr);
                });
        };
        vm.removeTemp = function (index) {
            var item = vm.tempData[index];
            dalogModal.confirm({})
                .then(function (res) {
                    if (!res) { return; }
                    attendanceSvc
                        .deleteAttendanceAndInterimDetail({
                            staffAttendance: vm.search,
                            staffAttendanceDetailsInterim: item
                        })
                        .then(function (res) {
                            if (res.data) {
                                vm.tempData.splice(index, 1);
                                toastr.success("删除成功");
                            } else {
                                toastr.success("删除失败");
                            }
                        });
                });
        };

        vm.updateTemp = function (index, data, item) {
            vm.tempDisabled = false;
            attendanceSvc
                .updateAttendanceAndInterimDetail({
                    staffAttendance: vm.search,
                    staffAttendanceDetailsInterim: angular.extend(item, data)
                })
                .then(function (res) {
                    if (res.data) {
                        toastr.success("操作成功");
                    } else {
                        toastr.error("操作失败");
                    }
                })
                .catch(function () {
                    vm.tempData.splice(index, 1);
                });
        };

        vm.checkTempEmpty = function (data) {
            if (!data) return "*";
        };

        vm.tempDisabled = false;
        vm.addTemp = function () {
            vm.tempDisabled = true;
            $scope.inserted = {
                attendanceId: null,
                tEmployeeName: "",
                workingHours: null
            };
            vm.tempData.unshift($scope.inserted);
        };

        vm.cancelTemp = function (index, rowform) {
            rowform.$cancel();
            if (vm.tempDisabled) {
                vm.tempData.splice(index, 1);
            }
            vm.tempDisabled = false;
        };

        // vm.saveRowData = function(rowform) {
        //     rowform.$visible = false;
        //     console.log(rowform);
        // }; POST /api/services/app/attendance/GetAttendanceInfo

        vm.onTableRowSaved = function (data, itemKey, item) {
            var t = angular.extend({}, item);
            t[itemKey] = data;
            if (itemKey == "categoryCode") {
                var arr = filterKaoQin(data);
                if (arr.length) t.categoryName = arr[0].text;
            } else if (itemKey == "leave") {
                t.workingHours = 8 - t.leave;
            } else if (itemKey == "workingHours") {
                t.leave = 8 - t.workingHours;
            }
            updateInSys([t], vm.search, [item]);
        };

        // 初始化页面数据
        function reloadData() {
            apiRequest("inSysSearch", "rpData", 0);
            apiRequest("interimSearch", "tempData", 0);
            apiRequest("mainAttendanceSearch", "search");
        }

        function apiRequest(apiName, dataObjName, pageIndex) {
            var postData = {
                attendanceDate: vm.search.attendanceDate,
                warehouseCode: vm.search.warehouse.selected.value
            };
            if (!isNaN(pageIndex)) {
                postData.pageIndex = pageIndex;
                postData.maxResultCount = pageSize;
            }
            attendanceSvc
            [apiName](postData)
                .then(function (result) {
                    if (result.data.items) {
                        vm[dataObjName] = result.data.items;
                    } else {
                        // 因为查询时的参数包含期间，因此在返回结果中不需要该字段
                        delete result.data.attendanceDate;
                        delete result.data.warehouseCode;
                        angular.extend(vm[dataObjName], result.data);
                    }
                })
                .catch(function (res) { });
        }

        function filterKaoQin(code) {
            return $filter("filter")(vm.ddlKaoQin, { value: code });
        }

        function getSelectedDatas() {
            return $filter("filter")(vm.rpData, { checked: true });
        }

        function openDatepicker() {
            vm.datepicker.opened = true;
        }

        function initDropdown() {
            vm.selectWarehouseItems = warehouse;
            vm.onWarehouseSelected = function ($item, $model) {
                vm.search.warehouseCode = $model.value;
                reloadData();
            };
            vm.search.warehouse.selected = vm.selectWarehouseItems[0];
            vm.search.warehouseCode = vm.search.warehouse.selected.value;
        }

        // 更新在编
        function updateInSys(data, search, orderArr) {
            var postDataSearch = angular.extend({}, search);
            attendanceSvc
                .updateAttendanceAndDetail({
                    staffAttendance: postDataSearch,
                    staffAttendanceDetailsInSys: data
                })
                .then(function (res) {
                    if (res.data) {
                        toastr.success("修改成功！");
                        angular.forEach(orderArr, function (v, i) {
                            angular.extend(
                                v,
                                data.filter(function (item) {
                                    return item.employeeCode == v.employeeCode;
                                })[0]
                            );
                        });
                    } else {
                        toastr.error("修改失败！");
                    }
                })
                .catch(function () {
                    toastr.error("修改失败!");
                });
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

        reloadData();
    }
})();

(function() {
    "use strict";

    angular.module("A56.pages.dashboard").controller("DashboardCtrl", DashboardCtrl);

    DashboardCtrl.$inject = ["DefaultCtrlService", "content", "abp.services.app.kpiMonthlyIndicator"];

    /** @ngInject */
    function DashboardCtrl(ctrlSvc, content, apiSvc) {
        var vm = this;
        vm.onIncludeLoad = $.proxy(ctrlSvc.ctrl, vm, {
            reportName: content.reportName || "Total Order Shipped",
            decActual: content.decActual || "Dec Actual",
            reportFormula: content.reportFormula,
            yearDwopdown: {
                apiSvc: apiSvc.getYears
            },
            customersDwopdown: {
                apiSvc: apiSvc.getCustomers,
                labelKey: "customerName",
                valueKey: "id"
            },
            warehousesDwopdown: {
                apiSvc: apiSvc.getWarehouses,
                labelKey: "warehouseName",
                valueKey: "id"
            },
            lineChart: {
                apiSvc: apiSvc[content.lineChartApiSvcName || "getMonthlyIndicator"],
                // onApiCallback: function(result) {return result;},
                setApiSvcParams: function() {
                    return { statisticsID: content.statisticsID };
                },
                setBarCharDataProvider: function(result) {
                    var barChartData = [
                        {
                            name: "YTD",
                            sum: 0,
                            colorName: "danger"
                        },
                        {
                            name: "YOY",
                            sum: 0,
                            colorName: "warning"
                        }
                    ];
                    angular.forEach(result.data, function(v, i) {
                        barChartData[0].sum = barChartData[0].sum + v.preYearTotal;
                        barChartData[1].sum = barChartData[1].sum + v.curYearTotal;
                    });
                    barChartData[0].sum = barChartData[0].sum.toFixed(2);
                    barChartData[1].sum = barChartData[1].sum.toFixed(2);
                    return barChartData;
                },
                valueAxes: {
                    title: ""
                },
                graphs: [
                    {
                        title: "Pre Year",
                        valueField: "preYearTotal",
                        lineColorName: "danger"
                    },
                    {
                        title: "Quota",
                        valueField: "curYearQuota",
                        lineColorName: "success"
                    },
                    {
                        title: "Cur Year",
                        valueField: "curYearTotal",
                        lineColorName: "warning"
                    }
                ],
                categoryField: "month"
            },
            barChart: {
                apiSvc: content.barChartApiSvcName ? apiSvc[content.barChartApiSvcName] : undefined,
                onApiCallback: content.barChartApiSvcCallback
                    ? content.barChartApiSvcCallback
                    : function(result) {
                          return [
                              {
                                  name: "YTD",
                                  sum: result.preYearTotal,
                                  colorName: "danger"
                              },
                              {
                                  name: "Goal",
                                  sum: result.curYearQuota,
                                  colorName: "success"
                              },
                              {
                                  name: "YOY",
                                  sum: result.curYearTotal,
                                  colorName: "warning"
                              }
                          ];
                      },
                valueAxes: {},
                graphs: {
                    valueField: "sum"
                },
                categoryField: "name"
            },
            comments: content.comments || []
        });
    }
})();

(function() {
    "use strict";

    angular.module("A56.pages.dashboard").controller("PesCtrl", PesCtrl);

    PesCtrl.$inject = ["abp.services.app.attendance", "koaQin", "warehouse", "DownloadService"];

    /** @ngInject */
    function PesCtrl(attendanceSvc, koaQin, wh, DownloadSvc) {
        var vm = this,
            warehouse = wh.concat();

        vm.ddlKaoQin = koaQin.concat();
        vm.search = {
            attendanceDate: new Date(),
            warehouseCode: "",
            // isRestDay: false,
            headName: "",
            whManagerName: "",
            inSystemEmployeeNum: 0,
            warehouse: {
                selected: {}
            }
        };
        vm.datepicker = {
            open: openDatepicker,
            opened: false,
            format: "yyyy-MM",
            options: {
                showWeeks: false,
                minMode: "month"
            },
            dateChanged: function(e) {
                getData();
            }
        };
        vm.reportModel = {
            // 期间
            date: "",
            // 单位
            unitCode: "",
            // 编制
            empCount: null,
            // 负责人
            manager: "",
            // 报表数据主体结构
            reportData: []
        };

        vm.export = function() {
            attendanceSvc.export(vm.search).then(function(result) {
                DownloadSvc.download({
                    url: abp.appPath + "api/fileDownload/download",
                    data: result.data,
                    type: "application/vnd.ms-excel",
                    fileName: new Date().getTime() + ".xlsx"
                });
            });
        };

        initDropdown();

        // 重置报表数据
        function resetReportModelData() {
            vm.reportModel.reportData = [];
            initReportData("zaiBian", "在编", [
                { code: "renShu", codeName: "人数" },
                { code: "gongShi", codeName: "工时" },
                { code: "chaoShi", codeName: "超时" }
            ]);
            initReportData("linShi", "临时", [
                { code: "renShu", codeName: "人数" },
                { code: "gongShi", codeName: "工时" }
            ]);
            initReportData("whYeWu", "WH业务", [
                { code: "inHangShu", codeName: "入库行数" },
                { code: "inJianShu", codeName: "件数" },
                { code: "inDingDan", codeName: "订单" },
                { code: "inLiFang", codeName: "立方" },
                { code: "outHangShu", codeName: "出库行数" },
                { code: "outJianShu", codeName: "件数" },
                { code: "outDingDan", codeName: "订单" },
                { code: "outLiFang", codeName: "立方" }
            ]);
            initReportData("T&D业务", "T&D业务", [
                { code: "piaoShu", codeName: "票数" },
                { code: "jianShu", codeName: "件数" },
                { code: "liFang", codeName: "立方" },
                { code: "gongJin", codeName: "公斤" }
            ]);
            var k = 1,
                maxDay = getLastDayOfMonth();
            vm.reportModel.manages = [];
            for (k; k <= maxDay; k++) {
                vm.reportModel.manages.push({
                    day: k,
                    value: null
                });
            }
        }

        function initReportData(groupCode, groupCodeName, codes) {
            var maxDay = getLastDayOfMonth(),
                i = 1,
                dayValues = [],
                rowCount = codes.length;
            for (i; i <= maxDay; i++) {
                dayValues.push({
                    day: i,
                    value: null
                });
            }
            angular.forEach(codes, function(v, i) {
                vm.reportModel.reportData.push({
                    rowCount: rowCount,
                    // 分组类型编码
                    groupCode: groupCode,
                    groupCodeName: groupCodeName,
                    // 统计类型编码【人数，工时，超时...】
                    code: v.code,
                    codeName: v.codeName,
                    // 累计
                    total: null,
                    // 报表数据
                    dayValues: dayValues.map(function(item) {
                        return { day: item.day, value: item.value };
                    })
                });
            });
        }

        function openDatepicker() {
            vm.datepicker.opened = true;
        }

        function initDropdown() {
            vm.selectWarehouseItems = warehouse;
            vm.onWarehouseSelected = function($item, $model) {
                getData();
            };

            vm.search.warehouse.selected = vm.selectWarehouseItems[0];
            vm.search.warehouseCode = vm.search.warehouse.selected.value;
        }

        function getData() {
            vm.search.warehouseCode = vm.search.warehouse.selected.value;
            attendanceSvc
                .productionEfficiency(vm.search)
                .then(function(result) {
                    resetReportModelData();
                    vm.reportModel.empCount = result.data.empCount;
                    vm.reportModel.manager = result.data.manager;
                    if (!result.data) {
                        return;
                    }
                    convertData(result.data);
                })
                .catch(function() {
                    resetReportModelData();
                });
        }

        // 获取当月最后一天
        function getLastDayOfMonth() {
            return new Date(
                new Date(
                    vm.search.attendanceDate.getFullYear(),
                    vm.search.attendanceDate.getMonth() + 1,
                    1
                ).getTime() -
                    1000 * 60 * 60 * 21
            ).getDate();
        }

        function convertData(apiRes) {
            var i = 0,
                j = 0,
                mValue = "",
                len = vm.reportModel.reportData.length,
                dayValue;
            if (!!apiRes.reportData && apiRes.reportData.length) {
                var apiItem, t, dayValueItem;
                for (i; i < len; i++) {
                    apiItem = apiRes.reportData[i];
                    t = vm.reportModel.reportData.filter(function(v) {
                        return v.groupCode == apiItem.groupCode && v.code == apiItem.code;
                    });
                    if (!!!t || !t.length) {
                        continue;
                    }
                    t[0].total = apiItem.total || null;
                    j = 0;
                    for (j; j < t[0].dayValues.length; j++) {
                        dayValueItem = t[0].dayValues[j];
                        dayValue = apiItem.dayValues.filter(function(v) {
                            return v.day == dayValueItem.day;
                        });
                        if (!dayValue || !dayValue.length) continue;
                        dayValueItem.value = dayValue[0].value;
                    }
                }
            }

            if (!!apiRes.manages && apiRes.manages.length) {
                angular.forEach(apiRes.manages, function(v, i) {
                    mValue = vm.reportModel.manages.filter(function(item) {
                        return item.day == v.day;
                    });
                    if (mValue.length) {
                        mValue[0].value = v.value || null;
                    }
                });
            }
        }

        getData();
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.dashboard")
        .controller("TmsKpiCtrl", TmsKpiCtrl)
        .filter("rowTypeBind", ['$filter', function ($filter) {
            return function (o, rowType) {
                if (!o && o !== 0) return '';
                if (rowType == 0) {
                    return o;
                }
                if (rowType == 1) {
                    return $filter('number')(o, 2);
                }
                if (rowType == 2) {
                    return $filter('number')(o, 2) + '%';
                }
            }
        }]);

    TmsKpiCtrl.$inject = ["abp.services.app.kpiMonthlyIndicator"];

    /** @ngInject */
    function TmsKpiCtrl(tmsAppSvc) {
        var vm = this;
        vm.search = {};
        vm.datepicker = {
            open: openDatepicker,
            opened: false,
            format: "yyyy-MM",
            options: {
                showWeeks: false,
                minMode: "month"
            },
            dateChanged: function (e) {
                getData();
            }
        };

        vm.reportModel = { reportData: [] };

        initDropdown();
        initDatepicker();

        function openDatepicker() {
            vm.datepicker.opened = true;
        }

        function initDropdown() {
            vm.dropdonw = {
                project: {
                    isMultiple: true
                }
            };

            init.call(vm.dropdonw.project, "projectIds", "getTmsProjects", "projectId");

            function init(searchKey, apiName, key) {
                var that = this;
                key = key || 'id';
                if (!apiName) {
                    that.selectItems = [];
                } else {
                    tmsAppSvc[apiName]({}).then(function (result) {
                        if (!result || !result.data || !result.data.length) return;
                        that.selectItems = result.data;
                        that.selected = [].concat(that.selectItems).filter(function (item) {
                            return item && item[key];
                        });
                        selectedChange();
                    });
                }

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        clearSelect();
                    }
                });

                function selectedChange($item, $model) {
                    if (that.isMultiple && angular.isArray(that.selected)) {
                        vm.search[searchKey] = that.selected && that.selected.length ?
                            that.selected.map(function (item) { return item[key]; }) :
                            undefined;
                    } else {
                        vm.search[searchKey] = that.selected ? that.selected[key] : undefined;
                    }
                    getData();
                }
                function clearSelect() {
                    vm.search[searchKey] = that.selected ? that.selected[key] : undefined;
                    getData();
                }
            }
        }

        function initDatepicker() {
            vm.datepicker = {
                from: {}
            };

            init.call(vm.datepicker.from);
            vm.datepicker.from.model = new Date();
            // 获取当月第一天
            vm.search.beginDate = new Date(vm.datepicker.from.model.getFullYear(), vm.datepicker.from.model.getMonth(), 1);
            // 获取当月最后一天
            vm.search.endDate = new Date(vm.datepicker.from.model.getFullYear(), vm.datepicker.from.model.getMonth() + 1, 0);

            function init() {
                var that = this;
                angular.extend(that, {
                    model: undefined,
                    opened: false,
                    open: function () {
                        that.opened = !that.opened;
                    },
                    format: "yyyy-MM",
                    options: {
                        showWeeks: false,
                        minMode: "month"
                    },
                    dateChanged: function () {
                        // 获取当月第一天
                        vm.search.beginDate = new Date(that.model.getFullYear(), that.model.getMonth(), 1);
                        // 获取当月最后一天
                        vm.search.endDate = new Date(that.model.getFullYear(), that.model.getMonth() + 1, 0);
                        getData();
                    },
                    clear: function () {
                        vm.search.beginDate = vm.search.endDate = that.model = undefined;
                        getData();
                    }
                });
            }
        }

        function getData() {
            if (!vm.search.projectIds || !vm.search.beginDate) return;
            tmsAppSvc.getTmsKpi(vm.search)
                .then(function (result) {
                    vm.reportModel.reportData = result.data;
                });
        }
    }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
    "use strict";

    angular
        .module("A56.pages.settings.treeService", [])
        .config(function () {
            $.jstree.defaults.core.themes.url = true;
            $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
        })
        .service("settingsTreeService", settingsTree);

    settingsTree.$inject = ["$uibModal", "toastr", "$timeout", "$q", 'dalogModal'];

    /** @ngInject */
    function settingsTree($uibModal, toastr, $timeout, $q, dalogModal) {
        this.init = function ($scope, params) {
            abp.ui.block();
            var vm = this,
                newId = 0,
                isOnload = true,
                cnaMoveNode = true;

            var deferGetData = $q.defer(),
                deferTreeReady = $q.defer();
            $q.all([deferGetData.promise, deferTreeReady.promise]).then(setDefaultSelected);

            // 添加新节点时的禁用状态
            vm.btnNewDisabled = false;
            vm.disabeldAddBtn = false;
            vm.myForm = "myForm";
            vm.model = {};
            $scope.basicTree = {};
            $scope.ignoreChanges = false;
            $scope.newNode = {};

            $scope.basicConfig = {
                core: {
                    multiple: false,
                    worker: true,
                    // check_callback: true,
                    check_callback: function (operation, node, node_parent, node_position, more) {
                        if (operation == "delete_node") return true;
                        return cnaMoveNode;
                    },
                    themes: {
                        responsive: false,
                        // 背景显示间纹
                        stripes: true
                    }
                },
                types: {
                    folder: {
                        icon: "ion-ios-folder"
                    },
                    default: {
                        icon: "ion-document-text"
                    }
                },
                plugins: ["dnd", "types"], //,"contextmenu" 支持鼠标右键
                version: 1
            };

            $scope.deselectAll = function () {
                vm.model = {};
                vm.myForm.$setPristine();
                $scope.basicTree.jstree(true).deselect_all();
                vm.disabeldAddBtn = false;
                if (params.on) {
                    params.on("deselect_all");
                }
            };

            $scope.addNewNode = function () {
                cnaMoveNode = false;
                vm.btnNewDisabled = $scope.ignoreChanges = true;
                vm.myForm.$setPristine();
                var selected = this.basicTree.jstree(true).get_selected()[0];
                vm.model = {
                    id: newId++,
                    parent: selected || "#",
                    type: !!selected ? undefined : "folder",
                    text: "",
                    code: "",
                    comment: "",
                    level: undefined,
                    processFlag: true,
                    state: {
                        opened: true,
                        selected: true
                    }
                };
                angular.extend(vm.model, params.newDataModel || {});
                $scope.treeData.push(vm.model);
                $scope.basicConfig.version++;
                if (params.on) {
                    params.on("create_node", vm.model);
                }
                // this.basicTree.jstree(true).create_node(selected || "#", vm.model, "last", false, true);
            };

            $scope.deleteNode = function () {
                $scope.ignoreChanges = true;
                var selected = this.basicTree.jstree(true).get_selected()[0];
                if (!selected) {
                    return;
                }
                var item = $scope.treeData.filter(function (item) {
                    return item.id == selected;
                })[0];
                dalogModal
                    .confirm({
                        context: (item.text || "") + ",以及子节点"
                    }).then(function (res) {
                        if (!res) {
                            return;
                        }
                        // deleteChild(item);
                        params.settingsSve[params.deleteNode](item).then($scope.refresh);
                        if (params.on) {
                            params.on("delete_node", item);
                        }
                    });
            };

            $scope.refresh = getData;

            $scope.expand = function () {
                $scope.ignoreChanges = true;
                $scope.treeData.forEach(function (n) {
                    n.state.opened = true;
                });
                $scope.basicConfig.version++;
                onTreeReady();
                if (params.on) {
                    params.on("expand");
                }
            };

            $scope.collapse = function () {
                $scope.ignoreChanges = true;
                $scope.treeData.forEach(function (n) {
                    n.state.opened = false;
                });
                $scope.basicConfig.version++;
                onTreeReady();
                if (params.on) {
                    params.on("collapse");
                }
            };

            $scope.treeEventsObj = {
                ready: readyCB,
                select_node: selectNodeCB,
                move_node: moveNodeCB
                // deselect_node: deselectNodeCB,
            };

            // 保存树节点调整的更改
            vm.saveTree = function () {
                abp.ui.block();
                // processSubjectList
                var postData = $scope.treeData.map(function (item) {
                    item.name = item.text;
                    item.parentId = item.parent == "#" ? null : item.parent;
                    return item;
                });
                params.settingsSve
                [params.batchSave](postData)
                    .then(function (result) {
                        toastr.success("保存成功！");
                        $scope.refresh();
                        if (params.on) {
                            params.on("saveTree", $scope.treeData);
                        }
                    })
                    .catch(function () {
                        toastr.error("保存失败");
                        abp.ui.unblock();
                    });
            };

            // 新增或修改单个节点
            vm.saveTreeNode = function () {
                abp.ui.block();
                if (vm.myForm) {
                    vm.myForm.$setSubmitted(true);
                    if (!vm.myForm.$valid) {
                        toastr.warning("请完善必填信息");
                        abp.ui.unblock();
                        return;
                    }
                }
                if (!vm.model.id) {
                    angular.extend(vm.model, {
                        id: newId++,
                        parentId: null,
                        name: vm.model.text,
                        level: 1,
                        processFlag: true
                    });
                } else {
                    var treeNode = $scope.basicTree.jstree(true).get_node(vm.model);
                    vm.model.level = treeNode.parents.length || 1;
                    vm.model.parent = treeNode.parent;
                    vm.model.state = treeNode.state;
                    vm.model.position = treeNode.position;
                    vm.model.name = vm.model.text;
                    vm.model.parentId = vm.model.parent == "#" ? null : vm.model.parent;
                }
                // processSubject
                params.settingsSve
                [params.singleSave](vm.model)
                    .then(function (result) {
                        toastr.success("保存成功！");
                        $scope.refresh(vm.model);
                        if (params.on) {
                            params.on("saveTreeNode", vm.model);
                        }
                    })
                    .catch(function (result) {
                        toastr.error("保存失败");
                        abp.ui.unblock();
                    });
            };

            function readyCB() {
                $scope.basicTree = this.basicTree;
                $timeout(function () {
                    $scope.ignoreChanges = false;
                    deferTreeReady.resolve("treeReady");
                });
                if (params.on) {
                    params.on("ready");
                }
            }

            function checkMoveChildNode(node, maxlevel) {
                if (!maxlevel) return true;
                var i = 0,
                    len = node.children.length,
                    cNode;
                if (!len) return true;
                for (i; i < len; i++) {
                    cNode = $scope.basicTree.jstree(true).get_node(node.children[i]);
                    if (cNode.parents.length > maxlevel) return false;
                    checkMoveChildNode(cNode, maxlevel);
                }
                return true;
            }
            function moveNodeCB(e, node) {
                $scope.ignoreChanges = true;
                if (node.node.original.isBack) {
                    // 如果是标识为返回原处节点的移动，则退出递归
                    node.node.original.isBack = undefined;
                    return;
                }
                var canMove = false;
                // maxlevel 为 0 则不限制层级数量
                // 1、验证要去到的父节点是否可以是否可以添加子节点
                if (!params.maxlevel || node.node.parents.length <= params.maxlevel) {
                    canMove = true;
                }
                // 2、验证当前移动的节点所包含的子节点是否超出了最大层级限制
                if (canMove) {
                    canMove = checkMoveChildNode(node.node, params.maxlevel);
                }
                if (canMove) {
                    var dataNode = $scope.treeData.filter(function (item) {
                        return item.id == node.node.id;
                    })[0];
                    dataNode.parent = node.node.parent;
                    dataNode.level = node.node.parents.length || 1;
                    dataNode.position = node.position;
                    $scope.basicTree
                        .jstree(true)
                        .set_icon(
                            node.node,
                            dataNode.level == 1
                                ? $scope.basicConfig.types.folder.icon
                                : $scope.basicConfig.types.default.icon
                        );
                    if (params.on) {
                        params.on("move_node", node.node);
                    }
                    return;
                }
                // 如果是移动到了子节点上，将该节点返回原处
                // isBack 标记为返回原处标识，否则会出现死循环(如果科目上要求最多两级节点,二级节点下不允许有子节点
                // 但由于初始化数据出现问题产生了三级节点时，把三级节点拖动到二级节点时会形成死循环)
                node.node.original.isBack = true;
                $scope.basicTree
                    .jstree(true)
                    .move_node(node.node, { id: node.old_parent }, node.old_position);
            }

            //TODO: 取消选中事为什么没有触发呢？？？
            function deselectNodeCB(nodes, selected, e) {
                if (selected && selected.selected.length) {
                    var unSelected = $scope.treeData.filter(function (item) {
                        return (
                            (!item.text || item.text == "&nbsp;") &&
                            !item.code &&
                            item.processFlag &&
                            item.id != selected.selected[0]
                        );
                    });
                    unSelected.forEach(deleteChild);
                    vm.btnNewDisabled = false;
                    cnaMoveNode = true;
                }
            }

            function selectNodeCB(nodes, selected, e) {
                // 取消选中事件检查
                deselectNodeCB(nodes, selected, e);
                var t = this.basicTree.jstree(true).get_node({ id: selected.selected[0] });
                angular.extend(vm.model, t.original);
                vm.myForm.$setPristine();
                // 检查是否选择的是子节点，如果是子节点，则禁用【添加按钮】
                vm.disabeldAddBtn = t.parents.length > 1;
                if (params.on) {
                    params.on("select_node", t.original);
                }
            }

            function deleteChild(c) {
                var arr = $scope.treeData.filter(function (t) {
                    return t.parent == c.id;
                });
                if (arr.length) {
                    arr.forEach(deleteChild);
                }
                $scope.treeData.splice($scope.treeData.indexOf(c), 1);
                $scope.basicTree.jstree(true).delete_node({ id: c.id });
            }

            $scope.applyModelChanges = function () {
                return !$scope.ignoreChanges;
            };

            $scope.refresh();

            function getData(selectNode) {
                abp.ui.block();
                $scope.ignoreChanges = true;
                // getDepartmentTree
                $scope.treeData = params.settingsSve[params.get]({}).then(function (result) {
                    $scope.treeData = result.data.map(function (item) {
                        // 获取最大的Id
                        newId = newId < item.id ? item.id : newId;
                        return params.dataMap(item);
                    });
                    newId = newId * 100;
                    $scope.basicConfig.version++;
                    if (isOnload) {
                        deferGetData.resolve("getData");
                    } else {
                        onTreeReady(selectNode);
                    }
                    if (params.on) {
                        params.on("getData", $scope.treeData);
                    }
                    abp.ui.unblock();
                });
            }

            function onTreeReady(selectNode) {
                deferTreeReady = $q.defer();
                deferTreeReady.promise.then(function () {
                    setDefaultSelected(selectNode);
                });
            }

            function setDefaultSelected(selectNode) {
                if (isOnload) isOnload = false;
                var s = $scope.basicTree.jstree(true).get_json()[0];
                if (selectNode && selectNode.code) {
                    s = {
                        id: $scope.treeData.filter(function (item) {
                            return item.code == selectNode.code;
                        })[0].id
                    };
                }
                $scope.basicTree.jstree(true).select_node(s, true);
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settleAccount").service("PanelAndReportService", PanelAndReportService);

    /** @ngInject */
    function PanelAndReportService() {

        this.apply = function (customerCtrl, departmentCtrl, subjectCtrl, customerTempUrl, departmentTempUrl, subjectTempUrl) {
            var vm = this;
            vm.DropdownPlaceholderConst = {
                customer: '客户',
                department: '部门',
                subject: '科目'
            };
            vm.dropdownPlaceholder = vm.DropdownPlaceholderConst.department;

            initDropdown();

            function initDropdown() {
                vm.panelDropdown = {};

                init.call(vm.panelDropdown);

                function init() {
                    var that = this;
                    that.selectItems = [
                        { id: 1, name: vm.DropdownPlaceholderConst.department, code: 'department', templateUrl: departmentTempUrl },
                        { id: 2, name: vm.DropdownPlaceholderConst.customer, code: 'customer', templateUrl: customerTempUrl },
                        { id: 3, name: vm.DropdownPlaceholderConst.subject, code: 'subject', templateUrl: subjectTempUrl }
                    ];

                    angular.extend(that, { onSelected: selectedChange });
                    function selectedChange($item, $model) {
                        resetDropdown($item);
                    }
                    that.selected = that.selectItems[0];
                    selectedChange(that.selected, that.selected);
                }
            }

            function resetDropdown(item) {
                switch (item.id) {
                    case 1:
                        vm.dropdownPlaceholder = vm.DropdownPlaceholderConst.department;
                        departmentCtrl.apply.call(vm);
                        break;
                    case 2:
                        vm.dropdownPlaceholder = vm.DropdownPlaceholderConst.customer;
                        customerCtrl.apply.call(vm);
                        break;
                    case 3:
                        vm.dropdownPlaceholder = vm.DropdownPlaceholderConst.subject;
                        subjectCtrl.apply.call(vm);
                        break;
                }
            }
        };
    }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function() {
    "use strict";

    angular
        .module("A56.theme")
        .constant("koaQin", [
            { value: "", text: "休息" },
            { value: "Attendance", text: "出勤" },
            { value: "CompassionateLeave", text: "事假" },
            { value: "SickLeave", text: "病假" },
            { value: "MarriageHoliday", text: "婚假" },
            { value: "FuneralLeave", text: "丧假" },
            { value: "MaternityLeave", text: "产假" },
            { value: "AnnualLeave", text: "年假" },
            { value: "TrainingLeave", text: "培训假" },
            { value: "EmployeeLeave", text: "调休" }
        ]);
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function() {
    "use strict";

    angular
        .module("A56.theme")
        .constant("warehouse", [
            { label: "上海合庆CMC仓库", value: "SH001" },
            { label: "上海合庆CTC仓库", value: "HEQ" },
            { label: "上海梅陇库", value: "SHA" },
            { label: "北京仓库", value: "PEK" }
        ]);
})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('A56.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
    'use strict';

    angular.module('A56.theme')
        .directive('inputNumber', inputNumber);

    /** @ngInject */
    function inputNumber() {
        return {
            restrict: 'C',
            template: function (elem, attrs) {
                // input type="number" 禁用鼠标滚轮事件
                elem.attr('onmousewheel', "return false");
                // Firefox浏览器禁用鼠标滚轮事件
                elem[0].addEventListener('DOMMouseScroll', MouseWheel, false);
                function MouseWheel(event) {
                    event = event || window.event;
                    event.preventDefault();
                }
            }
        };
    }

})();
/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('A56.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
/**
 * Animated load block
 */
(function () {
    'use strict';

    angular.module('A56.theme')
        .directive('regionPicker', [regionPicker]);
    // .controller('regionFormGroupCtrl', ['$scope', '$timeout', regionFormGroupCtrl])
    // .directive('regionFormGroup', regionFormGroup);

    /** @ngInject */
    function regionPicker() {
        return {
            restrict: 'CEA',
            require: '?^ngModel',
            template: '<div class="city-picker-container" ng-disabled="setting.readonly">\
                <input class="form-control" type="text" data-toggle="city-picker" placeholder="{{setting.placeholder}}" />\
                <span class="picker-icon" ng-click="setting.picker(\'reset\')"><i class="ion-close-round"></i></span>\
            </div>',
            scope: {
                setting: '=?'
            },
            link: function ($scope, elem, attr, ngModelCtrl) {
                var picker = elem.find('input');
                var rendered = false;
                var inputObj = picker[0];

                $scope.setting = $scope.setting || {};
                if ($scope.setting.readonly) {
                    elem.css({ 'pointer-events': 'none', 'cursor': 'not-allowed' });
                }

                if (!!ngModelCtrl) {
                    var baseRender = ngModelCtrl.$render;
                    // 1、将 $modelValue 转变成 $viewValue
                    ngModelCtrl.$formatters.push(function (modelValue) {
                        if (rendered && !ngModelCtrl.$dirty && ngModelCtrl.$isEmpty(modelValue)) {
                            ngModelCtrl.$setDirty();
                        }

                        if (!ngModelCtrl.$isEmpty(modelValue)) {
                            if ($.isNumeric(modelValue)) {
                                setViewValueWithCode(modelValue);
                                return modelValue;
                            }
                            var result = $scope.setting.getSelected();
                            setViewValueWithStr(modelValue);
                            var arr = result.arrayCode;
                            if (arr.length) {
                                ngModelCtrl.$modelValue = arr[arr.length - 1];
                            }
                            return modelValue;
                        }
                        $scope.setting.picker('reset');
                        return modelValue;
                    });

                    // 2、将 $viewValue 渲染到指令模板中去。
                    ngModelCtrl.$render = function () {
                        rendered = true;
                        baseRender();
                    };

                    // 3、当 ng-Model 变更时，将 $viewValue 转变成 $modelValue
                    ngModelCtrl.$parsers.push(function (viewValue) {
                        selectedChange($scope.setting.getSelected());
                        if (!ngModelCtrl.$isEmpty(viewValue)) {
                            var arr = $scope.setting.picker('getCode').split(/,|\//);
                            return arr[arr.length - 1];
                        }
                        return viewValue;
                    });

                    Object.defineProperty(inputObj, 'value', {
                        set: function (val) {
                            ngModelCtrl.$viewValue = val;
                            if (rendered) {
                                ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue);
                            }
                            inputObj.setAttribute('value', ngModelCtrl.$viewValue);
                            return ngModelCtrl.$viewValue;
                        },
                        get: function () {
                            return ngModelCtrl.$viewValue || undefined;
                        }
                    });
                }
                var defaultSetting = {
                    simple: false,
                    placeholder: !!attr.placeholder ? attr.placeholder : '省/市/区',
                    level: 'district'
                };

                $scope.setting = $scope.setting || {};
                angular.extend($scope.setting, defaultSetting);

                /**
                 * 获取当前选择的省市区
                 */
                $scope.setting.getSelected = function () {
                    var code = $scope.setting.picker('getCode');
                    var codeArr = code.split(/,|\//);
                    var codeLen = codeArr.length;

                    var val = $scope.setting.picker('getVal');
                    var valArr = val.split(/,|\//);
                    var valLen = valArr.length;

                    return {
                        arrayCode: codeArr,
                        code: code,
                        provinceCode: codeLen >= 1 ? codeArr[0] || '' : '',
                        cityCode: codeLen >= 2 ? codeArr[1] || '' : '',
                        districtCode: codeLen == 3 ? codeArr[2] || '' : '',
                        arrayText: valArr,
                        text: val,
                        provinceText: valLen >= 1 ? valArr[0] || '' : '',
                        cityText: valLen >= 2 ? valArr[1] || '' : '',
                        districtText: valLen == 3 ? valArr[2] || '' : '',
                    };
                };

                // 绑定 city-Picker 的内置函数
                $scope.setting.picker = function (fnName) {
                    var t = picker.data('citypicker')[fnName];
                    if (angular.isFunction(t)) {
                        var args = [].slice.call(arguments, 1);
                        return t.apply(picker.data('citypicker'), args);
                    }
                    return t;
                };

                picker.citypicker($scope.setting);

                function selectedChange(result) {
                    if ($scope.setting.onSelectChange) {
                        $scope.setting.onSelectChange($scope.setting.picker, result);
                    }
                }

                /**
                 * 根据行政区编码设置 view 文本
                 * @param {number} codeNo 
                 */
                function setViewValueWithCode(codeNo) {
                    var code = codeNo + '';
                    if ($.isNumeric(code) && code.length != 6) {
                        return;
                    }

                    var pCode = code.substr(0, 2),
                        cCode = code.substr(2, 2),
                        dCode = code.substr(4, 2),
                        province = '',
                        city = '',
                        district = '',
                        p, c, d;

                    if (dCode != '00') {
                        p = pCode + '0000';
                        c = pCode + cCode + '00';
                        d = codeNo;
                        city = ChineseDistricts[p][c];
                        district = ChineseDistricts[c][d];
                        province = getProvinceNameByCode(p);
                    } else if (cCode != '00') {
                        p = pCode + '0000';
                        c = pCode + cCode + '00';
                        city = ChineseDistricts[p][c];
                        province = getProvinceNameByCode(p);
                    } else {
                        p = pCode + '0000';
                        province = getProvinceNameByCode(p);
                    }

                    $scope.setting.picker('reset');
                    angular.extend(picker.data('citypicker').options, {
                        province: province,
                        city: city,
                        district: district
                    });
                    $scope.setting.picker('refresh');
                }

                /**
                 * 根据 Province Code 获取 Province Text
                 * @param {number} provinceCode 
                 */
                function getProvinceNameByCode(provinceCode) {
                    var data = ChineseDistricts['86'],
                        cData, ccData;
                    for (var i in data) {
                        cData = data[i];
                        for (var j in cData) {
                            ccData = cData[j];
                            if (ccData.code == provinceCode) {
                                return ccData.address;
                            }
                        }
                    }
                    return '';
                }

                /**
                 * 根据 string 值设置 view 文本
                 * @param {number} codeNo 
                 */
                function setViewValueWithStr(strVal) {
                    var arr = strVal.split(/,|\//);
                    var len = arr.length;
                    $scope.setting.picker('reset');
                    angular.extend(picker.data('citypicker').options, {
                        province: len >= 1 ? arr[0] || '' : '',
                        city: len >= 2 ? arr[1] || '' : '',
                        district: len == 3 ? arr[2] || '' : '',
                    });
                    $scope.setting.picker('refresh');
                }
            }
        };
    }


    // var template =
    //     '<div class="form-group text-left">\
    //         <label ng-if="regionLabel !== undefined" for="{{id}}">{{regionLabel}}&nbsp;</label>\
    //         <region-picker \
    //             id="{{id}}" name="{{id}}" ng-model="regionModel" \
    //             placeholder="{{regionPlaceholder}}" ng-required="regionRequired" \
    //             ng-disabled="regionDisabled" setting="regionSeting" \
    //             ng-class="{\'has-error\': regionForm[id].$invalid && (regionForm[id].$dirty || regionForm.$submitted)}">\
    //         </region-picker>\
    //     </div>';

    // function regionFormGroupCtrl($scope, $timeout) {
    //     if (!$scope.regionSeting) {
    //         $scope.regionSeting = {};
    //     }
    //     $scope.regionSeting.readonly = $scope.regionDisabled;
    //     $scope.regionSeting.onSelectChange = function (instance, result) {
    //         $scope.regionProvince = result.provinceCode;
    //         $scope.regionCity = result.cityCode;
    //         $scope.regiondistrict = result.districtCode;
    //         if ($scope.regionSeting.onChange) {
    //             $timeout(function () {
    //                 // region 插件不是 Angular 插件，因此需要用 $timeout
    //                 $scope.regionSeting.onChange()(instance, result);
    //             });
    //         }
    //     };
    // }

    // /** @ngInject */
    // function regionFormGroup() {
    //     return {
    //         restrict: 'E',
    //         replace: true,
    //         scope: {
    //             regionModel: '=',
    //             // 绑定当前选择的【省】
    //             regionProvince: '=?',
    //             // 绑定当前选择的【市】
    //             regionCity: '=?',
    //             // 绑定当前选择的【区】
    //             regiondistrict: '=?',
    //             regionLabel: '@',
    //             regionPlaceholder: '@',
    //             regionForm: '=?',
    //             regionDisabled: '=?',
    //             regionRequired: '=?',
    //             regionSeting: '=?',
    //             regionOnChange: '&?'
    //         },
    //         // templateUrl: 'app/theme/components/regionFormGroup/regionFormGroup.html',
    //         template: template,
    //         controller: 'regionFormGroupCtrl',
    //         link: function (scope, element, attrs, ngModelCtrl) {
    //             scope.id = attrs.regionModel.replace(/\./ig, '_');
    //             if (scope.regionOnChange) {
    //                 scope.regionSeting.onChange = scope.regionOnChange;
    //             }
    //         }
    //     };
    // }
})();
(function() {
    "use strict";

    angular.module("A56.theme").directive("repeatFinish", repeatFinish);

    function repeatFinish() {
        return {
            restrict: "A",
            scope: {
                repeatFinishParent: "=?",
                repeatFinishOnRepeat: "=?"
            },
            link: function(scope, elem, attr) {
                if (scope.repeatFinishOnRepeat) {
                    scope.repeatFinishOnRepeat(scope.repeatFinishParent.$last);
                }
            }
        };
    }
})();

(function () {
  'use strict';

  angular.module('A56.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('A56.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
(function() {
    angular.module("A56.theme").factory("appSession", [
        "abp.services.app.session",
        function(sessionSvc) {
            var _session = {
                user: null,
                tenant: null
            };
            sessionSvc.getCurrentLoginInformations({ async: false }).then(function(result) {
                angular.extend(_session, result.data);
            });
            return _session;
        }
    ]);
})();

(function() {
    "use strict";

    angular
        .module("A56.theme")
        .factory("httpInterceptor", ["$rootScope", "$q", "$injector", httpInterceptorFn]);

    /** @ngInject */
    function httpInterceptorFn($rootScope, $q, $injector) {
        var requestCount = 0;

        function isApi(url) {
            var p = /^(\.)?\/be\/api(\/services\/app\/|\/file\/)\w{1,}/gi;
            return p.test(url);
        }

        function closeLoading(url) {
            if (isApi(url)) {
                requestCount--;
                // 当所有请求完成后关闭 loading
                if (requestCount == 0) {
                    abp.ui.unblock(".page-content");
                }
            }
        }

        var httpInterceptor = {
            responseError: function(response) {
                var toastr = $injector.get("toastr");
                switch (response.status) {
                    case 400:
                        // 表单验证失败
                        if (
                            response.data &&
                            response.data.validationErrors &&
                            response.data.validationErrors.length
                        ) {
                            response.data.validationErrors.forEach(function(item) {
                                toastr.error(item.message || "提交失败，缺少必要的信息!");
                            });
                        } else {
                            toastr.error("提交失败，缺少必要的信息!");
                        }
                        break;
                    case 404:
                    // toastr.error("找不到页面");
                    // break;
                    case 403:
                    // toastr.error("没有权限");
                    // break;
                    case 500:
                        var msg = "请求失败";
                        if (response.data && response.data.message) {
                            msg = response.data.message;
                        }
                        toastr.error(msg);
                        break;
                }
                var url = !!response.config ? response.config.url || "" : "";
                closeLoading(url);
                return $q.reject(response);
            },
            response: function(response) {
                var url = !!response.config ? response.config.url || "" : "";
                closeLoading(url);
                return response;
            },
            request: function(config) {
                if (!isApi(config.url)) return config;
                if (requestCount == 0) {
                    abp.ui.block(".page-content");
                }
                requestCount++;
                return config;
            },
            requestError: function(config) {
                closeLoading(config.url);
                return $q.reject(config);
            }
        };
        return httpInterceptor;
    }
})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
    "use strict";

    angular
        .module("A56.theme")
        .filter("a56Enum", a56Enum);

    /** @ngInject */
    function a56Enum() {
        return function (val, mEnum, keyName, textName) {
            if (angular.isArray(mEnum)) {
                var arr = mEnum.filter(function (i) {
                    return i[keyName] == val;
                });
                return arr.length ? arr[0][textName] : '';
            }
            return '';
        };
    }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function() {
    "use strict";

    angular.module("A56.theme").provider("AbpScriptsInitialized", function() {
        this.$get = function() {
            return {
                scriptsInitialized: function() {
                    var promise = new Promise(function(resolve) {
                        if (abp.nav && abp.nav.menus) {
                            resolve();
                        } else {
                            abp.event.on("abp.dynamicScriptsInitialized", function() {
                                resolve();
                            });
                        }
                    });
                    return promise;
                }
            };
        };
    });
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function() {
    "use strict";

    angular.module("A56.theme").service("backendMapping", backendMapping);

    /** @ngInject */
    function backendMapping() {
        this.warehouse = function(item) {
            return {
                code: item.code,
                name: item.name,
                id: item.id
            };
        };
        this.project = function(item) {
            return {
                code: item.code,
                name: item.name,
                id: item.id
            };
        };
        this.customer = function(item) {
            return {
                code: item.code,
                name: item.name,
                id: item.id
            };
        };
    }
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('A56.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
    "use strict";

    angular.module("A56.theme").service("dalogModal", dalogModal);

    dalogModal.$inject = ["$uibModal"];

    /** @ngInject */
    function dalogModal($uibModal) {
        this.open = function (conf) {
            var instence = $uibModal.open({
                animation: true,
                backdrop: conf.backdrop || 'static',
                templateUrl: conf.templateUrl, //"app/pages/users/modal.html",
                controller: conf.ctrlName,
                controllerAs: "vm",
                size: conf.size || "md",
                resolve: {
                    context: function () {
                        return conf.context;
                    }
                }
            });

            if (conf.callback) {
                instence.result.then(conf.callback);
            }
            return instence;
        };

        this.confirm = function (context) {
            return $uibModal
                .open({
                    animation: true,
                    templateUrl: "app/templates/modal.confirm.html",
                    controller: [
                        "$uibModalInstance",
                        "context",
                        function ($uibModalInstance, data) {
                            var ctrl = this;
                            ctrl.theme = data.theme || 'bg-danger';
                            ctrl.title = data.title || '删除';
                            ctrl.optionName = data.optionName || '是否删除';
                            ctrl.context = data.context;

                            ctrl.cancel = function () {
                                $uibModalInstance.close(false);
                            };
                            ctrl.ok = function () {
                                $uibModalInstance.close(true);
                            };
                        }
                    ],
                    controllerAs: "vm",
                    size: "md",
                    resolve: {
                        context: function () {
                            return context;
                        }
                    }
                })
                .result;
        }
    }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function() {
    "use strict";

    angular.module("A56.theme").service("DefaultCtrlService", DefaultCtrlService);

    DefaultCtrlService.$inject = ["$q", "baConfig", "layoutPaths"];

    /** @ngInject */
    function DefaultCtrlService($q, baConfig, layoutPaths) {
        //加载年度对比折线图
        var layoutColors = baConfig.colors;
        var graphsBaseSetting = {
            valueAxis: "v2",
            // 设置 line 的端点形状
            bullet: "round",
            bulletBorderAlpha: 1,
            bulletColor: layoutColors.defaultText,
            color: layoutColors.defaultText,
            bulletSize: 5,
            hideBulletsCount: 50,
            lineThickness: 2,
            // id: 'g1',
            // lineColor: layoutColors.danger,
            // 设置维度值的呈现形式,默认为“line”. [“line”，“column”，“step”，“smoothedLine”，“candlestick”，“ohlc”]
            // title: "Year",
            // 指定该维度值来自于 "dataProvider" 中的字段名称
            // valueField: "preYearTotal",
            type: "smoothedLine",
            useLineColorForBulletBorder: true,
            // 汽泡设置
            balloonText: "[[title]]<br/><b style='font-size: 130%'>&nbsp;[[value]]</b>"
        };

        this.ctrl = function(conf) {
            var vm = this,
                isLegendReady = false;

            pageLoad();

            //选中年更改事件
            vm.onYearSelected = function(item, model, isPost) {
                vm.dropdownYear.model.selected = vm.dropdownYear.model.selected || {
                    value: new Date().getFullYear()
                };
                var y = vm.dropdownYear.model.selected.value;
                var cur = y - 2000,
                    pre = y - 1 - 2000;
                angular.forEach(conf.lineChart.graphs, function(v, i) {
                    switch (v.valueField) {
                        case "preYearTotal":
                            v.title = pre + "' Actual";
                            break;
                        case "curYearTotal":
                            v.title = cur + "' Actual";
                            break;
                        case "curYearQuota":
                            v.title = cur + "' Goal";
                            break;
                    }
                });
                onDropdownSeleceted({
                    searchName: "year",
                    dropdownObj: vm.dropdownYear,
                    isPost: isPost === undefined || isPost === true
                });
            };

            //客户更改事件
            vm.onCustomerSelected = function(item, model, isPost) {
                onDropdownSeleceted({
                    searchName: "customers",
                    dropdownObj: vm.dropdownCustomer,
                    isPost: isPost === undefined || isPost === true
                });
            };

            //仓库更改事件
            vm.onWarehouseSelected = function(item, model, isPost) {
                onDropdownSeleceted({
                    searchName: "warehouses",
                    dropdownObj: vm.dropdownWarehouse,
                    isPost: isPost === undefined || isPost === true
                });
            };

            vm.onRepeatFinished = function(isLast) {
                if (!isLast) return;
                isLegendReady = true;
                setTimeout(rendBottomLegend);
            };

            function rendBottomLegend() {
                angular.forEach(conf.lineChart.graphs, function(v, i) {
                    var id = "#legend" + (i + 1);
                    var svg = $("#legend").find("svg").clone();
                    var g = svg.find(">g>g>g");
                    var j = 0,
                        len = g.length;
                    $(id).find("svg").remove();
                    for (j; j < len; j++) {
                        if (j == i) {
                            $(g[j]).attr("transform", "translate(0,0)");
                            continue;
                        }
                        g[j].remove();
                    }
                    svg.appendTo(id);
                });
            }

            /**
             * 下拉列表初始化
             */
            function dropdwonInit(options) {
                options.svcApi(options.params || {}).then(callBack);
                function callBack(result) {
                    options.dropdownObj.data = [];
                    var label = "",
                        value = "";
                    angular.forEach(result.data, function(v, i) {
                        label = !!options.labelKey ? v[options.labelKey] : v;
                        value = !!options.valueKey ? v[options.valueKey] : v;
                        options.dropdownObj.data.push({
                            label: label,
                            value: value
                        });
                    });
                    if (options.onSvcApiCallback) {
                        options.onSvcApiCallback(result.data, options.dropdownObj.data);
                    }
                }
            }

            /**
             * 下拉列表 change 事件
             */
            function onDropdownSeleceted(options) {
                if (angular.isArray(options.dropdownObj.model.selected)) {
                    vm.search[options.searchName] = [];
                    angular.forEach(options.dropdownObj.model.selected, function(v, i) {
                        vm.search[options.searchName].push(v.value);
                    });
                } else {
                    vm.search[options.searchName] = options.dropdownObj.model.selected
                        ? options.dropdownObj.model.selected.value
                        : undefined;
                }
                if (options.isPost) {
                    rendChart();
                }
            }

            function rendChart() {
                // var legendText1Ele, legendText2Ele;
                var postParams = !!conf.lineChart.setApiSvcParams
                    ? conf.lineChart.setApiSvcParams(vm.search)
                    : vm.search;
                angular.extend(vm.search, postParams);
                conf.lineChart.apiSvc(vm.search).then(function(result) {
                    var dataProvider;
                    if (conf.lineChart.onApiCallback) {
                        dataProvider = conf.lineChart.onApiCallback(result);
                    } else {
                        dataProvider = result.data;
                    }

                    rendOrderReport(dataProvider);

                    if (!!!conf.barChart.apiSvc && conf.lineChart.setBarCharDataProvider) {
                        var barChartData = conf.lineChart.setBarCharDataProvider(result);
                        rendBarChart(barChartData);
                    }

                    // rendLegend();
                    if (isLegendReady) {
                        rendBottomLegend();
                    }
                });

                if (!!conf.barChart.apiSvc) {
                    conf.barChart.apiSvc(postParams).then(function(result) {
                        var barChartData;
                        if (conf.barChart.onApiCallback) {
                            barChartData = conf.barChart.onApiCallback(result.data);
                        } else {
                            barChartData = result.data;
                        }
                        rendBarChart(barChartData);
                    });
                }

                // function rendLegend() {
                //     // if ($("#legend1").find("svg").length) return;
                //     // var legend1 = $("#legend").clone();
                //     // var legend2 = $("#legend").clone();
                //     // legend1.find("svg>g>g>g")[0].remove();
                //     // legend2.find("svg>g>g>g")[1].remove();
                //     // legend1.find("svg>g>g>g").attr("transform", "translate(0,0)");
                //     // legend1.find("svg").appendTo($("#legend2"));
                //     // legend2.find("svg").appendTo($("#legend1"));

                //     // todo: 有待继续研究 svg，将 x 轴的值显示到底部 legend 上
                //     // if (legendText1Ele) {
                //     //     return;
                //     // }
                //     // // legendText1Ele = $("#legend>svg>g>g>g:first-child>text:last");
                //     // // legendText2Ele = $("#legend>svg>g>g>g:last-child>text:last");
                //     //  legendText1Ele = $("#legend>svg>g>g>g:first-child");
                //     // legendText2Ele = $("#legend>svg>g>g>g:last-child");

                //     // console.log(legendText1Ele);
                //     // console.log(legendText2Ele);

                //     //     legendText1Ele.append('<text y="6" fill="#666666" font-family="Verdana" font-size="11" opacity="1" text-anchor="start" transform="translate(109,7)">32132132312</text>');
                //     //     legendText2Ele.html("rewrewrwer");
                // }

                function rendOrderReport(dataProvider) {
                    vm.reportData = dataProvider;
                    vm.lineChart = {
                        graphs: conf.lineChart.graphs
                    };

                    var graphs = [];
                    angular.forEach(conf.lineChart.graphs, function(v, i) {
                        v.lineColor = layoutColors[v.lineColorName];
                        v.id = "g" + (i + 1);
                        graphs.push(
                            angular.extend(
                                { lineColor: layoutColors[v.lineColorName] },
                                graphsBaseSetting,
                                v
                            )
                        );
                    });

                    var chart = AmCharts.makeChart("orderReport", {
                        type: "serial",
                        theme: "none",
                        color: layoutColors.defaultText,
                        precision: 2,
                        valueAxes: [
                            angular.extend(
                                {
                                    color: layoutColors.defaultText,
                                    axisColor: layoutColors.defaultText,
                                    id: "v2",
                                    title: "汇总",
                                    gridAlpha: 0,
                                    position: "left",
                                    autoGridCount: false
                                },
                                conf.lineChart.valueAxes || {}
                            )
                        ],
                        // 定义图表列表(维度上的值)
                        graphs: graphs,
                        chartCursor: {
                            pan: true,
                            cursorColor: layoutColors.danger,
                            valueLineEnabled: true,
                            valueLineBalloonEnabled: true,
                            cursorAlpha: 0,
                            valueLineAlpha: 0.2
                        },
                        // 指定 "dataProvider" 中，显示在 X 轴上的字段
                        categoryField: conf.lineChart.categoryField || "month",
                        categoryAxis: {
                            axisColor: layoutColors.defaultText,
                            color: layoutColors.defaultText,
                            gridColor: layoutColors.defaultText,
                            // "parseDates": true,
                            gridAlpha: 0,
                            dashLength: 1,
                            minorGridEnabled: true
                        },
                        // 设置样式(当鼠标移入图表时就会有汽泡显示，balloon 设置汽泡的样式)
                        balloon: {
                            borderThickness: 1,
                            shadowAlpha: 0
                        },
                        dataProvider: vm.reportData,
                        // 设置 "graphs" 的位置
                        legend: {
                            useGraphSettings: true,
                            position: "bottom",
                            color: layoutColors.defaultText,
                            divId: "legend",
                            valueAlign: "left",
                            valueWidth: 100,
                            valueText: "[[value]]"
                        },
                        pathToImages: layoutPaths.images.amChart
                    });
                }

                function rendBarChart(barChartData) {
                    if (!barChartData.length) return;

                    vm.barCharData = barChartData;
                    vm.barChart = {
                        graphs: conf.barChart.graphs
                    };

                    // 设置颜色
                    angular.forEach(vm.barCharData, function(v, i) {
                        v.color = layoutColors[v.colorName];
                    });

                    var barChart = AmCharts.makeChart("orderBarChart", {
                        type: "serial",
                        theme: "none",
                        color: layoutColors.defaultText,
                        dataProvider: vm.barCharData,
                        valueAxes: [
                            angular.extend(
                                {
                                    color: layoutColors.defaultText,
                                    axisColor: layoutColors.defaultText,
                                    gridColor: layoutColors.defaultText,
                                    id: "v2",
                                    title: "",
                                    gridAlpha: 0,
                                    position: "right",
                                    autoGridCount: false
                                },
                                conf.barChart.valueAxes || {}
                            )
                        ],
                        startDuration: 1,
                        graphs: [
                            angular.extend(
                                {
                                    balloonText: "<b>[[category]]: [[value]]</b>",
                                    fillColorsField: "color",
                                    fillAlphas: 0.7,
                                    lineAlpha: 0.2,
                                    type: "column",
                                    valueField: "sum"
                                },
                                vm.barChart.graphs || {}
                            )
                        ],
                        chartCursor: {
                            categoryBalloonEnabled: false,
                            cursorAlpha: 0,
                            // valueLineAlpha: 0,
                            zoomable: false
                        },
                        categoryField: conf.barChart.categoryField || "name",
                        categoryAxis: {
                            gridAlpha: 0,
                            gridPosition: "start",
                            labelRotation: 45,
                            gridColor: layoutColors.border
                        },
                        creditsPosition: "top-right",
                        pathToImages: layoutPaths.images.amChart
                    });
                }
            }

            /**
             * 页面初始化
             */
            function pageLoad() {
                var defer = $q.defer();
                defer.promise.then(rendChart);

                vm.reportName = conf.reportName || "Total Order Shipped";
                vm.decActual = conf.decActual || "Dec Actual";
                vm.reportFormula = conf.reportFormula;
                vm.comments = conf.comments;
                //年
                vm.dropdownYear = {
                    model: {},
                    data: []
                };

                //客户
                vm.dropdownCustomer = {
                    model: {},
                    data: []
                };

                //仓库
                vm.dropdownWarehouse = {
                    model: {},
                    data: []
                };

                vm.reportData = [];

                vm.search = conf.search || {
                    /// 统计类型
                    statisticsID: 2,
                    /// 年
                    year: 0,
                    /// 客户
                    customers: [],
                    /// 数据类型
                    dataAttribute: [1, 2],
                    /// 仓库信息
                    warehouses: []
                };

                //加载年
                dropdwonInit({
                    // svcApi: apiSvc.getYears,
                    svcApi: conf.yearDwopdown.apiSvc,
                    dropdownObj: vm.dropdownYear,
                    onSvcApiCallback: function(apiResultData, dropdownDataItems) {
                        vm.dropdownYear.model.selected =
                            dropdownDataItems[dropdownDataItems.length - 1];
                        vm.onYearSelected(null, null, false);
                        defer.resolve("yearDropdown");
                    }
                });

                //加载客户信息
                dropdwonInit({
                    // svcApi: apiSvc.getCustomers,
                    svcApi: conf.customersDwopdown.apiSvc,
                    dropdownObj: vm.dropdownCustomer,
                    labelKey: conf.customersDwopdown.labelKey,
                    valueKey: conf.customersDwopdown.valueKey
                });

                //加载仓库信息
                dropdwonInit({
                    // svcApi: apiSvc.getWarehouses,
                    svcApi: conf.warehousesDwopdown.apiSvc,
                    dropdownObj: vm.dropdownWarehouse,
                    labelKey: conf.warehousesDwopdown.labelKey,
                    valueKey: conf.warehousesDwopdown.valueKey
                });
            }
        };
    }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function() {
    "use strict";

    angular.module("A56.theme").service("DownloadService", DownloadService);

    DownloadService.$inject = ["$http", "FileSaver"];

    /** @ngInject */
    function DownloadService($http, FileSaver) {
        this.download = function(params) {
            $http({
                url: params.url, // abp.appPath + "api/fileDownload/download",
                method: "POST",
                data: JSON.stringify(params.data), //JSON.stringify(result.data),
                responseType: "arraybuffer"
            }).then(function(res) {
                //"application/vnd.ms-excel"
                var blob = new Blob([res.data], { type: params.type });
                // var fileName = new Date().getTime() + ".xlsx";
                FileSaver.saveAs(blob, params.fileName);
            });
        };
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function() {
    "use strict";

    angular.module("A56.theme").service("preloader", preloader);

    /** @ngInject */
    function preloader($q) {
        return {
            loadImg: function(src) {
                var d = $q.defer();
                var img = new Image();
                img.src = src;
                img.onload = function() {
                    d.resolve();
                };
                return d.promise;
            },
            loadAmCharts: function() {
                var d = $q.defer();
                AmCharts.ready(function() {
                    d.resolve();
                });
                return d.promise;
            }
        };
    }
})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('A56.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/*
  Create by Cundong Zhang, 2017.03.10
  For logis sidebar menu permissions defintions
*/

(function() {
    "use strict";

    angular.module("A56.theme").service("userPermission", [
        function() {
            this.isGrantedMenu = function(stateItem) {
                if (!stateItem || !stateItem.perm) return true;
                // https://aspnetboilerplate.com/Pages/Documents/Navigation
                // https://aspnetboilerplate.com/Pages/Documents/Authorization
                // abp.auth.isGranted('Administration.UserManagement.CreateUser');
                if (angular.equals({}, abp.auth.grantedPermissions)) return false;
                var perms = [];
                //将对象结构转换为数据组
                if (angular.isObject(stateItem.perm)) {
                    for (var x in stateItem.perm) {
                        perms.push(stateItem.perm[x]);
                    }
                } else {
                    perms.push(stateItem.perm);
                }
                return abp.auth.isAnyGranted.apply(this, perms);
            };
        }
    ]);
})();

(function () {
    "use strict";

    angular.module("A56.pages.attendance").controller("InhouseStaffCtrl", InhouseStaffCtrl);

    InhouseStaffCtrl.$inject = [
        "abp.services.app.baseInfo",
        "abp.services.app.clearing_W_Sale_InhouseStaff",
        "editableOptions",
        "editableThemes",
        "$uibModal",
        "toastr",
        "dalogModal"
    ];

    /** @ngInject */
    function InhouseStaffCtrl(baseInfoSvc, inhouseStaffSvc, editableOptions, editableThemes, $uibModal, toastr, dalogModal) {
        var vm = this;
        vm.search = {
            attendanceDate: new Date()
        };
        vm.model = {};
        vm.myForm = "myForm";
        vm.uiDropdown = {
            isopen: false,
            confirm: function () {
                vm.grid.gridData.forEach(function (item) {
                    angular.extend(item, vm.model);
                });
                vm.uiDropdown.isopen = false;
                vm.model = {
                    dQuantity: undefined,
                    oQuantity: undefined
                };
            },
            cancel: function () {
                vm.uiDropdown.isopen = false;
                vm.model = {
                    dQuantity: undefined,
                    oQuantity: undefined
                };
            },
            onToggle: function (isOpen) { }
        };

        vm.grid = {
            gridData: [],
            clearItem: function (item) {
                dalogModal.confirm({ context: '单证人员和操作工' })
                    .then(function (res) {
                        if (res) {
                            item.dQuantity = undefined;
                            item.oQuantity = undefined;
                        }
                    }); 
            }
        };

        vm.datepicker = {
            open: function () {
                vm.datepicker.opened = true;
            },
            opened: false,
            format: "yyyy-MM",
            options: {
                showWeeks: false,
                minMode: "month"
            },
            dateChanged: function (e) {
                getData();
            }
        };

        vm.saveData = function () {
            inhouseStaffSvc.save(vm.grid.gridData).then(function () {
                toastr.success("修改成功");
                getData();
            });
        };

        initDropdown();
        getData();

        function getData() {
            vm.grid.gridData = [];
            inhouseStaffSvc.getAll(vm.search).then(function (result) {
                result.data = result.data || { items: [] };
                vm.grid.gridData = result.data.items;
            });
        }

        function initDropdown() {
            vm.dropdonw = {
                project: {},
                warehouse: {}
            };

            init.call(vm.dropdonw.project, "projectId", "getProjectOptions", 1);
            init.call(vm.dropdonw.warehouse, "warehouseId", "getWarehouseOptions", 2);

            function init(searchKey, apiName, lavel) {
                var that = this;

                baseInfoSvc[apiName]({}).then(function (result) {
                    that.selectItems = result.data;
                });

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        clearSelect();
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.id : "";
                    getData();
                }

                function clearSelect() {
                    vm.search[searchKey] = that.selected ? that.selected.id : undefined;
                    getData();
                }
            }
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    }
})();

(function () {
    "use strict";

    angular
        .module("A56.pages.dashboard.dcbi")
        .controller("DcbiCtrl", DcbiCtrl)
        .controller("ShaCtrl", ShaCtrl)
        .controller("HeqCtrl", HeqCtrl);

    DcbiCtrl.$inject = ["$scope", '$state', "$location", "$interval", "warehouse"];

    HeqCtrl.$inject = [
        "$scope",
        "$location",
        "baConfig",
        "colorHelper",
        "abp.services.app.whOrderGatherOperation"
    ];
    ShaCtrl.$inject = [
        "$scope",
        "$location",
        "baConfig",
        "colorHelper",
        "abp.services.app.whOrderGatherOperation"
    ];

    // var warehouse = [{ label: "合庆CMC", value: "HEQ" }, { label: "梅龙", value: "SHA" }];
    var warehouse;

    /** @ngInject */
    function DcbiCtrl($scope, $state, $location, $interval, wh) {
        var vm = this,
            warehouse = wh;
        vm.disabledWarehouse = $state.current.name != 'Dashboard.Dcbi';
        vm.isMobile = $location.$$search.isMobile;
        $scope.$on("ddl.get.warehouse", function (event, callcack) {
            callcack(vm.warehouseItem.selected);
        });

        initDropdown($location.$$search.warehouse);
        connectionSignalrHubServer.call(vm);
        vm.isFullscreen = $location.$$search.fullscreen;

        vm.modelData = {
            HEQ: {
                // 入库订单
                intoStorage: {},
                // 出库订单(领料单)
                outStorage: {}
            },
            SHA: {
                // 入库订单
                intoStorage: {},
                // 出库订单(领料单)
                outStorage: {}
            },
            PEK: {
                // 入库订单
                intoStorage: {},
                // 出库订单(领料单)
                outStorage: {}
            },
            SH001: {
                // 入库订单
                intoStorage: {},
                // 出库订单(领料单)
                outStorage: {}
            }
        };

        var toDo = function () {
            if (!vm.dateNow) {
                vm.dateNow = new Date();
                return;
            }

            vm.dateNow.setSeconds(vm.dateNow.getSeconds() + 1);
        };
        $interval(toDo, 1000);

        function initDropdown(clinetName) {
            vm.selectWarehouseItems = warehouse;
            if (!clinetName) {
                vm.warehouseItem = { selected: vm.selectWarehouseItems[0] };
                return;
            }
            // 如果Url中有参数，则根据参数设置当前选择的仓库
            var i = 0,
                len = warehouse.length;
            for (i; i < len; i++) {
                if (vm.selectWarehouseItems[i].value == clinetName) {
                    vm.warehouseItem = { selected: vm.selectWarehouseItems[i] };
                    break;
                }
            }
        }
    }

    function ShaCtrl($scope, $location, baConfig, colorHelper, apiSvc) {
        var vm = this,
            dashboardColors = baConfig.colors.dashboard;

        // 获取仓库名称
        $scope.$emit("ddl.get.warehouse", function (whObj) {
            vm.warehouse = whObj;
        });

        vm.isMobile = $location.$$search.isMobile;
        vm.transparent = baConfig.theme.blur;
        vm.triggerIncludLoaded = false;

        // 入库订单
        vm.intoStorage = {};
        // 出库订单(领料单)
        vm.outStorage = {};

        vm.intoStorage = getModelStructure(colorHelper, dashboardColors, ["预计", "到货", "收货", "理货", "上架", "入库"]);
        vm.outStorage = getModelStructure(
            colorHelper,
            dashboardColors,
            ["等待拣货", "开始拣货", '拣货完成', '复核打包', '已出库'],//, '已发货'
            undefined
        );

        // 梅龙入库订单
        vm.initIntoStorage = function (elemId, isInit) {
            var dataKeyName = "intoStorage";
            rendChar.call(
                this,
                isInit,
                $scope,
                vm,
                dataKeyName,
                1, //"InOrder",
                elemId,
                {
                    fn: convertData,
                    params: [vm, dataKeyName]
                },
                apiSvc
            );
        };

        // 梅龙出库
        vm.initOutStorage = function (elemId, isInit) {
            var dataKeyName = "outStorage";
            rendChar.call(
                this,
                isInit,
                $scope,
                vm,
                dataKeyName,
                2,//"OutOrder",
                elemId,
                {
                    fn: convertOutOrderData,
                    params: []
                },
                apiSvc
            );
        };

        abp.event.on("sha.intoStorage.received", function (data) {
            vm.initIntoStorage.call(data, "into-storage");
        });

        abp.event.on("sha.outStorage.received", function (data) {
            vm.initOutStorage.call(data, "out-storage");
        });

        function convertOutOrderData() {
            var that = this;
            if (!that) return;
            var arr = that.milestoneOrderNumOutputDtos,
                index = 0;
            angular.forEach(arr, function (v, i) {
                if (v.milestone == 70) {
                    index = 0;
                } else if (v.milestone == 80) {
                    index = 1;
                } else if (v.milestone == 90) {
                    index = 2;
                } else if (v.milestone == 110) {
                    index = 3;
                } else if (v.milestone == 120) {
                    index = 4;
                }
                // else if (v.milestone == 130) {
                //     index = 5;
                // }
                else {
                    return;
                }
                vm.outStorage.datasets[0].percentage[index] = vm.outStorage.datasets[0].data[index] = v.infoValue;
            });
            vm.outStorage.sum = that.sumInfoValue;
        }
    }

    function HeqCtrl($scope, $location, baConfig, colorHelper, apiSvc) {
        var vm = this,
            dashboardColors = baConfig.colors.dashboard;

        // 获取仓库名称
        $scope.$emit("ddl.get.warehouse", function (whObj) {
            vm.warehouse = whObj;
        });

        vm.isMobile = $location.$$search.isMobile;
        vm.transparent = baConfig.theme.blur;

        // 入库订单
        vm.intoStorage = {};
        // 出库订单(领料单)
        vm.outStorage = {};

        vm.intoStorage = getModelStructure(colorHelper, dashboardColors, ["预计", "到货", "收货", "理货", "上架", "入库"]);
        vm.outStorage = getModelStructure(
            colorHelper,
            dashboardColors,
            ["等待拣货", "开始拣货", '拣货完成', '复核打包', '已出库'],//, '已发货'
            undefined,
            { rowNum: 0, typeNum: 0 },
            [],
            [{ rowNum: 0, typeNum: 0 }, { rowNum: 0, typeNum: 0 }, { rowNum: 0, typeNum: 0 },
            { rowNum: 0, typeNum: 0 }, { rowNum: 0, typeNum: 0 }]//, { rowNum: 0, typeNum: 0 }
        );

        // 合庆入库订单
        vm.initIntoStorage = function (elemId, isInit) {
            var dataKeyName = "intoStorage";
            rendChar.call(
                this,
                isInit,
                $scope,
                vm,
                dataKeyName,
                1,//"InOrder",
                elemId,
                {
                    fn: convertData,
                    params: [vm, dataKeyName]
                },
                apiSvc
            );
        };

        // 合庆出库订单(领料单)
        vm.initOutStorage = function (elemId, isInit) {
            var dataKeyName = "outStorage";
            rendChar.call(
                this,
                isInit,
                $scope,
                vm,
                dataKeyName,
                3,//"DeliveryOrder",
                elemId,
                {
                    fn: convertDeliveryOrderData,
                    params: []
                },
                apiSvc
            );
        };

        abp.event.on("heq.intoStorage.received", function (data) {
            vm.initIntoStorage.call(data, "into-storage");
        });

        abp.event.on("heq.outStorage.received", function (data) {
            vm.initOutStorage.call(data, "out-storage");
        });

        function convertDeliveryOrderData() {
            var that = this;
            if (!that) return;
            var arr = that.milestoneOrderNumOutputDtos,
                index = 0;
            angular.forEach(arr, function (v, i) {
                if (v.milestone == 70) {
                    index = 0;
                } else if (v.milestone == 80) {
                    index = 1;
                } else if (v.milestone == 90) {
                    index = 2;
                } else if (v.milestone == 110) {
                    index = 3;
                } else if (v.milestone == 120) {
                    index = 4;
                }
                // else if (v.milestone == 130) {
                //     index = 5;
                // }
                else {
                    return;
                }
                // 领料单/欠料行数
                vm.outStorage.datasets[0].percentage[index].rowNum = vm.outStorage.datasets[0].data[index] = v.cargoListNum;
                // 领料单/欠料种数
                vm.outStorage.datasets[0].percentage[index].typeNum = v.skuNum;
            });
            vm.outStorage.sum.rowNum = that.sumCargoListNum;
            vm.outStorage.sum.typeNum = that.sumSkuNum;
        }
    }

    function rendChar(
        isInit,
        $scope,
        vm,
        dataKeyName,
        flow,
        elemId,
        convertDataObj,
        apiSvc
    ) {
        if (isInit) {
            if ($scope.$parent.vm.modelData[vm.warehouse.value][dataKeyName].labels) {
                vm[dataKeyName] = $scope.$parent.vm.modelData[vm.warehouse.value][dataKeyName];
            }

            // 向服务器发起请求加载数据
            apiSvc.getWhStatisticInfo({
                warehouseCode: vm.warehouse.value,
                flow: flow
            }).then(function (result) {
                bindData(result.data);
            });
            return;

            // if (!vm[dataKeyName].datasets[0].data.length) {
            //     // 向服务器发起请求加载数据
            //     apiSvc.getWhStatisticInfo({
            //         warehouseCode: vm.warehouse.value,
            //         flow: flow
            //     }).then(function (result) {
            //         bindData(result.data);
            //     });
            //     return;
            // } else {
            //     // 加载已存在 vm 对象中的数据
            //     salesReport.call(vm, elemId, vm[dataKeyName]);
            //     return;
            // }
        }
        var that = this;

        // 如果下拉列表选择的仓库与推送的数据不匹配则不加载
        if (vm.warehouse.value != that.warehouseCode) {
            return;
        }

        bindData(that);

        function bindData(data) {
            convertDataObj.fn.apply(data, convertDataObj.params);
            salesReport.call(vm, elemId, vm[dataKeyName]);
            $scope.$parent.vm.modelData[vm.warehouse.value][dataKeyName] = vm[dataKeyName];
        }
    }

    // [入库][出库] 图表
    function salesReport(elemId, data) {
        if (!data) return;
        var that = this;
        if (that[elemId]) {
            that[elemId].chart.config.data = data;
            that[elemId].update();
        } else {
            setTimeout(function () {
                var elem = document.getElementById(elemId);
                if (!elem) return;
                var ctx = elem.getContext("2d");
                that[elemId] = new Chart(ctx, {
                    type: "doughnut",
                    data: data, //$scope.doughnutData,
                    options: {
                        // 内圆直径像素为 64
                        cutoutPercentage: 64,
                        responsive: true,
                        elements: {
                            arc: {
                                borderWidth: 0
                            }
                        }
                    }
                });
            }, 0);
        }
    }

    function getModelStructure(
        colorHelper,
        dashboardColors,
        labels,
        colors,
        sum,
        data,
        percentage
    ) {
        sum = sum || 0;
        data = data || [];
        percentage = percentage || [];
        // colors = colors || [
        //     dashboardColors.warning,//"#dadada",
        //     dashboardColors.warning,
        //     dashboardColors.danger,
        //     dashboardColors.success
        // ];
        colors = colors || ["#dadada", "#dfb81c", "#e85656", "#90b900", "#b9f2a1"];//, "#0e8174"
        var pColord = [];
        angular.forEach(colors, function (v, i) {
            pColord.push(colorHelper.shade(v, 15));
        });
        return {
            sum: sum,
            labels: labels,
            datasets: [
                {
                    data: data,
                    backgroundColor: colors,
                    hoverBackgroundColor: pColord,
                    percentage: percentage
                }
            ]
        };
    }

    function convertData(vm, name) {
        var that = this;
        if (!that) return;
        var arr = that.milestoneOrderNumOutputDtos,
            index = 0;
        angular.forEach(arr, function (v, i) {
            if (v.milestone == 10) {
                // 新建
                index = 0;
            } else if (v.milestone == 20) {
                // 到货
                index = 1;
            } else if (v.milestone == 30) {
                // 收货
                index = 2;
            } else if (v.milestone == 40) {
                // 入库
                index = 3;
            } else if (v.milestone == 50) {
                // 入库
                index = 4;
            } else if (v.milestone == 60) {
                // 入库
                index = 5;
            } else {
                return;
            }
            vm[name].datasets[0].percentage[index] = vm[name].datasets[0].data[index] = v.infoValue;
        });
        vm[name].sum = that.sumInfoValue;
    }

    // 连接到 signalr 服务器
    function connectionSignalrHubServer() {
        var that = this,
            clinetName = that.warehouseItem.selected.value;
        // 获取客户端名称，如果不存在则不连接 signalr 服务器
        if (!clinetName) return;

        // 如果已连接则不再进行连接
        if ($.connection.hub.state !== $.signalR.connectionState.disconnected) {
            return;
        }

        // 定义连接成功事件
        abp.event.on("abp.signalr.dcbi.connected", function (cName) {
            console.log(cName);
            bindClient();
        });

        // 定义重新连接事件
        abp.event.on("abp.signalr.dcbi.reConnected", function () {
            bindClient();
        });

        // 定义断开连接事件
        abp.event.on("abp.signalr.dcbi.disconnected", function () {

        });

        window.a56 = window.a56 || {};
        window.a56.dcbiHub = $.connection.dcbiHub;
        console.log(window.a56.dcbiHub);

        // 连接成功后的回调
        window.a56.dcbiHub.client.connectedCallback = function (connectionId) {
            that.connectionId = connectionId;
            console.log("Hub 已连接：", connectionId);
            //连接成功播放声音
            abp.event.trigger("playNotificationMp3", {});
        };

        // 接收到消息
        window.a56.dcbiHub.client.getNotification = function (notification) {
            abp.event.trigger("abp.signalr.dcbi.received", notification);
        };

        // 重新连接成功
        window.a56.dcbiHub.client.reConnectedCallback = function (connectionId) {
            that.connectionId = connectionId;
            console.log("Hub 重新连接：", connectionId);
        };

        $.connection.hub.start().done(function () {
            abp.event.trigger("abp.signalr.dcbi.connected", clinetName);
        });

        $.connection.hub.error(function (e) {
            if (e.source && e.source.type == 'close') {
                window.a56.dcbiHub.connection.socket.close();
                window.a56.dcbiHub.connection.stop();
                // 5 分钟重新连接一次
                var intervalId = setInterval(function () {
                    if (window.a56.dcbiHub.connection.state === $.signalR.connectionState.disconnected) {
                        console.log('重新连接中...');
                        $.connection.hub.start().done(function () {
                            clearInterval(intervalId);
                            console.log('已经重新连接!!!');
                            abp.event.trigger("abp.signalr.dcbi.connected", clinetName);
                        });
                    }
                }, 1000 * 60 * 5);
            }
        });

        // 定义读取接收到的消息事件
        abp.event.on("abp.signalr.dcbi.received", function (data) {
            console.log("读取消息...");
            //播放声音
            abp.event.trigger("playNotificationMp3", {});

            if (data.statisticsCode == warehouse[0].value + "_InOrder") {
                // 合庆CMC入库订单(入库单统计)
                abp.event.trigger("heq.intoStorage.received", data);
            } else if (data.statisticsCode == warehouse[0].value + "_DeliveryOrder") {
                // 合庆CMC 领料单统计
                abp.event.trigger("heq.outStorage.received", data);
            } else if (
                data.statisticsCode == warehouse[1].value + "_InOrder" ||
                data.statisticsCode == warehouse[2].value + "_InOrder" ||
                data.statisticsCode == warehouse[3].value + "_InOrder"
            ) {
                // 入库
                abp.event.trigger("sha.intoStorage.received", data);
            } else if (
                data.statisticsCode == warehouse[1].value + "_OutOrder" ||
                data.statisticsCode == warehouse[2].value + "_OutOrder" ||
                data.statisticsCode == warehouse[3].value + "_OutOrder"
            ) {
                // 出库
                abp.event.trigger("sha.outStorage.received", data);
            }
        });

        function bindClient() {
            var pro = {};
            if (that.isMobile) {
                pro[clinetName] = "";
                window.a56.dcbiHub.server.bindClient(pro);
            } else {
                angular.forEach(that.selectWarehouseItems, function (v, i) {
                    pro[v.value] = "";
                    window.a56.dcbiHub.server.bindClient(pro);
                });
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("CleaingRuleCtrl", CleaingRuleCtrl);

    CleaingRuleCtrl.$inject = [
        "abp.services.app.baseInfo",
        "abp.services.app.clearing_W_Rule",
        "toastr",
        "editableOptions",
        "editableThemes",
        "$uibModal",
        'dalogModal',
    ];

    /** @ngInject */
    function CleaingRuleCtrl(baseInfoSvc, clearingRuleSvc, toastr, editableOptions, editableThemes, $uibModal, dalogModal) {
        var vm = this,
            displayedPages = 10;

        vm.search = {
            isActive: true,
            maxResultCount: 12
        };

        initDropdown();

        vm.grid = {
            gridData: [],
            addBtnDisabled: false,
            dropdonw: {
                group: {},
                sub: {},
                subject: {}
            },
            add: function () {
                vm.grid.addBtnDisabled = true;
                vm.grid.inserted = {
                    groupCode: undefined,
                    groupName: "",
                    subjectId: undefined,
                    subjectName: "",
                    subCode: undefined,
                    subName: "",
                    chargeName: "",
                    unitName: "",
                    isSupportDay: false,
                    isSupportMonth: false,
                    isSupportOnce: false,
                    isSupportMaxQty: false,
                    isActive: true,
                    comment: null,
                    id: undefined
                };
                vm.grid.gridData.unshift(vm.grid.inserted);
            },
            cancel: function (index, item, rowform) {
                if (!item.id) {
                    vm.grid.gridData.splice(index, 1);
                }
                rowform.$cancel();
                vm.grid.addBtnDisabled = false;
            },
            update: function (index, data, item) {
                angular.extend(item, data);
                var apiName = "create",
                    msg = "创建成功！";
                if (item.id) {
                    apiName = "update";
                    msg = "更新成功！";
                }
                clearingRuleSvc[apiName](item).then(function (result) {
                    toastr.success(msg);
                    vm.grid.selectPage(1);
                });
            },
            disabled: function (index) {
                var item = vm.grid.gridData[index];
                dalogModal
                    .confirm({
                        optionName: item.isActive ? '是否禁用' : "是否启用",
                        title: item.isActive ? "禁用" : '启用'
                    }).then(function (res) {
                        if (res) {
                            item.isActive = !item.isActive;
                            clearingRuleSvc.update(item).then(function (res) {
                                toastr.success("操作成功");
                                vm.grid.selectPage(1);
                            });
                        }
                    });
            },
            checkTempEmpty: function (data) {
                if (angular.isObject(data)) {
                    if (!data.id) {
                        return "*";
                    }
                    return;
                } else if (data == null || data == undefined || !data.length) {
                    return "*";
                }
            },
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: displayedPages,
                total: undefined
            },
            callServer: function (tableState, ctrl) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                clearingRuleSvc.getAll(vm.search).then(function (result) {
                    vm.grid.gridData = result.data.items;
                    tableState.pagination.totalItemCount = result.data.totalCount;
                    tableState.pagination.numberOfPages =
                        Math.ceil(result.data.totalCount / pagination.number) || 1;
                    vm.grid.addBtnDisabled = false;
                });
            },
            selectPage: function (pageIndex) {
                angular.element("st-pagination").isolateScope().selectPage(pageIndex);
            },
            checkBoxClikc: function (evt, data, item, itemKeyCk, itemKey, itemValKey) {
                item[itemKeyCk] = data;
                if (!item[itemKey]) {
                    item[itemKey] = item[itemValKey];
                }
            },
            onCheckboxShow: function (item, itemKeyCk, itemKey, data) {
                item[itemKeyCk] = item[itemKey] > 0;
            }
        };

        initGridDropdown.call(
            vm.grid.dropdonw.group,
            "getWRuleGroupCodeOptions",
            "groupCode",
            "groupName",
            "groupSelect"
        );
        initGridDropdown.call(
            vm.grid.dropdonw.sub,
            "getWRuleSubCodeOptions",
            "subCode",
            "subName",
            "subSelect"
        );
        initGridDropdown.call(
            vm.grid.dropdonw.subject,
            "getSubjectOptions",
            "subjectId",
            "subjectName",
            "subjectSelect"
        );

        function initGridDropdown(apiName, feildKey, feildText, selected) {
            var that = this;
            angular.extend(that, {
                data: [],
                onShow: function () {
                    if (!that.data.length) {
                        baseInfoSvc[apiName]({}).then(function (result) {
                            // if (apiName == "getSubjectOptions") {
                            // 二级科目绑定
                            //     that.data = result.data.filter(function(item) {
                            //         return !!item.parentId;
                            //     });
                            // } else {
                            that.data = result.data;
                            // }
                        });
                    }
                },
                onChange: function (data, item) {
                    item[feildText] = data.name;
                    item[feildKey] = data.id;
                }
            });
        }

        function initDropdown() {
            vm.dropdonw = {
                groupCount: {},
                status: {}
            };

            init.call(vm.dropdonw.groupCount, "groupCode", "getWRuleGroupCodeOptions");
            init.call(vm.dropdonw.status, "isActive");

            function init(searchKey, apiName) {
                var that = this;

                if (!apiName) {
                    that.selectItems = [{ id: false, text: "禁用" }, { id: true, text: "启用" }];
                    that.selected = that.selectItems[1];
                } else {
                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });
                }

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        clearSelect();
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.id : "";
                    vm.grid.selectPage(1);
                }

                function clearSelect() {
                    vm.search[searchKey] = that.selected ? that.selected.id : undefined;
                    vm.grid.selectPage(1);
                }
            }
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("CustomerCtrl", CustomerCtrl);

    CustomerCtrl.$inject = [
        "abp.services.app.customerSettings",
        "toastr",
        "editableOptions",
        "editableThemes",
        'dalogModal'
    ];

    /** @ngInject */
    function CustomerCtrl(customerSettingsSvc, toastr, editableOptions, editableThemes, dalogModal) {
        var vm = this,
            displayedPages = 10,
            optionEnum = {
                add: 1,
                addName: '添加客户',
                update: 2,
                updateName: '编辑客户',
                del: 3,
                active: 4,
                updatePwd: 5
            };

        vm.search = {
            isActive: true,
            maxResultCount: 12
        }; 

        vm.grid = {
            gridData: [],
            addBtnDisabled: false, 
            optionEnum: optionEnum,
            options: function (item, option) {
                item = item || {};
                var ctrlName = undefined,
                    apiName = '',
                    msg = '',
                    title = '',
                    includeTemp = 'app/pages/settings/customer/customer.form.html';
                switch (option) {
                    case optionEnum.add:
                        ctrlName = "settingsCustomerFormCtrl";
                        apiName = 'create';
                        msg = "创建成功！";
                        title = "添加客户";
                        break;
                    case optionEnum.update:
                        ctrlName = "settingsCustomerFormCtrl";
                        apiName = 'update';
                        msg = "更新成功！";
                        title = "编辑客户";
                        break;
                    case optionEnum.updatePwd:
                        ctrlName = "settingsCustomerPwdFormCtrl";
                        apiName = 'resetPassword';
                        msg = "密码修改成功";
                        title = "修改密码";
                        includeTemp = 'app/pages/settings/customer/customer.pwd.form.html';
                        break;
                    case vm.grid.optionEnum.active:
                        dalogModal
                            .confirm({
                                context: item.name,
                                optionName: item.isActive ? '是否禁用客户：' : "是否启用客户：",
                                title: item.isActive ? "禁用" : '启用'
                            }).then(function (res) {
                                if (res) {
                                    item.isActive = !item.isActive;
                                    customerSettingsSvc.update(item).then(function (res) {
                                        toastr.success("禁用成功");
                                        vm.grid.selectPage(1);
                                    });
                                }
                            });
                        return;
                    default:
                        return;
                }
                dalogModal.open({
                    templateUrl: "app/theme/components/modalForm/modal.form.html",
                    ctrlName: ctrlName,
                    size: "lg",
                    context: {
                        title: title,
                        optionEnum: optionEnum,
                        currentOption: option,
                        model: item,
                        includeTemp: includeTemp
                    },
                    callback: function (res) {
                        if (res === false) return;
                        customerSettingsSvc[apiName](res).then(function (result) {
                            toastr.success(msg);
                            vm.grid.selectPage(1);
                        });
                    }
                });
            },
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: displayedPages,
                total: undefined
            },
            callServer: function (tableState) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                customerSettingsSvc.getAll(vm.search).then(function (result) {
                    vm.grid.gridData = result.data.items;
                    tableState.pagination.totalItemCount = result.data.totalCount;
                    tableState.pagination.numberOfPages =
                        Math.ceil(result.data.totalCount / pagination.number) || 1;
                    vm.grid.addBtnDisabled = false;
                });
            },
            selectPage: function (pageIndex) {
                angular.element("st-pagination").isolateScope().selectPage(pageIndex);
            }
        };

        initDropdown();

        function initDropdown() {
            vm.dropdonw = {
                status: {}
            };

            init.call(vm.dropdonw.status, "isActive");

            function init(searchKey, apiName) {
                var that = this;

                that.selectItems = [{ value: false, text: "禁用" }, { value: true, text: "启用" }];
                that.selected = that.selectItems[1];

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        vm.grid.selectPage(1);
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.value : undefined;
                    vm.grid.selectPage(1);
                }
            }
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("settingsCustomerFormCtrl", settingsCustomerFormCtrl);

    settingsCustomerFormCtrl.$inject = [
        'modal.form.ctrl.service',
        '$uibModalInstance',
        'context'
    ];

    /** @ngInject */
    function settingsCustomerFormCtrl(modalFormSvc, $uibModalInstance, context) {
        var vm = this;
        modalFormSvc.initModal.call(vm, $uibModalInstance, context);
    };
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("settingsCustomerPwdFormCtrl", settingsCustomerPwdFormCtrl);

    settingsCustomerPwdFormCtrl.$inject = [
        'modal.form.ctrl.service',
        '$uibModalInstance',
        'context'
    ];

    /** @ngInject */
    function settingsCustomerPwdFormCtrl(modalFormSvc, $uibModalInstance, context) {
        var vm = this;
        modalFormSvc.initModal.call(vm, $uibModalInstance, context);
    };
})();

(function() {
    "use strict";

    angular.module("A56.pages.settings").controller("DepartmentCtrl", DepartmentCtrl);

    DepartmentCtrl.$inject = [
        "abp.services.app.departmentSettings",
        "settingsTreeService",
        "$scope",
        "abp.services.app.baseInfo"
    ];

    /** @ngInject */
    function DepartmentCtrl(settingsSve, settingsTreeService, $scope, baseInfoSvc) {
        var vm = this,
            newDataModel = {};

        function dataMap(item) {
            return {
                id: item.id,
                parent: item.parentId || "#",
                type: !!item.parentId ? undefined : "folder",
                position: item.position,
                text: item.name,
                code: item.code,
                comment: item.comment,
                employeeId: item.employeeId,
                level: item.level,
                processFlag: false,
                state: {
                    opened: true
                }
            };
        }

        function initDropdown() {
            vm.dropdonw = {
                employee: {}
            };

            init.call(vm.dropdonw.employee, "employeeId", "getEmployeeOptions");

            function init(searchKey, apiName) {
                var that = this;

                baseInfoSvc[apiName]({}).then(function(result) {
                    that.selectItems = result.data;
                });

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function() {
                        vm.model[searchKey] = [];
                        that.selected = undefined;
                    }
                });

                function selectedChange($item, $model) {
                    vm.model[searchKey] = that.selected ? that.selected.id : undefined;
                }
            }
        }

        initDropdown();

        settingsTreeService.init.call(vm, $scope, {
            maxlevel: 0,
            settingsSve: settingsSve,
            get: "getDepartmentTree",
            singleSave: "processDepartment",
            batchSave: "processDepartmentList",
            deleteNode: "delete",
            dataMap: dataMap,
            newDataModel: newDataModel,
            on: function(eventName, data) {
                if (
                    eventName == "select_node" ||
                    eventName == "deselect_all" ||
                    eventName == "create_node" ||
                    eventName == "delete_node"
                ) {
                    if (eventName == "delete_node") data = null;
                    clearDropdown(data);
                }
            }
        });

        function clearDropdown(data) {
            if (!data || !data.employeeId) {
                vm.dropdonw.employee.selected = undefined;
                return;
            }
            var arr = vm.dropdonw.employee.selectItems.filter(function(item) {
                return item.id == data.employeeId;
            });
            if (arr && arr.length) {
                vm.dropdonw.employee.selected = arr[0];
                return;
            }

            vm.dropdonw.employee.selected = undefined;
        }
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("ProjectCtrl", ProjectCtrl);

    ProjectCtrl.$inject = [
        "$uibModal",
        "abp.services.app.baseInfo",
        "abp.services.app.projectSetting",
        "toastr",
        "editableOptions",
        "editableThemes",
        'dalogModal'
    ];

    /** @ngInject */
    function ProjectCtrl($uibModal, baseInfoSvc, projectSettingSvc, toastr, editableOptions, editableThemes, dalogModal) {
        var vm = this,
            displayedPages = 10;

        vm.search = {
            isActive: true,
            maxResultCount: 12
        };

        vm.onKeyup = function (e) {
            var keycode = window.event ? e.keyCode : e.which;
            if (keycode == 13) {
                vm.grid.selectPage(1);
            }
        };
        vm.onClear = function (searchKey) {
            vm.search[searchKey] = undefined;
            vm.grid.selectPage(1);
        };

        vm.grid = {
            gridData: [],
            addBtnDisabled: false,
            cancel: function (index, item, rowform) {
                if (!item.id) {
                    vm.grid.gridData.splice(index, 1);
                }
                rowform.$cancel();
                vm.grid.addBtnDisabled = false;
            },
            add: function () {
                vm.grid.addBtnDisabled = true;
                vm.grid.inserted = {
                    code: undefined,
                    comment: undefined,
                    creationTime: undefined,
                    departmentId: undefined,
                    departmentName: "",
                    employeeId: undefined,
                    employeeName: "",
                    id: undefined,
                    name: undefined,
                    isActive: true
                };
                vm.grid.gridData.unshift(vm.grid.inserted);
            },
            update: function (index, data, item) {
                angular.extend(item, data);
                var apiName = "create",
                    msg = "创建成功！";
                if (item.id) {
                    apiName = "update";
                    msg = "更新成功！";
                }
                item.warehouses = item.warehouseSelected;
                projectSettingSvc[apiName](item).then(function (result) {
                    toastr.success(msg);
                    vm.grid.selectPage(1);
                });
            },
            disabled: function (index) {
                var item = vm.grid.gridData[index];
                dalogModal
                    .confirm({
                        context: item.name,
                        optionName: item.isActive ? '是否禁用项目：' : "是否启用项目：",
                        title: item.isActive ? "禁用" : '启用'
                    }).then(function (res) {
                        if (res) {
                            item.isActive = !item.isActive;
                            projectSettingSvc.update(item).then(function (res) {
                                toastr.success("禁用成功");
                                vm.grid.selectPage(1);
                            });
                        }
                    });
            },
            checkTempEmpty: function (data, rowform) {
                if (data == null || data == undefined || (!angular.isNumber(data) && data == ""))
                    return "*";
            },
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: displayedPages,
                total: undefined
            },
            callServer: function (tableState) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                projectSettingSvc.getAll(vm.search).then(function (result) {
                    vm.grid.gridData = result.data.items.map(function (item) {
                        item.warehouseSelected = item.warehouses.map(function (w) {
                            return { id: w.id, name: w.name };
                        });
                        return item;
                    });
                    tableState.pagination.totalItemCount = result.data.totalCount;
                    tableState.pagination.numberOfPages =
                        Math.ceil(result.data.totalCount / pagination.number) || 1;
                    vm.grid.addBtnDisabled = false;
                });
            },
            selectPage: function (pageIndex) {
                angular.element("st-pagination").isolateScope().selectPage(pageIndex);
            },
            radioList: {
                status: {
                    data: [{ value: true, text: "启用" }, { value: false, text: "禁用" }]
                }
            },
            dropdown: {
                customer: {},
                warehouse: {}
            }
        };

        initGridDropdown.call(
            vm.grid.dropdown.customer,
            "getCustomerOptions",
            "customerId",
            "customerName",
            "customerSelected"
        );
        initGridDropdown.call(
            vm.grid.dropdown.warehouse,
            "getWarehouseOptions",
            "warehouseId",
            "warehouseName",
            "warehouseSelected"
        );

        initDropdown();

        function initDropdown() {
            vm.dropdonw = {
                status: {}
            };

            init.call(vm.dropdonw.status, "isActive");

            function init(searchKey, apiName) {
                var that = this;

                that.selectItems = [{ value: false, text: "禁用" }, { value: true, text: "启用" }];
                that.selected = that.selectItems[1];

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        vm.grid.selectPage(1);
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.value : undefined;
                    vm.grid.selectPage(1);
                }
            }
        }

        function initGridDropdown(apiName, feildKey, feildText, selectedKey) {
            var that = this;
            angular.extend(that, {
                data: [],
                onShow: function () {
                    if (!that.data.length) {
                        baseInfoSvc[apiName]({}).then(function (result) {
                            that.data = result.data;
                        });
                    }
                },
                onChange: function (data, item) {
                    item[feildKey] = data.id;
                    item[feildText] = data.name;
                }
            });
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    }
})();

(function() {
    "use strict";

    angular.module("A56.pages.settings").constant("optionRoleEnum", {
        addName: "添加角色",
        add: 1,
        updateName: "编辑角色",
        update: 2,
        permName: "权限设置",
        perm: 3,
        unlock: 4,
        del: 5
    });
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings")
        .controller("settingsRoleCtrl", settingsRoleCtrl)
        .service('settings.userRole.Service', userRoleTreeService);

    settingsRoleCtrl.$inject = [
        "$uibModalInstance",
        "context",
        "optionRoleEnum",
        "settingsModelNav",
        "abp.services.app.role",
        'settings.userRole.Service',
        "toastr"
    ];

    /** @ngInject */
    function settingsRoleCtrl(
        $uibModalInstance,
        context,
        optionEnum,
        settingsModelNav,
        roleSvc,
        userRoleSvc,
        toastr
    ) {
        var vm = this;
        vm.model = {};
        vm.myForm = "myForm";
        vm.company = {};
        vm.tree = {
            prem: {},
            department: {},
            project: {}
        };

        settingsModelNav.initNav.call(vm, {
            // 用户信息
            name: 0,
            // 权限
            prem: 1,
            // 部门
            department: 2,
            // 项目
            project: 3,
            // 公司
            company: 4
        });
        vm.currentMenu = vm.menu.name;

        switch (context.optionEnum) {
            case optionEnum.add:
                vm.title = optionEnum.addName;
                break;
            case optionEnum.update:
                vm.title = optionEnum.updateName + "：" + context.item.displayName;
                break;
            case optionEnum.permName:
                vm.title = optionEnum.permName + "：" + context.item.displayName;
                break;
        }

        var roleId = !!context.item ? context.item.id : undefined;
        roleSvc.getRoleForEdit({ id: roleId }).then(function (result) {
            vm.model = result.data;
            if (!vm.model.role) {
                vm.model.role = {};
            }
            userRoleSvc.tree.call(
                vm.tree.prem,
                vm.model.permissions,
                vm.model.grantedPermissionNames,
                userRoleSvc.premDataMap,
                "权限"
            );
            userRoleSvc.tree.call(
                vm.tree.department,
                vm.model.departments,
                vm.model.grantedDepartmentIds,
                userRoleSvc.departmentDataMap,
                "部门"
            );
            userRoleSvc.tree.call(
                vm.tree.project,
                vm.model.projects,
                !vm.model.grantedProjectIds ? "" : "," + vm.model.grantedProjectIds.join(",") + ",",
                userRoleSvc.projectDataMap,
                "项目"
            );
            userRoleSvc.company.call(vm.company, vm.model.companies, vm.model.grantedCompanyIds);
        });

        vm.cancel = function () {
            $uibModalInstance.close(false);
        };
        vm.ok = function () {
            if (vm.myForm) {
                vm.myForm.$setSubmitted(true);
                if (!vm.myForm.$valid) {
                    toastr.warning("请完善必填信息");
                    return;
                }
            }

            var grantedPermissionNames = [],
                res = vm.tree.prem.basicTree
                    .get_checked()
                    .filter(function (item) {
                        return item != "pages";
                    });

            angular.forEach(res, function (v, i) {
                userRoleSvc.grantedPermissionNames(v, vm.model.permissions, grantedPermissionNames);
            });
            roleSvc.createOrUpdateRole({
                role: vm.model.role,
                grantedPermissionNames: grantedPermissionNames,
                grantedDepartmentIds: vm.tree.department.basicTree
                    .get_checked()
                    .filter(function (item) {
                        return item != "pages";
                    }),
                grantedProjectIds: vm.tree.project.basicTree
                    .get_checked()
                    .filter(function (item) {
                        return item != "pages";
                    }),
                grantedCompanyIds: userRoleSvc.getSelectedCompanyItems.call(vm.company).map(function (item) {
                    return item.id
                })
            }).then(function (result) {
                $uibModalInstance.close(result);
            });
        };
    }

    function getParentPrem(prem, data, arr) {
        if (!prem || arr.indexOf(prem) >= 0) {
            return;
        }

        arr.push(prem);
        var currentNode, item;
        for (item in data) {
            if (data[item].name == prem) {
                currentNode = data[item];
                break;
            }
        }
        if (currentNode && arr.indexOf(currentNode.parentName) <= -1) {
            getParentPrem(currentNode.parentName, data, arr);
        }
    }

    function userRoleTreeService() {
        // tree 初始化
        this.tree = function (data, selectedItems, dataMap, topNodeText) {
            var that = this;
            that.treeEventsObj = {
                ready: readyCB
            };
            that.basicConfig = {
                core: {
                    // 允许多选
                    multiple: true,
                    worker: true,
                    themes: {
                        responsive: false,
                        // 背景显示间纹
                        stripes: true
                    }
                },
                types: {
                    folder: {
                        icon: "ion-ios-folder"
                    },
                    default: {
                        icon: "ion-document-text"
                    }
                },
                plugins: ["types", "checkbox"], //,"contextmenu" 支持鼠标右键
                checkbox: {
                    keep_selected_style: false, //是否默认选中
                    three_state: true, //父子级别级联选择
                    // tie_selection: false,
                    whole_node: true
                },
                version: 1
            };
            if (data && data.length) {
                that.treeData = data.map(function (item) {
                    return dataMap(item, selectedItems, data);
                });
            } else {
                that.treeData = [];
            }

            that.treeData.push({
                id: "pages",
                parent: "#",
                type: "folder",
                text: topNodeText,
                state: { opened: true }
            });

            function readyCB(e, instance) {
                that.basicTree = instance.instance.element.jstree(true);
            }
        };

        this.company = function (dataItems, selectedItems) {
            dataItems = dataItems || [];
            selectedItems = selectedItems || [];
            var that = this,
                selectedItemsStr = ',' + selectedItems.join(',') + ',';
            angular.extend(that, {
                selectedAll: undefined,
                indeterminate: undefined,
                data: dataItems.map(function (item) {
                    return companyDataMap(item, selectedItems);
                }),
                selectedAllClick: function () {
                    angular.forEach(that.data, function (i, v) {
                        i.state.selected = that.selectedAll;
                    });
                },
                itemClick: function (isSelected) {
                    _getSelectedCompanyItems.call(that);
                }
            });

            _getSelectedCompanyItems.call(that);

            function companyDataMap(item, selectedItems) {
                return {
                    id: item.id,
                    name: item.name,
                    isGrantedByDefault: item.isGrantedByDefault,
                    state: {
                        selected: !!selectedItems && selectedItemsStr.indexOf("," + item.id + ",") != -1
                    }
                };
            }
        };

        // 获取选择的公司
        this.getSelectedCompanyItems = _getSelectedCompanyItems;

        this.premDataMap = function (item, selectedItems, data) {
            var selected = !!selectedItems && selectedItems.indexOf(item.name) != -1,
                // 如果是父节点，则父节点的选中状态必须设置为 false, 否则会导致没有选择的子节点也会被勾选
                isParentNode = data.filter(function (i) {
                    return i.parentName == item.name;
                }).length >= 1;

            if (isParentNode) {
                selected = false;
            }
            return {
                id: item.name,
                parent: item.parentName || "pages",
                type: !!item.parentName ? undefined : "folder",
                text: item.displayName,
                isGrantedByDefault: item.isGrantedByDefault,
                state: {
                    opened: true,
                    selected: selected
                }
            };
        };

        this.departmentDataMap = function (item, selectedItems) {
            return {
                id: item.id,
                parent: item.parentId || "pages",
                type: !!item.parentId ? undefined : "folder",
                text: item.displayName,
                isGrantedByDefault: item.isGrantedByDefault,
                state: {
                    opened: true,
                    selected: !!selectedItems && selectedItems.indexOf(item.id) != -1
                }
            };
        }

        this.projectDataMap = function (item, selectedItems) {
            return {
                id: item.id,
                parent: item.parentId || "pages",
                type: !!item.parentId ? undefined : "folder",
                text: item.displayName,
                isGrantedByDefault: item.isGrantedByDefault,
                state: {
                    opened: true,
                    selected: !!selectedItems && selectedItems.indexOf("," + item.id + ",") != -1
                }
            };
        }

        this.grantedPermissionNames = _grantedPermissionNames;

        function _grantedPermissionNames(prem, data, arr) {
            if (!prem || arr.indexOf(prem) >= 0) {
                return;
            }

            arr.push(prem);
            var currentNode, item;
            for (item in data) {
                if (data[item].name == prem) {
                    currentNode = data[item];
                    break;
                }
            }
            if (currentNode && arr.indexOf(currentNode.parentName) <= -1) {
                _grantedPermissionNames(currentNode.parentName, data, arr);
            }
        }

        function _getSelectedCompanyItems() {
            var that = this;
            var items = that.data.filter(function (item) {
                return item.state.selected === true;
            });

            $('#ck-all').prop('indeterminate', false);

            if (items.length == 0) {
                that.selectedAll = false;
            }
            else if (items.length == that.data.length) {
                that.selectedAll = true;
            } else {
                $('#ck-all').prop('indeterminate', true);
            }

            return items;
        };
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("RolesCtrl", RolesCtrl);

    RolesCtrl.$inject = [
        "dalogModal",
        "optionEnum",
        "abp.services.app.baseInfo",
        "abp.services.app.role",
        "toastr",
        "editableOptions",
        "editableThemes"
    ];

    /** @ngInject */
    function RolesCtrl(
        dalogModal,
        optionEnum,
        baseInfoSvc,
        roleSvc,
        toastr,
        editableOptions,
        editableThemes
    ) {
        var vm = this,
            displayedPages = 10;

        vm.search = {
            isActive: true,
            maxResultCount: 12
        };

        vm.onKeyup = function (e) {
            var keycode = window.event ? e.keyCode : e.which;
            if (keycode == 13) {
                vm.grid.selectPage(1);
            }
        };
        vm.onClear = function (searchKey) {
            vm.search[searchKey] = undefined;
            vm.grid.selectPage(1);
        };

        vm.grid = {
            gridData: [],
            addBtnDisabled: false,
            optionEnum: optionEnum,
            options: function (item, option) {
                var ctrlName = undefined,
                    templateUrl = "app/pages/settings/roles/roleModal.html";
                switch (option) {
                    case optionEnum.add:
                        ctrlName = "settingsRoleCtrl";
                        break;
                    case optionEnum.update:
                        ctrlName = "settingsRoleCtrl";
                        break;
                    case vm.grid.optionEnum.del:
                        roleSvc.delete({ id: item.id }).then(function (res) {
                            toastr.success("删除成功");
                            vm.grid.selectPage(vm.grid.tableState.pagination.pageindex);
                        });
                        return;
                    default:
                        return;
                }
                dalogModal.open({
                    templateUrl: templateUrl,
                    ctrlName: ctrlName,
                    size: "lg",
                    context: {
                        optionEnum: option,
                        item: item
                    },
                    callback: function (res) {
                        if (res === false) return;
                        vm.grid.selectPage(vm.grid.tableState.pagination.pageindex);
                    }
                });
            },
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: displayedPages,
                total: undefined
            },
            callServer: function (tableState) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                tableState.pagination.pageindex = pagination.start / pagination.number + 1;
                roleSvc.getRoles(vm.search).then(function (result) {
                    vm.grid.gridData = result.data.items;
                    tableState.pagination.totalItemCount = result.data.totalCount;
                    tableState.pagination.numberOfPages =
                        Math.ceil(result.data.totalCount / pagination.number) || 1;
                    vm.grid.addBtnDisabled = false;
                });
            },
            selectPage: function (pageIndex) {
                angular.element("st-pagination").isolateScope().selectPage(pageIndex);
            }
        };

        initDropdown();

        function initDropdown() {
            vm.dropdonw = {
                status: {}
            };

            init.call(vm.dropdonw.status, "isActive");

            function init(searchKey, apiName) {
                var that = this;

                if (!apiName) {
                    that.selectItems = [{ value: false, text: "禁用" }, { value: true, text: "启用" }];
                    that.selected = that.selectItems[1];
                } else {
                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });
                }

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        vm.grid.selectPage(1);
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.value : undefined;
                    vm.grid.selectPage(1);
                }
            }
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    }
})();

(function() {
    "use strict";

    angular.module("A56.pages.settings").controller("SubjectCtrl", SubjectCtrl);

    SubjectCtrl.$inject = ["abp.services.app.subjectSettings", "settingsTreeService", "$scope"];

    /** @ngInject */
    function SubjectCtrl(settingsSve, settingsTreeService, $scope) {
        var vm = this,
            newDataModel = {};

        function dataMap(item) {
            return {
                id: item.id,
                parent: item.parentId || "#",
                type: !!item.parentId ? undefined : "folder",
                position: item.position,
                text: item.name,
                code: item.code,
                comment: item.comment,
                level: item.level,
                processFlag: false,
                state: {
                    opened: true
                }
            };
        }

        settingsTreeService.init.call(vm, $scope, {
            maxlevel: 2,
            settingsSve: settingsSve,
            get: "getSubjectTree",
            singleSave: "processSubject",
            batchSave: "processSubjectList",
            deleteNode: "delete",
            dataMap: dataMap,
            newDataModel: newDataModel
        });
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("SaleTariffCtrl", SaleTariffCtrl);

    SaleTariffCtrl.$inject = [
        "$uibModal",
        "abp.services.app.baseInfo",
        "abp.services.app.clearing_W_Sale_Tariff",
        "toastr",
        'dalogModal'
    ];

    /** @ngInject */
    function SaleTariffCtrl($uibModal, baseInfoSvc, wSaleTariffSvc, toastr, dalogModal) {
        var vm = this,
            displayedPages = 10;

        vm.search = {
            isActive: true,
            maxResultCount: 12
        };

        initDropdown();
        // getData();

        vm.grid = {
            gridData: [],
            disabled: function (index) {
                var item = vm.grid.gridData[index];
                dalogModal
                    .confirm({
                        optionName: item.isActive ? '是否禁用' : "是否启用",
                        title: item.isActive ? "禁用" : '启用'
                    }).then(function (res) {
                        if (res) {
                            item.isActive = !item.isActive;
                            wSaleTariffSvc.updateActive({ id: item.id }).then(function (res) {
                                toastr.success("操作成功");
                                vm.grid.selectPage(1);
                            });
                        }
                    });
            },
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: displayedPages,
                total: undefined
            },
            callServer: function (tableState) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                wSaleTariffSvc.getAll(vm.search).then(function (result) {
                    vm.grid.gridData = result.data.items;
                    tableState.pagination.totalItemCount = result.data.totalCount;
                    tableState.pagination.numberOfPages =
                        Math.ceil(result.data.totalCount / pagination.number) || 1;
                });
            },
            selectPage: function (pageIndex) {
                angular.element("st-pagination").isolateScope().selectPage(pageIndex);
            }
        };

        // function getData() {
        //     wSaleTariffSvc.getAll(vm.search).then(function(result) {
        //         vm.grid.gridData = result.data.items;
        //     });
        // }

        /**
         * 因为【客户】【项目】【仓库】下拉列表是有级联关系
         * 当清空【客户】时，重新加载【项目】和【仓库】的数据源
         * 当清空 【项目】时，要判断【客户】是否有值，如果有则【仓库】只清空数据源，而不重新加载数据源，如果【客户】没值，则需要重新加载【仓库的数据源】
         */
        function initDropdown() {
            vm.dropdonw = {
                customer: {},
                project: {},
                warehouse: {},
                status: {}
            };

            init.call(vm.dropdonw.customer, "customerId", "getCustomerOptions", 0);
            init.call(vm.dropdonw.project, "projectId", "getProjectOptions", 1);
            init.call(vm.dropdonw.warehouse, "warehouseId", "getWarehouseOptions", 2);
            init.call(vm.dropdonw.status, "isActive");

            function init(searchKey, apiName, lavel) {
                var that = this;

                if (!apiName) {
                    that.selectItems = [{ id: false, text: "禁用" }, { id: true, text: "启用" }];
                    that.selected = that.selectItems[1];
                } else {
                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });
                }

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        clearSelect();
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.id : "";
                    switch (lavel) {
                        case 0:
                            clearProject();
                            clearWarehouse();
                            baseInfoSvc
                                .getProjectOptions({ customerId: that.selected.id })
                                .then(function (result) {
                                    vm.dropdonw.project.selectItems = result.data;
                                });
                            break;
                        case 1:
                            clearWarehouse();
                            baseInfoSvc
                                .getWarehouseOptions({ projectId: that.selected.id })
                                .then(function (result) {
                                    vm.dropdonw.warehouse.selectItems = result.data;
                                });
                            break;
                        case 2:
                            break;
                    }
                    // getData();
                    vm.grid.selectPage(1);
                }

                function clearSelect() {
                    vm.search[searchKey] = that.selected ? that.selected.id : undefined;
                    switch (lavel) {
                        case 0:
                            clearProject();
                            clearWarehouse();
                            baseInfoSvc.getProjectOptions({}).then(function (result) {
                                vm.dropdonw.project.selectItems = result.data;
                            });
                            baseInfoSvc.getWarehouseOptions({}).then(function (result) {
                                vm.dropdonw.warehouse.selectItems = result.data;
                            });
                            break;
                        case 1:
                            clearWarehouse();
                            if (!vm.search.customerId) {
                                baseInfoSvc.getWarehouseOptions({}).then(function (result) {
                                    vm.dropdonw.warehouse.selectItems = result.data;
                                });
                            }
                            break;
                        case 2:
                            break;
                    }
                    // getData();
                    vm.grid.selectPage(1);
                }
            }

            function clearProject() {
                vm.search.projectId = undefined;
                vm.dropdonw.project.selectItems = [];
                vm.dropdonw.project.selected = undefined;
            }

            function clearWarehouse() {
                vm.search.warehouseId = undefined;
                vm.dropdonw.warehouse.selectItems = [];
                vm.dropdonw.warehouse.selected = undefined;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("SaleTariffDetailCtrl", SaleTariffDetailCtrl);

    SaleTariffDetailCtrl.$inject = [
        "dalogModal",
        "$state",
        "$uibModal",
        "abp.services.app.baseInfo",
        "abp.services.app.clearing_W_Sale_Tariff",
        "$stateParams",
        "toastr",
        "settingsModelNav"
    ];

    /** @ngInject */
    function SaleTariffDetailCtrl(dalogModal, $state, $uibModal, baseInfoSvc, wSaleTariffSvc, $stateParams, toastr, settingsModelNav) {
        var vm = this,
            isCreate = !!!$stateParams.id,
            gridDropdownSource = {},
            optionEnum = { add: 1, addName: '添加', update: 2, updateName: '编辑' },
            // 订单费// 仓储费// 周期性费用// 储位寄存费
            GridType = { order: 1, stock: 2, cycleCharge: 3, stockCell: 4 },
            // 订单费 // 仓储费 // 周期费 // 储位费
            groupCodeEnum = { order: 1, stock: 4, cycleCharge: 6, stockCell: 7 };

        vm.search = { isActive: true };
        vm.model = {};
        vm.myForm = "myForm";
        vm.order = {
            tdTemplateUrl: "app/pages/settings/saleTariff/widgets/table.td.order.html",
            title: "订单",
            tableHeaders: ["科目", "服务项目", "费率(元)", "单位", "说明", "操作"], //"商品名称","订单类型",  "显示单位",'最低价格', "最低数量",
            grid: { dropdown: { subject: {}, rule: {}, priceRate: {} } }
        };

        vm.stock = {
            tdTemplateUrl: "app/pages/settings/saleTariff/widgets/table.td.stock.html",
            title: "仓储",
            tableHeaders: ["科目", "服务项目", "费率(元)", "单位", "频率", "说明", "操作"], //"商品名称",  "显示单位",'最低价格', "最低数量",  "应用峰值",
            grid: { dropdown: { subject: {}, rule: {}, priceRate: {} } }
        };

        vm.cycleCharge = {
            tdTemplateUrl: "app/pages/settings/saleTariff/widgets/table.td.cycleCharge.html",
            title: "周期",
            tableHeaders: ["科目", "服务项目", "费率(元)", "单位", '数量', "频率", "说明", "操作"], // "显示单位",
            grid: { dropdown: { subject: {}, rule: {}, priceRate: {} } }
        };

        vm.stockCell = {
            tdTemplateUrl: "app/pages/settings/saleTariff/widgets/table.td.stockCell.html",
            title: "储位",
            tableHeaders: ["科目", "服务项目", "费率(元)", "单位", "频率", "说明", "操作"], //"商品名称","基数", "增幅",  "显示单位","应用峰值",
            grid: { dropdown: { subject: {}, rule: {}, priceRate: {} } }
        };

        vm.groupTypeEnum = [
            { key: 0, text: '全部' },
            { key: 1, text: '入库' },
            { key: 2, text: '出库' },
        ];

        vm.isApplyMaxQtyEnum = [
            { key: true, text: '是' },
            { key: false, text: '否' }
        ];

        vm.priceRateEnum = [
            { key: 0, text: '无' },
            { key: 1, text: '天' },
            { key: 2, text: '月' }
        ];

        vm.submitDate = function () {
            if (vm.myForm) {
                vm.myForm.$setSubmitted(true);
                if (!vm.myForm.$valid) {
                    toastr.warning("请完善必填信息");
                    return;
                }
                if (!vm.order.grid.gridData.length) {
                    toastr.warning("请添加详情信息 ");
                    return;
                }
            }
            vm.model.orderSaleRules = vm.order.grid.gridData;
            vm.model.cycleCharges = vm.cycleCharge.grid.gridData;
            vm.model.stockSaleRules = vm.stock.grid.gridData;
            vm.model.stockCellSaleRules = vm.stockCell.grid.gridData;

            if (isCreate) {
                wSaleTariffSvc.create(vm.model).then(function (result) {
                    toastr.success("创建成功");
                    $state.go("Settings.SaleTariffDetail", { id: result.data.id }, { location: "replace" });
                });
            } else {
                wSaleTariffSvc.update(vm.model).then(function (result) {
                    toastr.success("修改成功");
                    getData();
                });
            }
        };

        initDatepicker.call(vm, "datepickerBegin");
        initDatepicker.call(vm, "datepickerEnd");
        // 订单费
        initGrid.call(vm.order.grid, GridType.order);
        // 仓储费
        initGrid.call(vm.stock.grid, GridType.stock);
        // 周期费
        initGrid.call(vm.cycleCharge.grid, GridType.cycleCharge);
        // 储位寄存费
        initGrid.call(vm.stockCell.grid, GridType.stockCell);

        // 根据 url 参数加数 model 数据
        if (!isCreate) {
            getData();
        } else {
            initDropdown();
        }

        function getGridModel(type) {
            return { ruleId: null, ruleName: "", isActive: true, isAddNew: true };
        }

        function initGrid(gridType) {
            var that = this;
            angular.extend(that, {
                gridData: [],
                addBtnDisabled: false,
                inserted: {},
                add: function () {
                    openModal.call(that, optionEnum.add, getGridModel(gridType), gridType);
                },
                update: function (item) {
                    openModal.call(that, optionEnum.update, item, gridType);
                },
                disabled: function (index) {
                    var item = that.gridData[index];
                    dalogModal
                        .confirm({
                            context: item.name,
                            optionName: item.isActive ? '是否禁用' : "是否启用",
                            title: item.isActive ? "禁用" : '启用'
                        }).then(function (res) {
                            if (res) {
                                item.isActive = !item.isActive;
                            }
                        });
                }
            });
        }

        function initGridDropdown(apiName, params, flag) {
            var that = this,
                key = apiName + (flag || '');
            if (!gridDropdownSource[key]) {
                params = params || {};
                baseInfoSvc[apiName](params).then(function (result) {
                    that.data = result.data;
                    gridDropdownSource[key] = result.data;
                    if (that.onDataSourceLoaded) {
                        that.onDataSourceLoaded(that.data, that);
                    }
                });
            } else {
                that.data = gridDropdownSource[key];
                if (that.onDataSourceLoaded) {
                    that.onDataSourceLoaded(that.data, that);
                }
            }
        }

        function getData(isInit) {
            wSaleTariffSvc
                .getDetail({
                    id: $stateParams.id,
                    isActive: vm.search.isActive
                })
                .then(function (result) {
                    vm.model = result.data;
                    vm.order.grid.gridData = vm.model.orderSaleRules;
                    vm.stock.grid.gridData = vm.model.stockSaleRules;
                    vm.cycleCharge.grid.gridData = vm.model.cycleCharges;
                    vm.stockCell.grid.gridData = vm.model.stockCellSaleRules;
                    if (vm.model.validityFrom) {
                        vm.model.validityFrom = new Date(Date.parse(vm.model.validityFrom));
                    }
                    if (vm.model.validityTo) {
                        vm.model.validityTo = new Date(Date.parse(vm.model.validityTo));
                    }
                    if (isInit !== false) {
                        initDropdown();
                    }
                });
        }

        function initDatepicker(key) {
            var that = this;
            that[key] = {
                open: function () {
                    that[key].opened = true;
                },
                opened: false,
                format: "yyyy-MM-dd",
                options: { showWeeks: false, minMode: "day" },
                dateChanged: function (e) { }
            };
        }
        // // 启用// 禁用 // 所有
        // settingsModelNav.initNav.call(vm, { active: 0, disabled: 1, all: 2 }, onMenuClick);
        // vm.currentMenu = vm.menu.active;
        // function onMenuClick(cMenu, menu) {
        //     switch (cMenu) {
        //         case menu.active:
        //             vm.search.isActive = true;
        //             break;
        //         case menu.disabled:
        //             vm.search.isActive = false;
        //             break;
        //         case menu.all:
        //             vm.search.isActive = undefined;
        //             break;
        //     }
        //     getData(false);
        // }
        initSearchDropdown();
        function initSearchDropdown() {
            vm.dropdonw = vm.dropdonw || {};
            vm.dropdonw.status = {};
            init.call(vm.dropdonw.status, "isActive");

            function init(searchKey, apiName) {
                var that = this;

                that.selectItems = [{ id: false, text: "禁用" }, { id: true, text: "启用" }];
                that.selected = that.selectItems[1];

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        clearSelect();
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.id : undefined;
                    getData(false);
                }

                function clearSelect() {
                    vm.search[searchKey] = that.selected ? that.selected.id : undefined;
                    getData(false);
                }
            }
        }

        function initDropdown() {
            vm.dropdown = vm.dropdown || {};
            vm.dropdown.customer = {};
            vm.dropdown.project = {};
            vm.dropdown.warehouse = {};
            if (isCreate) {
                init.call(vm.dropdown.customer, "customerId", "customerName", "getCustomerOptions", 0);
                init.call(vm.dropdown.project, "projectId", "projectName", "getProjectOptions", 1);
                init.call(vm.dropdown.warehouse, "warehouseId", "warehouseName", "getWarehouseOptions", 2);
            } else {
                baseInfoSvc.getCustomerOptions({}).then(function (result) {
                    vm.dropdown.customer.selectItems = result.data;
                    if (!vm.dropdown.customer.onSelected) {
                        init.call(vm.dropdown.customer, "customerId", "customerName", null, 0);
                    }
                    // 触发 onCustomerChange 事件，以加载 project 数据源
                    triggerNextLavel.call(vm.dropdown.customer, result.data, vm.model.customerId, onCustomerChange, vm.model.projectId, true);
                });
            }

            function init(modelIdKey, modelNameKey, apiName, lavel) {
                var that = this;

                if (lavel === 0 && apiName) {
                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });
                }

                var change;
                switch (lavel) {
                    case 0:
                        change = onCustomerChange;
                        break;
                    case 1:
                        change = onProjectChange;
                        break;
                    case 2:
                        break;
                }

                angular.extend(that, {
                    onSelected: onSelectChange,
                    clearSelected: function () {
                        that.selected = undefined;
                        switch (lavel) {
                            case 0:
                                // 清空 project 和 warehouse
                                clearProjectDataSource();
                                clearWarehouseDataSource();
                                break;
                            case 1:
                                // 清空 warehouse
                                clearWarehouseDataSource();
                                break;
                            case 2:
                                break;
                        }
                    }
                });

                function onSelectChange(item, model) {
                    vm.model[modelIdKey] = that.selected ? that.selected.id : null;
                    vm.model[modelNameKey] = that.selected ? that.selected.name : null;
                    if (change) change();
                }
            }

            function onCustomerChange(selectedValue) {
                // 清空 project 和 warehouse
                clearProjectDataSource();
                clearWarehouseDataSource();
                // 根据 customerId 加 project
                baseInfoSvc
                    .getProjectOptions({ customerId: vm.dropdown.customer.selected.id })
                    .then(function (result) {
                        vm.dropdown.project.selectItems = result.data;
                        if (!vm.dropdown.project.onSelected) {
                            init.call(vm.dropdown.project, "projectId", "projectName", null, 1);
                        }
                        // 触发 onProjectChange 事件，以加载 warehouse 数据源
                        triggerNextLavel.call(vm.dropdown.project, result.data, selectedValue, onProjectChange, vm.model.warehouseId, true);
                    });
            }

            function onProjectChange(selectedValue) {
                // 清空 warehouse
                clearWarehouseDataSource();
                // 根据 projectId 加 warehouse
                baseInfoSvc
                    .getWarehouseOptions({ projectId: vm.dropdown.project.selected.id })
                    .then(function (result) {
                        vm.dropdown.warehouse.selectItems = result.data;
                        if (!vm.dropdown.warehouse.onSelected) {
                            init.call(vm.dropdown.warehouse, "warehouseId", "warehouseName", null, 2);
                        }
                        // 设置 warehouse 选择的值
                        triggerNextLavel.call(vm.dropdown.warehouse, result.data, selectedValue, null, null, false);
                    });
            }

            function clearProjectDataSource() {
                vm.dropdown.project.selectItems = [];
                vm.dropdown.project.selected = undefined;
            }

            function clearWarehouseDataSource() {
                vm.dropdown.warehouse.selectItems = [];
                vm.dropdown.warehouse.selected = undefined;
            }

            // 设置 dropdown 初始值，并加载下一级 dropdown 数据源
            function triggerNextLavel(data, selectedValue, fn, fnParams, hasNext) {
                var that = this;
                if (selectedValue) {
                    var t = data.filter(function (item) {
                        return item.id == selectedValue;
                    });
                    if (t.length) {
                        that.selected = t[0];
                        if (hasNext) fn(fnParams);
                    }
                }
            }
        }

        function openModal(option, item, gridType) {
            var that = this,
                includeTemp = '',
                ctrlName = '',
                modalTitle = '',
                groupCode;

            switch (gridType) {
                case GridType.order:
                    modalTitle = ' - 订单';
                    includeTemp = "app/pages/settings/saleTariff/modalForm/modal.form.order.html";
                    ctrlName = 'ModalFormOrderCtrl';
                    groupCode = groupCodeEnum.order;
                    break;
                case GridType.stock:
                    modalTitle = ' - 仓储';
                    includeTemp = "app/pages/settings/saleTariff/modalForm/modal.form.stock.html";
                    ctrlName = 'ModalFormStockCtrl';
                    groupCode = groupCodeEnum.stock;
                    break;
                case GridType.cycleCharge:
                    modalTitle = ' - 周期';
                    includeTemp = "app/pages/settings/saleTariff/modalForm/modal.form.cycleCharge.html";
                    ctrlName = 'ModalFormCycleChargeCtrl';
                    groupCode = groupCodeEnum.cycleCharge;
                    break;
                case GridType.stockCell:
                    modalTitle = ' - 储位';
                    includeTemp = "app/pages/settings/saleTariff/modalForm/modal.form.stockCell.html";
                    ctrlName = 'ModalFormStockCellCtrl';
                    groupCode = groupCodeEnum.stockCell;
                    break;
            }

            dalogModal.open({
                templateUrl: "app/theme/components/modalForm/modal.form.html",
                ctrlName: ctrlName,
                size: "lg",
                context: {
                    optionEnum: angular.extend({}, optionEnum, {
                        addName: optionEnum.addName + modalTitle, updateName: optionEnum.updateName + modalTitle
                    }),
                    modalEnum: GridType,
                    currentModal: gridType,
                    currentOption: option,
                    model: angular.extend({}, item),
                    dropdown: that.dropdown,
                    includeTemp: includeTemp
                },
                callback: function (res) {
                    if (res === false) return;
                    if (option == optionEnum.add) {
                        that.gridData.unshift(res);
                    } else {
                        angular.extend(item, res);
                    }
                }
            }).opened.then(function () {
                initGridDropdown.call(that.dropdown.rule, "getWRuleOptions", { groupCode: groupCode }, groupCode);
                initGridDropdown.call(that.dropdown.subject, "getSubjectOptions");
            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("settingsUserInfoCtrl", settingsUserInfoCtrl);

    settingsUserInfoCtrl.$inject = [
        "$uibModalInstance",
        "context",
        "optionEnum",
        "settingsModelNav",
        "abp.services.app.user",
        'settings.userRole.Service',
        "toastr"
    ];

    /** @ngInject */
    function settingsUserInfoCtrl(
        $uibModalInstance,
        context,
        optionEnum,
        settingsModelNav,
        userSvc,
        userRoleSvc,
        toastr
    ) {
        var vm = this;
        vm.model = {};
        vm.myForm = "myForm";
        vm.company = {};
        vm.tree = {
            prem: {},
            department: {},
            project: {}
        };

        settingsModelNav.initNav.call(vm, {
            // 用户信息
            userInfo: 0,
            // 角色
            role: 1,
            // 权限
            prem: 2,
            // 部门
            department: 3,
            // 项目
            project: 4,
            // 公司
            company: 5
        });
        vm.currentMenu = vm.menu.userInfo;

        switch (context.optionEnum) {
            case optionEnum.add:
                vm.title = optionEnum.addName;
                break;
            case optionEnum.update:
                vm.title = optionEnum.updateName + "：" + context.item.userName;
                break;
            case optionEnum.permName:
                vm.title = optionEnum.permName + "：" + context.item.userName;
                break;
        }

        var userId = !!context.item ? context.item.id : undefined;
        userSvc.getUserForEdit({ id: userId }).then(function (result) {
            vm.model = result.data;
            if (!vm.model.user) {
                vm.model.user = {};
            }
            vm.model.user.passwordConfirm = "";
            vm.model.user.password = "";

            userRoleSvc.tree.call(
                vm.tree.prem,
                vm.model.permissions,
                vm.model.grantedPermissionNames,
                userRoleSvc.premDataMap,
                "权限"
            );
            userRoleSvc.tree.call(
                vm.tree.department,
                vm.model.departments,
                vm.model.grantedDepartmentIds,
                userRoleSvc.departmentDataMap,
                "部门"
            );
            userRoleSvc.tree.call(
                vm.tree.project,
                vm.model.projects,
                !vm.model.grantedProjectIds ? "" : "," + vm.model.grantedProjectIds.join(",") + ",",
                userRoleSvc.projectDataMap,
                "项目"
            );
            userRoleSvc.company.call(vm.company, vm.model.companies, vm.model.grantedCompanyIds);
        });

        vm.cancel = function () {
            $uibModalInstance.close(false);
        };

        vm.ok = function () {
            if (vm.myForm) {
                vm.myForm.$setSubmitted(true);
                if (
                    !vm.myForm.$valid ||
                    // 两次密码输入不一致
                    vm.model.user.passwordConfirm != vm.model.user.password
                ) {
                    toastr.warning("请完善必填信息");
                    return;
                }
            }
            vm.model.assignedRoleNames = vm.model.roles
                .filter(function (item) {
                    return item.isAssigned === true;
                }).map(function (item) {
                    return item.roleName;
                });

            var grantedPermissionNames = [],
                res = vm.tree.prem.basicTree.get_checked().filter(function (item) {
                    return item != "pages";
                });
            angular.forEach(res, function (v, i) {
                userRoleSvc.grantedPermissionNames(v, vm.model.permissions, grantedPermissionNames);
            });

            vm.model.grantedPermissionNames = grantedPermissionNames;
            vm.model.grantedDepartmentIds = vm.tree.department.basicTree
                .get_checked()
                .filter(function (item) {
                    return item != "pages";
                });
            vm.model.grantedProjectIds = vm.tree.project.basicTree
                .get_checked()
                .filter(function (item) {
                    return item != "pages";
                });
            vm.model.grantedCompanyIds = userRoleSvc.getSelectedCompanyItems.call(vm.company).map(function (item) {
                return item.id
            });
            userSvc.createOrUpdateUser(vm.model).then(function (result) {
                $uibModalInstance.close(result);
            });
        };
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").service("settingsModelNav", settingsModelNav);

    angular.module("A56.pages.settings").constant("optionEnum", {
        addName: "添加用户",
        add: 1,
        updateName: "编辑用户",
        update: 2,
        permName: "权限设置",
        perm: 3,
        unlock: 4,
        del: 5,
        // 禁用、启用
        active: 6
    });

    /** @ngInject */
    function settingsModelNav() {
        this.initNav = function (menu, onClick) {
            var ctrl = this;
            ctrl.menu = menu;
            ctrl.menuClick = function (cMenu) {
                ctrl.currentMenu = cMenu;
                if (angular.isFunction(onClick)) {
                    onClick(cMenu, menu);
                }
            };
        };
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("UsersCtrl", UsersCtrl);

    UsersCtrl.$inject = [
        "dalogModal",
        "optionEnum",
        "abp.services.app.baseInfo",
        "abp.services.app.user",
        "toastr",
        "editableOptions",
        "editableThemes"
    ];

    /** @ngInject */
    function UsersCtrl(
        dalogModal,
        optionEnum,
        baseInfoSvc,
        userSvc,
        toastr,
        editableOptions,
        editableThemes
    ) {
        var vm = this,
            displayedPages = 10;

        vm.search = {
            isActive: true,
            maxResultCount: 12
        };

        vm.onKeyup = function (e) {
            var keycode = window.event ? e.keyCode : e.which;
            if (keycode == 13) {
                vm.grid.selectPage(1);
            }
        };
        vm.onClear = function (searchKey) {
            vm.search[searchKey] = undefined;
            vm.grid.selectPage(1);
        };

        vm.grid = {
            gridData: [],
            addBtnDisabled: false,
            optionEnum: optionEnum,
            options: function (item, option) {
                var ctrlName = undefined,
                    templateUrl = "app/pages/settings/users/userModal.html";
                switch (option) {
                    case optionEnum.add:
                        ctrlName = "settingsUserInfoCtrl";
                        break;
                    case optionEnum.update:
                        ctrlName = "settingsUserInfoCtrl";
                        break;
                    case optionEnum.perm:
                        ctrlName = "";
                        break;
                    case vm.grid.optionEnum.unlock:
                        return;
                    case vm.grid.optionEnum.del:
                        dalogModal
                            .confirm({}).then(function (res) {
                                if (res) {
                                    userSvc.delete({ id: item.id }).then(function (res) {
                                        toastr.success("删除成功");
                                        vm.grid.selectPage(vm.grid.tableState.pagination.pageindex);
                                    });
                                }
                            });
                        return;
                    case vm.grid.optionEnum.active:
                        dalogModal
                            .confirm({
                                optionName: item.isActive ? '是否禁用' : "是否启用",
                                title: item.isActive ? "禁用" : '启用'
                            }).then(function (res) {
                                if (res) {
                                    item.isActive = !item.isActive;
                                    userSvc.update(item).then(function (res) {
                                        toastr.success("操作成功");
                                        vm.grid.selectPage(1);
                                    });
                                }
                            });
                        return;
                    default:
                        return;
                        break;
                }
                dalogModal.open({
                    templateUrl: templateUrl,
                    ctrlName: ctrlName,
                    size: "lg",
                    context: {
                        optionEnum: option,
                        item: item
                    },
                    callback: function (res) {
                        if (res === false) return;
                        vm.grid.selectPage(vm.grid.tableState.pagination.pageindex);
                    }
                });
            },
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: displayedPages,
                total: undefined
            },
            callServer: function (tableState) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                tableState.pagination.pageindex = pagination.start / pagination.number + 1;
                userSvc.getUsers(vm.search).then(function (result) {
                    vm.grid.gridData = result.data.items; //users.result.items; //
                    tableState.pagination.totalItemCount = result.data.totalCount;
                    tableState.pagination.numberOfPages =
                        Math.ceil(result.data.totalCount / pagination.number) || 1;
                    vm.grid.addBtnDisabled = false;
                });
            },
            selectPage: function (pageIndex) {
                angular.element("st-pagination").isolateScope().selectPage(pageIndex);
            }
        };

        initDropdown();

        function initDropdown() {
            vm.dropdonw = {
                status: {},
                role: {}
                // permission:{}
            };

            init.call(vm.dropdonw.status, "isActive");
            // init.call(vm.dropdonw.permission, "permissionName", "getProjectOptions", 1);
            init.call(vm.dropdonw.role, "roleId", "getRoleOptions", 1);

            function init(searchKey, apiName) {
                var that = this;

                if (!apiName) {
                    that.selectItems = [{ id: false, text: "禁用" }, { id: true, text: "启用" }];
                    that.selected = that.selectItems[1];
                } else {
                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });
                }

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        vm.grid.selectPage(1);
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.id : undefined;
                    vm.grid.selectPage(1);
                }
            }
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("WarehouseCtrl", WarehouseCtrl);

    WarehouseCtrl.$inject = [
        "$uibModal",
        "abp.services.app.baseInfo",
        "abp.services.app.warehouseSettings",
        "toastr",
        "editableOptions",
        "editableThemes",
        'dalogModal'
    ];

    /** @ngInject */
    function WarehouseCtrl($uibModal, baseInfoSvc, warehouseSettingsSvc, toastr, editableOptions, editableThemes, dalogModal) {
        var vm = this,
            displayedPages = 10;

        vm.search = {
            isActive: true,
            maxResultCount: 12
        };

        vm.onKeyup = function (e) {
            var keycode = window.event ? e.keyCode : e.which;
            if (keycode == 13) {
                vm.grid.selectPage(1);
            }
        };
        vm.onClear = function (searchKey) {
            vm.search[searchKey] = undefined;
            vm.grid.selectPage(1);
        };

        vm.grid = {
            gridData: [],
            addBtnDisabled: false,
            cancel: function (index, item, rowform) {
                if (!item.id) {
                    vm.grid.gridData.splice(index, 1);
                }
                rowform.$cancel();
                vm.grid.addBtnDisabled = false;
            },
            add: function () {
                vm.grid.addBtnDisabled = true;
                vm.grid.inserted = {
                    code: undefined,
                    comment: undefined,
                    creationTime: undefined,
                    departmentId: undefined,
                    departmentName: "",
                    employeeId: undefined,
                    employeeName: "",
                    id: undefined,
                    name: undefined,
                    isActive: true
                };
                vm.grid.gridData.unshift(vm.grid.inserted);
            },
            update: function (index, data, item) {
                angular.extend(item, data);
                var apiName = "create",
                    msg = "创建成功！";
                if (item.id) {
                    apiName = "update";
                    msg = "更新成功！";
                }
                warehouseSettingsSvc[apiName](item).then(function (result) {
                    toastr.success(msg);
                    vm.grid.selectPage(1);
                });
            },
            disabled: function (index) {
                var item = vm.grid.gridData[index];
                dalogModal
                    .confirm({
                        context: item.name,
                        optionName: item.isActive ? '是否禁用仓库：' : "是否启用仓库：",
                        title: item.isActive ? "禁用" : '启用'
                    }).then(function (res) {
                        if (res) {
                            item.isActive = !item.isActive;
                            warehouseSettingsSvc.update(item).then(function (res) {
                                toastr.success("禁用成功");
                                vm.grid.selectPage(1);
                            });
                        }
                    });
            },
            checkTempEmpty: function (data, rowform) {
                if (data == null || data == undefined || (!angular.isNumber(data) && data == ""))
                    return "*";
            },
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: displayedPages,
                total: undefined
            },
            callServer: function (tableState) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                warehouseSettingsSvc.getAll(vm.search).then(function (result) {
                    vm.grid.gridData = result.data.items;
                    tableState.pagination.totalItemCount = result.data.totalCount;
                    tableState.pagination.numberOfPages =
                        Math.ceil(result.data.totalCount / pagination.number) || 1;
                    vm.grid.addBtnDisabled = false;
                });
            },
            selectPage: function (pageIndex) {
                angular.element("st-pagination").isolateScope().selectPage(pageIndex);
            },
            dropdown: {
                department: {}
            },
            typeahead: {
                employee: {}
            },
            radioList: {
                status: {
                    data: [{ value: true, text: "启用" }, { value: false, text: "禁用" }]
                }
            }
        };

        initGridDropdown.call(
            vm.grid.dropdown.department,
            "getDepartmentOptions",
            "departmentId",
            "departmentName",
            "departmentSelected"
        );

        initGridTypeahead.call(
            vm.grid.typeahead.employee,
            "getEmployeeOptions",
            "employeeId",
            "employeeName",
            "employeeSelected"
        );

        initDropdown();

        function initGridDropdown(apiName, feildKey, feildText, selectedKey) {
            var that = this;
            angular.extend(that, {
                data: [],
                onShow: function () {
                    if (!that.data.length) {
                        baseInfoSvc[apiName]({}).then(function (result) {
                            that.data = result.data;
                        });
                    }
                },
                onChange: function (data, item) {
                    // item[selectedKey] = data;
                    item[feildKey] = data.id;
                    item[feildText] = data.name;
                }
            });
        }

        function initGridTypeahead(apiName, feildKey, feildText, selectedKey) {
            var that = this;
            angular.extend(that, {
                data: [],
                onInput: function ($data) {
                    var arr = that.data.filter(function (item) {
                        return item && item.name && item.name.indexOf($data) != -1;
                    });
                    if (!arr.length) {
                        baseInfoSvc[apiName]({ name: $data }).then(function (result) {
                            that.data = result.data;
                        });
                    }
                },
                onSelect: function ($item, $model, $label, dataItem) {
                    // dataItem[selectedKey] = $item;
                    dataItem[feildKey] = $model.id;
                    dataItem[feildText] = $label;
                }
            });
        }

        function initDropdown() {
            vm.dropdonw = {
                status: {}
            };

            init.call(vm.dropdonw.status, "isActive");

            function init(searchKey, apiName) {
                var that = this;

                // baseInfoSvc[apiName]({}).then(function(result) {
                //     that.selectItems = result.data;
                // });
                that.selectItems = [{ value: false, text: "禁用" }, { value: true, text: "启用" }];
                that.selected = that.selectItems[1];

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        vm.grid.selectPage(1);
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.value : undefined;
                    vm.grid.selectPage(1);
                }
            }
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settleAccount").service("CustomerDetailCtrl", CustomerDetail);

    CustomerDetail.$inject = ["abp.services.app.clearingReport", "abp.services.app.baseInfo"];

    /** @ngInject */
    function CustomerDetail(settlementSvc, baseInfoSvc) {

        this.apply = function () {
            var vm = this;
            vm.search = { ids: [], year: new Date().getFullYear() };
            vm.data = [];
            vm.datepicker = {
                model: new Date(),
                open: function () {
                    vm.datepicker.opened = true;
                },
                opened: false,
                format: "yyyy",
                options: {
                    showWeeks: false,
                    minMode: "year"
                },
                dateChanged: function (e) {
                    vm.search.year = vm.datepicker.model.getFullYear();
                    // getData();
                }
            };

            vm.onRepeat = function (i, item, arr) {
                // 获取上一行数组的索引
                var preIndex = i - 1 < 0 ? 0 : i - 1;
                // 获取上下单元格要合并的行数
                if (i == 0 || arr[preIndex].customerCode != item.customerCode) {
                    return {
                        isShow: true,
                        rowspan: arr.filter(function (arg) {
                            return arg.customerCode == item.customerCode;
                        }).length
                    };
                }
                return {
                    isShow: false,
                    rowspan: 0
                };
            };

            vm.refresh = getData;

            initDropdown();
            // getData();

            function getData() {
                settlementSvc.getCtRevenueDetails(vm.search).then(function (result) {
                    vm.data = [];
                    result.data.forEach(function (element) {
                        element.items.forEach(function (item) {
                            vm.data.push({
                                customerCode: element.code,
                                customerId: element.id,
                                customerName: element.name,
                                projectCode: item.code,
                                projectId: item.id,
                                projectName: item.name,
                                revenueTotal: item.revenueTotal,
                                revenueJan: item.revenueJan,
                                revenueFeb: item.revenueFeb,
                                revenueMar: item.revenueMar,
                                revenueApr: item.revenueApr,
                                revenueMay: item.revenueMay,
                                revenueJun: item.revenueJun,
                                revenueJul: item.revenueJul,
                                revenueAug: item.revenueAug,
                                revenueSep: item.revenueSep,
                                revenueOct: item.revenueOct,
                                revenueNov: item.revenueNov,
                                revenueDec: item.revenueDec
                            });
                        });
                    });
                });
            }

            function initDropdown() {
                vm.dropdown = {
                    customer: {}
                };

                init.call(vm.dropdown.customer, "ids", "getCustomerOptions");

                function init(searchKey, apiName) {
                    var that = this;

                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });

                    angular.extend(that, {
                        onSelected: selectedChange,
                        onRemove: selectedChange,
                        clearSelected: function () {
                            vm.search[searchKey] = [];
                            that.selected = undefined;
                            // getData();
                        }
                    });

                    function selectedChange($item, $model) {
                        vm.search[searchKey] = that.selected
                            ? that.selected.map(function (item) {
                                return item.id;
                            })
                            : undefined;
                        // getData();
                    }
                }
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settleAccount").service("CustomerTotalCtrl", CustomerTotal);

    CustomerTotal.$inject = ["abp.services.app.clearingReport", "abp.services.app.baseInfo"];

    /** @ngInject */
    function CustomerTotal(settlementSvc, baseInfoSvc) {
        this.apply = function () {
            var vm = this;
            vm.search = { ids: [], year: new Date().getFullYear() };
            vm.data = [];
            vm.onRepeat = function (i, item, arr) {
                // 获取上一行数组的索引
                var preIndex = i - 1 < 0 ? 0 : i - 1;
                // 获取上下单元格要合并的行数
                if (i == 0 || arr[preIndex].customerCode != item.customerCode) {
                    return {
                        isShow: true,
                        rowspan: arr.filter(function (arg) {
                            return arg.customerCode == item.customerCode;
                        }).length
                    };
                }
                return {
                    isShow: false,
                    rowspan: 0
                };
            };
            vm.refresh = getData;
            initDropdown();
            // getData();

            function getData() {
                settlementSvc.ctSettlement(vm.search.ids).then(function (result) {
                    vm.data = [];
                    result.data.forEach(function (element) {
                        element.items.forEach(function (item) {
                            vm.data.push({
                                customerCode: element.code,
                                customerId: element.id,
                                customerName: element.name,
                                projectCode: item.code,
                                projectId: item.id,
                                projectName: item.name,
                                revenueCD: item.revenueCD,
                                revenueCM: item.revenueCM,
                                revenueCY: item.revenueCY
                            });
                        });
                    });
                });
            }

            function initDropdown() {
                vm.dropdown = { customer: {} };

                init.call(vm.dropdown.customer, "ids", "getCustomerOptions");

                function init(searchKey, apiName) {
                    var that = this;

                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });

                    angular.extend(that, {
                        onSelected: selectedChange,
                        onRemove: selectedChange,
                        clearSelected: function () {
                            vm.search[searchKey] = [];
                            that.selected = undefined;
                            // getData();
                        }
                    });

                    function selectedChange($item, $model) {
                        vm.search[searchKey] = that.selected
                            ? that.selected.map(function (item) {
                                return { id: item.id };
                            })
                            : undefined;
                        // getData();
                    }
                }
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settleAccount").service("DepartmentDetailCtrl", DepartmentDetail);

    DepartmentDetail.$inject = ["abp.services.app.clearingReport", "abp.services.app.baseInfo"];

    /** @ngInject */
    function DepartmentDetail(settlementSvc, baseInfoSvc) {

        this.apply = function () {
            var vm = this;
            vm.search = { ids: [], year: new Date().getFullYear() };
            vm.data = [];
            vm.datepicker = {
                model: new Date(),
                open: function () {
                    vm.datepicker.opened = true;
                },
                opened: false,
                format: "yyyy",
                options: {
                    showWeeks: false,
                    minMode: "year"
                },
                dateChanged: function (e) {
                    vm.search.year = vm.datepicker.model.getFullYear();
                    // getData();
                }
            };
            vm.refresh = getData;
            initDropdown();
            // getData();

            function getData() {
                settlementSvc.getDpRevenueDetails(vm.search).then(function (result) {
                    vm.data = result.data;
                });
            }

            function initDropdown() {
                vm.dropdown = {
                    department: {}
                };

                init.call(vm.dropdown.department, "ids", "getDepartmentOptions");

                function init(searchKey, apiName) {
                    var that = this;

                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });

                    angular.extend(that, {
                        onSelected: selectedChange,
                        onRemove: selectedChange,
                        clearSelected: function () {
                            vm.search[searchKey] = [];
                            that.selected = undefined;
                            // getData();
                        }
                    });

                    function selectedChange($item, $model) {
                        vm.search[searchKey] = that.selected
                            ? that.selected.map(function (item) {
                                return item.id;
                            })
                            : undefined;
                        // getData();
                    }
                }
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settleAccount").service("DepartmentTotalCtrl", DepartmentTotal);

    DepartmentTotal.$inject = ["abp.services.app.baseInfo", "abp.services.app.clearingReport"];

    /** @ngInject */
    function DepartmentTotal(baseInfoSvc, settlementSvc) {

        this.apply = function () {
            var vm = this;
            vm.search = { ids: [], year: new Date().getFullYear() };
            vm.data = [];
            vm.refresh = getData;
            initDropdown();
            // getData();

            function getData() {
                settlementSvc.dpSettlement(vm.search.ids).then(function (result) {
                    vm.data = result.data;
                });
            }

            function initDropdown() {
                vm.dropdown = {
                    department: {}
                };

                init.call(vm.dropdown.department, "ids", "getDepartmentOptions");

                function init(searchKey, apiName) {
                    var that = this;

                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });

                    angular.extend(that, {
                        onSelected: selectedChange,
                        onRemove: selectedChange,
                        clearSelected: function () {
                            vm.search[searchKey] = [];
                            that.selected = undefined;
                            // getData();
                        }
                    });

                    function selectedChange($item, $model) {
                        vm.search[searchKey] = that.selected
                            ? that.selected.map(function (item) {
                                return { id: item.id };
                            })
                            : undefined;
                        // getData();
                    }
                }
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settleAccount").controller("PanelCtrl", PanelCtrl);


    PanelCtrl.$inject = ['PanelAndReportService', "CustomerTotalCtrl", 'DepartmentTotalCtrl', 'SubjectTotalCtrl'];

    /** @ngInject */
    function PanelCtrl(ctrlSvc, customerCtrl, departmentCtrl, subjectCtrl) {
        var vm = this;
        ctrlSvc.apply.call(vm, customerCtrl, departmentCtrl, subjectCtrl,
            "app/pages/settleAccount/customer/customerTotal.html",
            "app/pages/settleAccount/department/departmentTotal.html",
            "app/pages/settleAccount/subject/subjectTotal.html");
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settleAccount").controller("ReportCtrl", ReportCtrl);


    ReportCtrl.$inject = ['PanelAndReportService', "CustomerDetailCtrl", 'DepartmentDetailCtrl', 'SubjectDetailCtrl'];

    /** @ngInject */
    function ReportCtrl(ctrlSvc, customerCtrl, departmentCtrl, subjectCtrl) {
        var vm = this;
        ctrlSvc.apply.call(vm, customerCtrl, departmentCtrl, subjectCtrl,
            "app/pages/settleAccount/customer/customerDetail.html",
            "app/pages/settleAccount/department/departmentDetail.html",
            "app/pages/settleAccount/subject/subjectDetail.html");
    }
})();


(function () {
    "use strict";

    angular.module("A56.pages.settings")
        .service('CreateBillingService', CreateBillingService)
        .constant('SaleBillingOption', { add: 1, addName: '生成账单', update: 2, updateName: '重新生成' })
        .controller("SaleBillingCreateCtrl", SaleBillingCreateCtrl);

    CreateBillingService.$inject = [
        'SaleBillingOption',
        "abp.services.app.clearing_W_Sale_Billing",
        '$q',
        'dalogModal'
    ];

    function CreateBillingService(optionEnum, wSaleBilling, $q, dalogModal) {
        this.modal = function (option, model) {
            var deffer = $q.defer();
            dalogModal.open({
                templateUrl: "app/theme/components/modalForm/modal.form.html",
                ctrlName: 'SaleBillingCreateCtrl',
                size: "md",
                context: {
                    optionEnum: optionEnum,
                    currentOption: option,
                    cancelBtnText: '取消',
                    okBtnText: '生成',
                    model: model,
                    includeTemp: "app/pages/settleAccount/saleBilling/modal.form.create.html"
                },
                callback: function (res) {
                    if (res === false) return;
                    if (res.owner) {
                        if (angular.isArray(res.owner)) {
                            res.owner = res.owner.map(function (item) {
                                return item.name || item;
                            });
                        } else {
                            res.owner = [res.owner];
                        }
                    }
                    if (option == optionEnum.add) {
                        wSaleBilling.save(res).then(deffer.resolve);
                    } else {
                        wSaleBilling.reBuild(res).then(deffer.resolve);
                    }
                }
            });
            return deffer.promise;
        };
    }

    SaleBillingCreateCtrl.$inject = [
        'modal.form.ctrl.service',
        "abp.services.app.baseInfo",
        '$uibModalInstance',
        'context',
        'SaleBillingOption'
    ];

    /** @ngInject */
    function SaleBillingCreateCtrl(modalFormSvc, baseInfoSvc, $uibModalInstance, context, optionEnum) {
        var vm = this;
        modalFormSvc.initModal.call(vm, $uibModalInstance, context);
        initDropdown();
        initDatepicker.call(vm, "datepickerBegin");
        initDatepicker.call(vm, "datepickerEnd");
        initDatepicker.call(vm, "period", "month", "yyyy-MM");

        function initDropdown() {
            vm.dropdown = {
                customer: {},
                project: {},
                warehouse: {},
                owner: { isMultiple: true }
            };

            init.call(vm.dropdown.customer, "customerId", "customerName", "getCustomerOptions", 0);
            init.call(vm.dropdown.project, "projectId", "projectName", "getProjectOptions", 1);
            init.call(vm.dropdown.warehouse, "warehouseId", "warehouseName", "getWarehouseOptions", 2);
            init.call(vm.dropdown.owner, undefined, undefined, "getOwnerOptions", 3, "owner");

            if (vm.currentOption == optionEnum.update) {
                baseInfoSvc.getCustomerOptions({}).then(function (result) {
                    vm.dropdown.customer.selectItems = result.data;
                    // 触发 onCustomerChange 事件，以加载 project 数据源
                    triggerNextLavel.call(vm.dropdown.customer, result.data, vm.model.customerId, onCustomerChange, vm.model.projectId, true);
                });
            }

            function init(modelIdKey, modelNameKey, apiName, lavel, multipleSelectModelName) {
                var that = this;

                if (vm.currentOption == optionEnum.add && lavel === 0) {
                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });
                }

                var change;
                switch (lavel) {
                    case 0:
                        change = onCustomerChange;
                        break;
                    case 1:
                        change = onProjectChange;
                        break;
                    case 2:
                        change = onWarehouseChange;
                        break;
                }

                angular.extend(that, {
                    onSelected: onSelectChange,
                    clearSelected: function () {
                        that.selected = undefined;
                        switch (lavel) {
                            case 0:
                                // 清空 project 和 warehouse
                                clearProjectDataSource();
                                clearWarehouseDataSource();
                                clearOwnerDataSource();
                                break;
                            case 1:
                                // 清空 warehouse
                                clearWarehouseDataSource();
                                clearOwnerDataSource();
                                break;
                            case 2:
                                clearOwnerDataSource();
                                break;
                        }
                        if (that.isMultiple) {
                            vm.model[multipleSelectModelName] = that.selected;
                        } else {
                            vm.model[modelIdKey] = that.selected ? that.selected.id : undefined;
                            vm.model[modelNameKey] = that.selected ? that.selected.name : undefined;
                        }
                    },
                    onRemove: function ($item, $model) {
                        // 在未点击确定按钮之前不应该改变原始的数组数据
                        vm.model[multipleSelectModelName] = vm.model[multipleSelectModelName].concat();
                        if (that.isMultiple) {
                            [].splice.call(vm.model[multipleSelectModelName], vm.model[multipleSelectModelName].indexOf($item.name), 1);
                        }
                    }
                });

                function onSelectChange(item, model) {
                    if (that.isMultiple) {
                        vm.model[multipleSelectModelName] = that.selected;
                    } else {
                        vm.model[modelIdKey] = that.selected ? that.selected.id : undefined;
                        vm.model[modelNameKey] = that.selected ? that.selected.name : undefined;
                    }
                    if (change) change();
                }
            }

            function onCustomerChange(selectedValue) {
                // 清空 project 和 warehouse
                clearProjectDataSource();
                clearWarehouseDataSource();
                clearOwnerDataSource();
                // 根据 customerId 加 project
                baseInfoSvc
                    .getProjectOptions({ customerId: vm.dropdown.customer.selected.id })
                    .then(function (result) {
                        vm.dropdown.project.selectItems = result.data;
                        // 触发 onProjectChange 事件，以加载 warehouse 数据源
                        triggerNextLavel.call(vm.dropdown.project, result.data, selectedValue, onProjectChange, vm.model.warehouseId, true);
                    });
            }

            function onProjectChange(selectedValue) {
                // 清空 warehouse
                clearWarehouseDataSource();
                clearOwnerDataSource();
                // 根据 projectId 加 warehouse
                baseInfoSvc
                    .getWarehouseOptions({ projectId: vm.dropdown.project.selected.id })
                    .then(function (result) {
                        vm.dropdown.warehouse.selectItems = result.data;
                        // 设置 warehouse 选择的值
                        triggerNextLavel.call(vm.dropdown.warehouse, result.data, selectedValue, onWarehouseChange, vm.model.owner, true);
                    });
            }

            function onWarehouseChange(selectedValue) {
                clearOwnerDataSource();
                // 根据 projectId、warehouseId 加 owner
                baseInfoSvc
                    .getOwnerOptions({
                        projectId: vm.dropdown.project.selected.id,
                        warehouseId: vm.dropdown.warehouse.selected.id
                    })
                    .then(function (result) {
                        vm.dropdown.owner.selectItems = result.data;
                        // 设置 warehouse 选择的值
                        triggerNextLavel.call(vm.dropdown.owner, result.data, selectedValue, null, null, false, 'name');
                    });
            }

            function clearProjectDataSource() {
                vm.dropdown.project.selectItems = [];
                vm.dropdown.project.selected = undefined;
            }

            function clearWarehouseDataSource() {
                vm.dropdown.warehouse.selectItems = [];
                vm.dropdown.warehouse.selected = undefined;
            }

            function clearOwnerDataSource() {
                vm.dropdown.owner.selectItems = [];
                vm.dropdown.owner.selected = undefined;
            }

            // 设置 dropdown 初始值，并加载下一级 dropdown 数据源
            function triggerNextLavel(data, selectedValue, fn, fnParams, hasNext, key) {
                var that = this;
                key = key || 'id';
                if (selectedValue) {
                    var t = data.filter(function (item) {
                        return that.isMultiple ?
                            (angular.isArray(selectedValue) ? selectedValue.indexOf(item[key]) >= 0 : item[key] == selectedValue) :
                            item[key] == selectedValue;
                    });
                    if (t.length) {
                        that.selected = that.isMultiple ? t : t[0];
                        if (hasNext) fn(fnParams);
                    }
                }
            }
        }

        function initDatepicker(key, minMode, format) {
            var that = this;
            that[key] = {};
            angular.extend(that[key], {
                model: new Date(),
                altInputFormats: ["yyyy-MM-dd"],
                open: function () {
                    that[key].opened = !that[key].opened;
                },
                opened: false,
                format: format || "yyyy-MM-dd",
                options: {
                    showWeeks: false,
                    minMode: minMode || "day"
                    // maxDate:new Date()
                },
                dateChanged: function (e) { }
            });
        }
    };
})();


(function () {
    "use strict";

    angular.module("A56.pages.settings")
        .controller("SaleBillingViewDetailCtrl", SaleBillingViewDetailCtrl);

    SaleBillingViewDetailCtrl.$inject = [
        'abp.services.app.clearing_W_Sale_Billing',
        'modal.form.ctrl.service',
        '$uibModalInstance',
        'context'
    ];

    /** @ngInject */
    function SaleBillingViewDetailCtrl(saleBillingSvc, modalFormSvc, $uibModalInstance, context) {
        var vm = this;
        modalFormSvc.initModal.call(vm, $uibModalInstance, context);
        vm.search = {
            maxResultCount: 12,
            billDetailId: context.model.id
        };
        vm.isNotTuoPanWei = !(vm.model.subjectId == 3 && vm.model.chargeName == '托盘位');
        // 如果是【存储费】则明细列表的表头显示【储位号】否则显示【订单编号】
        if (vm.model.subjectId == 3) {
            vm.numberCell = "储位号";
            vm.cell2Name = "货主";
        } else {
            vm.numberCell = "订单编号";
            vm.cell2Name = "DN编号";
        }
        vm.grid = {
            gridData: [],
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: 10,
                total: undefined
            },
            callServer: function (tableState) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                saleBillingSvc.getDetailSource(vm.search).then(function (result) {
                    vm.grid.gridData = result.data.items;
                    tableState.pagination.totalItemCount = result.data.totalCount;
                    tableState.pagination.numberOfPages =
                        Math.ceil(result.data.totalCount / pagination.number) || 1;
                });
            }
        };
    };
})();


(function () {
    "use strict";

    angular.module("A56.pages.settings")
        .controller("SaleBillingSubmitCtrl", SaleBillingSubmitCtrl);

        SaleBillingSubmitCtrl.$inject = [
        'modal.form.ctrl.service',
        '$uibModalInstance',
        'context'
    ];

    /** @ngInject */
    function SaleBillingSubmitCtrl(modalFormSvc, $uibModalInstance, context) {
        var vm = this;
        modalFormSvc.initModal.call(vm, $uibModalInstance, context);
    };
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("SaleBillingCtrl", SaleBillingCtrl);

    SaleBillingCtrl.$inject = [
        "abp.services.app.baseInfo",
        "abp.services.app.clearing_W_Sale_Billing",
        'CreateBillingService',
        'SaleBillingOption',
        "DownloadService",
        '$state'
    ];

    /** @ngInject */
    function SaleBillingCtrl(baseInfoSvc, wSaleBilling, CreateBillingSvc, optionEnum, DownloadSvc, $state) {
        var vm = this,
            displayedPages = 10;

        vm.search = {
            isActive: true,
            maxResultCount: 12
        };

        vm.onNameKeyup = function (e) {
            var keycode = window.event ? e.keyCode : e.which;
            if (keycode == 13) {
                vm.onNameChange();
            }
        };
        vm.onNameChange = function (isClear) {
            if (isClear) vm.search.name = undefined;
            vm.grid.selectPage(1);
        };

        vm.createSaleBilling = function () {
            CreateBillingSvc.modal(optionEnum.add, {}).then(function (result) {
                $state.go("SettleAccount.SaleBillingDetail", { id: result.data.id });
            });
        };

        initDropdown();
        initDatepicker();

        vm.grid = {
            gridData: [],
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: displayedPages,
                total: undefined
            },
            callServer: function (tableState) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                wSaleBilling.getAll(vm.search)
                    .then(function (result) {
                        vm.grid.gridData = result.data.items;
                        tableState.pagination.totalItemCount = result.data.totalCount;
                        tableState.pagination.numberOfPages =
                            Math.ceil(result.data.totalCount / pagination.number) || 1;
                    }).catch(function () {
                        tableState.pagination.totalItemCount = 0;
                        tableState.pagination.numberOfPages = 1;
                    });
            },
            selectPage: function (pageIndex) {
                angular.element("st-pagination").isolateScope().selectPage(pageIndex);
            },
            getCurrentPageIndex: function () {
                var index =
                    vm.grid.tableState.pagination.start / vm.grid.tableState.pagination.number;
                return index + 1;
            },
            exportExcel: function (item) {
                wSaleBilling.export({
                    warehouseId: item.warehouseId,
                    projectId: item.projectId,
                    startDate: item.periodFrom,
                    endDate: item.periodTo,
                    id: item.id
                }).then(function (result) {
                    DownloadSvc.download({
                        url: abp.appPath + "api/fileDownload/download",
                        data: result.data,
                        type: "application/vnd.ms-excel",
                        fileName: new Date().getTime() + ".xlsx"
                    });
                });
            }
        };

        /**
         * 因为【客户】【项目】【仓库】下拉列表是有级联关系
         * 当清空【客户】时，重新加载【项目】和【仓库】的数据源
         * 当清空 【项目】时，要判断【客户】是否有值，如果有则【仓库】只清空数据源，而不重新加载数据源，如果【客户】没值，则需要重新加载【仓库的数据源】
         */
        function initDropdown() {
            vm.dropdonw = {
                customer: {},
                project: {},
                warehouse: {},
                status: {},
                owner: {
                    isMultiple: true
                }
            };

            init.call(vm.dropdonw.customer, "customerId", "getCustomerOptions", 0);
            init.call(vm.dropdonw.project, "projectId", "getProjectOptions", 1);
            init.call(vm.dropdonw.warehouse, "warehouseId", "getWarehouseOptions", 2);
            init.call(vm.dropdonw.status, "status", 'getSaleBillingStatusOptions');//getSaleBillingStatusOptions
            init.call(vm.dropdonw.owner, "owner", 'getOwnerOptions', null, 'name', undefined);

            function init(searchKey, apiName, lavel, key, text, apiParamFn) {
                var that = this;
                key = key || 'id';
                if (!apiName) {
                    that.selectItems = [];
                    // that.selected = that.selectItems[0];
                } else {
                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });
                }

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        clearSelect();
                    }
                });

                function selectedChange($item, $model) {
                    if (that.isMultiple && angular.isArray(that.selected)) {
                        vm.search[searchKey] = that.selected && that.selected.length ?
                            that.selected.map(function (item) { return item[key]; }) :
                            undefined;
                    } else {
                        vm.search[searchKey] = that.selected ? that.selected[key] : undefined;
                    }
                    switch (lavel) {
                        case 0:
                            clearProject();
                            clearWarehouse();
                            clearOwner();
                            baseInfoSvc.getProjectOptions({ customerId: that.selected.id })
                                .then(function (result) {
                                    vm.dropdonw.project.selectItems = result.data;
                                });
                            // 获取 Owner 数据源
                            getOwnerDataItems();
                            break;
                        case 1:
                            clearWarehouse();
                            clearOwner();
                            baseInfoSvc.getWarehouseOptions({ projectId: that.selected.id })
                                .then(function (result) {
                                    vm.dropdonw.warehouse.selectItems = result.data;
                                });
                            // 获取 Owner 数据源
                            getOwnerDataItems();
                            break;
                        case 2:
                            clearOwner();
                            // 获取 Owner 数据源
                            getOwnerDataItems();
                            break;
                    }
                    vm.grid.selectPage(1);
                }

                function clearSelect() {
                    vm.search[searchKey] = that.selected ? that.selected[key] : undefined;
                    switch (lavel) {
                        case 0:
                            clearProject();
                            clearWarehouse();
                            clearOwner();
                            baseInfoSvc.getProjectOptions({}).then(function (result) {
                                vm.dropdonw.project.selectItems = result.data;
                            });
                            baseInfoSvc.getWarehouseOptions({}).then(function (result) {
                                vm.dropdonw.warehouse.selectItems = result.data;
                            });
                            // 获取 Owner 数据源
                            getOwnerDataItems();
                            break;
                        case 1:
                            clearWarehouse();
                            clearOwner();
                            if (!vm.search.customerId) {
                                baseInfoSvc.getWarehouseOptions({}).then(function (result) {
                                    vm.dropdonw.warehouse.selectItems = result.data;
                                });
                            }
                            // 获取 Owner 数据源
                            getOwnerDataItems();
                            break;
                        case 2:
                            clearOwner();
                            // 获取 Owner 数据源
                            getOwnerDataItems();
                            break;
                    }
                    vm.grid.selectPage(1);
                }
            }

            function getOwnerDataItems() {
                baseInfoSvc.getOwnerOptions({
                    "customerId": vm.search["customerId"],
                    "projectId": vm.search["projectId"],
                    "warehouseId": vm.search["warehouseId"]
                }).then(function (result) {
                    vm.dropdonw.owner.selectItems = result.data;
                });
            }

            function clearProject() {
                vm.search.projectId = undefined;
                vm.dropdonw.project.selectItems = [];
                vm.dropdonw.project.selected = undefined;
            }

            function clearWarehouse() {
                vm.search.warehouseId = undefined;
                vm.dropdonw.warehouse.selectItems = [];
                vm.dropdonw.warehouse.selected = undefined;
            }

            function clearOwner() {
                vm.search.owner = undefined;
                vm.dropdonw.owner.selectItems = [];
                vm.dropdonw.owner.selected = undefined;
            }
        }

        function initDatepicker() {
            vm.datepicker = {
                from: {},
                to: {}
            };

            init.call(vm.datepicker.from, "periodFrom");
            init.call(vm.datepicker.to, "periodTo");

            function init(searchKey) {
                var that = this;
                angular.extend(that, {
                    model: undefined,
                    opened: false,
                    open: function () {
                        that.opened = !that.opened;
                    },
                    format: "yyyy-MM-dd",
                    options: {
                        showWeeks: false,
                        minMode: "day"
                    },
                    dateChanged: function () {
                        vm.search[searchKey] = that.model;
                        vm.grid.selectPage(1);
                    },
                    clear: function () {
                        vm.search[searchKey] = that.model = undefined;
                        vm.grid.selectPage(1);
                    }
                });
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("SaleBillingDetailCtrl", SaleBillingDetailCtrl);

    SaleBillingDetailCtrl.$inject = [
        "abp.services.app.clearing_W_Sale_Billing",
        "$stateParams",
        "toastr",
        'editableOptions',
        'editableThemes',
        'CreateBillingService',
        'SaleBillingOption',
        "DownloadService",
        'dalogModal'
    ];

    /** @ngInject */
    function SaleBillingDetailCtrl(wSaleBilling, $stateParams, toastr, editableOptions, editableThemes, CreateBillingSvc, optionEnum, DownloadSvc, dalogModal) {
        var vm = this,
            getDataCallback;

        vm.isReBilling = false;
        vm.model = { periodFrom: null, periodTo: null, period: null };
        vm.myForm = "myForm";
        // 整体调整价 change 事件
        vm.adjustmentPriceChange = function () {
            vm.model.actualPrice = (vm.model.price || 0) + vm.model.adjustmentPrice;
            if (!vm.model.adjustmentPrice) {
                vm.model.actualPrice = vm.model.actualPriceTmp;
            }
        };
        vm.grid = {
            gridData: [],
            pageSize: 12,
            ajustmentPriceUpdate: function (item) {
                item.finalPrice = (item.amount || 0) + (item.adjustmentPrice || 0);
                var sum = 0;
                angular.forEach(vm.grid.gridData, function (v, i) {
                    sum += v.finalPrice;
                });
                // 最终价格
                vm.model.price = sum;
                // 实际总额 = 最终价格 + 整体调整 
                vm.model.actualPrice = vm.model.price + (vm.model.adjustmentPrice || 0);
            },
            callServer: function (tableState) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                if (vm.grid.gridData.length) {
                    vm.grid.rowCollection = vm.grid.gridData;//.slice(pagination.start, pagination.start + vm.grid.pageSize);
                } else {
                    if (getDataCallback) {
                        getDataCallback.then(function (result) {
                            convertData(result);
                            tableState.pagination.totalItemCount = vm.grid.gridData.length;
                            tableState.pagination.numberOfPages = Math.ceil(tableState.pagination.totalItemCount / pagination.number) || 1;
                            vm.grid.rowCollection = vm.grid.gridData;//.slice(pagination.start, pagination.start + vm.grid.pageSize);
                            // toastr.success('操作成功！');
                        });
                    }
                }
            },
            selectPage: function (pageIndex) {
                vm.grid.gridData = [];
                var t = angular.element("st-pagination").isolateScope();
                if (t) { t.selectPage(pageIndex); }
            }
        };

        vm.viewDetail = function (item) {
            dalogModal.open({
                templateUrl: "app/theme/components/modalForm/modal.form.html",
                ctrlName: 'SaleBillingViewDetailCtrl',
                size: "lg",
                context: {
                    title: '明细',
                    cancelBtnText: '取消',
                    okBtnText: '提交',
                    model: item,
                    includeTemp: "app/pages/settleAccount/saleBilling/modal.form.detail.html"
                }
            });
        };

        vm.opt = {
            // 重新生成
            reCreate: function () {
                getDataCallback = CreateBillingSvc.modal(optionEnum.update, angular.extend({}, vm.model));
                getDataCallback.then(function (result) {
                    vm.grid.gridData.length = [];
                    vm.grid.callServer(vm.grid.tableState);
                });
            },
            // 保存账单
            saveBilling: function () {
                getDataCallback = wSaleBilling.save(vm.model);
                getDataCallback.then(function () {
                    vm.grid.gridData.length = [];
                    vm.grid.callServer(vm.grid.tableState);
                });
            },
            // 提交账单
            submitBilling: function () {
                dalogModal.open({
                    templateUrl: "app/theme/components/modalForm/modal.form.html",
                    ctrlName: 'SaleBillingSubmitCtrl',
                    size: "md",
                    context: {
                        title: '提交账单',
                        cancelBtnText: '取消',
                        okBtnText: '提交',
                        model: {
                            name: vm.model.name,
                            comment: vm.model.comment
                        },
                        includeTemp: "app/pages/settleAccount/saleBilling/modal.form.submit.html"
                    },
                    callback: function (res) {
                        if (res === false) return;
                        getDataCallback = wSaleBilling.submit(angular.extend(res, { id: vm.model.id }));
                        getDataCallback.then(function (result) {
                            vm.grid.gridData.length = [];
                            vm.grid.callServer(vm.grid.tableState);
                        });
                    }
                });
            },
            // 确认开票
            confimBilling: function () {
                getDataCallback = wSaleBilling.confirmInvoice({ id: vm.model.id });
                getDataCallback.then(function (result) {
                    vm.grid.gridData.length = [];
                    vm.grid.callServer(vm.grid.tableState);
                });
            },
            // 确认收款
            confimReceipt: function () {
                getDataCallback = wSaleBilling.confirmReceipt({ id: vm.model.id });
                getDataCallback.then(function (result) {
                    vm.grid.gridData.length = [];
                    vm.grid.callServer(vm.grid.tableState);
                });
            },
            // 确认结单
            finish: function () {
                getDataCallback = wSaleBilling.confirmFinish({ id: vm.model.id });
                getDataCallback.then(function (result) {
                    vm.grid.gridData.length = [];
                    vm.grid.callServer(vm.grid.tableState);
                });
            },
            // 导出账单
            exportExcel: function () {
                wSaleBilling
                    .export({
                        warehouseId: vm.model.warehouseId,
                        projectId: vm.model.projectId,
                        startDate: vm.model.periodFrom,
                        endDate: vm.model.periodTo,
                        id: vm.model.id
                    })
                    .then(function (result) {
                        DownloadSvc.download({
                            url: abp.appPath + "api/fileDownload/download",
                            data: result.data,
                            type: "application/vnd.ms-excel",
                            fileName: new Date().getTime() + ".xlsx"
                        });
                    });
            }
        };

        getData(1);

        function getData(pageIndex) {
            getDataCallback = wSaleBilling.get({ id: $stateParams.id });
            vm.grid.selectPage(pageIndex);
        }

        function convertData(result) {
            vm.model = result.data;
            if (vm.model) {
                vm.grid.gridData = vm.model.billingDetails || [];
                if (vm.model.periodFrom) {
                    vm.model.periodFrom = new Date(new Date(vm.model.periodFrom));
                }
                if (vm.model.periodTo) {
                    vm.model.periodTo = new Date(new Date(vm.model.periodTo));
                }
                if (vm.model.period) {
                    vm.model.period = new Date(new Date(vm.model.period));
                }
                vm.model.actualPriceTmp = vm.model.actualPrice;
            } else {
                vm.grid.gridData = [];
            }
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settleAccount").service("SubjectDetailCtrl", SubjectDetail);

    SubjectDetail.$inject = ["abp.services.app.baseInfo", "abp.services.app.clearingReport"];

    /** @ngInject */
    function SubjectDetail(baseInfoSvc, settlementSvc) {
        this.apply = function () {
            var vm = this;
            vm.search = { ids: [], year: new Date().getFullYear() };
            vm.data = [];
            vm.datepicker = {
                model: new Date(),
                open: function () {
                    vm.datepicker.opened = true;
                },
                opened: false,
                format: "yyyy",
                options: {
                    showWeeks: false,
                    minMode: "year"
                },
                dateChanged: function (e) {
                    vm.search.year = vm.datepicker.model.getFullYear();
                    // getData();
                }
            };
            vm.refresh = getData;
            initDropdown();
            // getData();

            function getData() {
                settlementSvc.getSubRevenueDetails(vm.search).then(function (result) {
                    vm.data = result.data;
                });
            }

            function initDropdown() {
                vm.dropdown = {
                    subject: {}
                };

                init.call(vm.dropdown.subject, "ids", "getSubjectOptionsLevel1");

                function init(searchKey, apiName) {
                    var that = this;

                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });

                    angular.extend(that, {
                        onSelected: selectedChange,
                        onRemove: selectedChange,
                        clearSelected: function () {
                            vm.search[searchKey] = [];
                            that.selected = undefined;
                            // getData();
                        }
                    });

                    function selectedChange($item, $model) {
                        vm.search[searchKey] = that.selected
                            ? that.selected.map(function (item) {
                                return item.id;
                            })
                            : undefined;
                        // getData();
                    }
                }
            }
        };
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settleAccount").service("SubjectTotalCtrl", SubjectTotal);

    SubjectTotal.$inject = ["abp.services.app.baseInfo", "abp.services.app.clearingReport"];

    /** @ngInject */
    function SubjectTotal(baseInfoSvc, settlementSvc) {
        
        this.apply = function () {
            var vm = this;
            vm.search = { ids: [], year: new Date().getFullYear() };
            vm.data = [];
            vm.refresh = getData;
            initDropdown();
            // getData();

            function getData() {
                settlementSvc.subSettlement(vm.search.ids).then(function (result) {
                    vm.data = result.data;
                });
            }

            function initDropdown() {
                vm.dropdown = {
                    subject: {}
                };

                init.call(vm.dropdown.subject, "ids", "getSubjectOptionsLevel1");

                function init(searchKey, apiName) {
                    var that = this;

                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });

                    angular.extend(that, {
                        onSelected: selectedChange,
                        onRemove: selectedChange,
                        clearSelected: function () {
                            vm.search[searchKey] = [];
                            that.selected = undefined;
                            // getData();
                        }
                    });

                    function selectedChange($item, $model) {
                        vm.search[searchKey] = that.selected
                            ? that.selected.map(function (item) {
                                return { id: item.id };
                            })
                            : undefined;
                        // getData();
                    }
                }
            }
        };
    }
})();

(function() {
    "use strict";

    angular
        .module("A56.pages.settings")
        .controller("settleAccount.orderDetailCtrl", orderDetailCtrl);

    orderDetailCtrl.$inject = [
        "abp.services.app.baseInfo",
        "abp.services.app.whData_OrderDetail",
        "toastr",
        "editableOptions",
        "editableThemes"
    ];

    /** @ngInject */
    function orderDetailCtrl(
        baseInfoSvc,
        whDataOrderDetailSvc,
        toastr,
        editableOptions,
        editableThemes
    ) {
        var vm = this,
            displayedPages = 10;

        vm.search = {
            workDate: new Date(),
            maxResultCount: 12
        };

        vm.onNoKeyup = function(e) {
            var keycode = window.event ? e.keyCode : e.which;
            if (keycode == 13) {
                vm.onNoChange();
            }
        };
        vm.onNoChange = function(isClear) {
            if (isClear) vm.search.no = undefined;
            vm.grid.selectPage(1);
        };
        initDropdown();
        initDatepicker();

        vm.grid = {
            gridData: [],
            cancel: function(index, item, rowform) {
                if (!item.orderId) {
                    vm.grid.gridData.splice(index, 1);
                }
                rowform.$cancel();
            },
            update: function(index, data, item) {
                angular.extend(item, data);
                var apiName = "create",
                    msg = "创建成功！";
                if (item.orderId) {
                    apiName = "edit";
                    msg = "更新成功！";
                }
                whDataOrderDetailSvc[apiName](item).then(function(result) {
                    toastr.success(msg);
                    vm.grid.selectPage(1);
                });
            },
            // checkTempEmpty: function(data, rowform, item, itemKeyCk, itemKey) {
            //     if (!item[itemKeyCk]) return true;
            //     if (data == null || data == undefined || (!angular.isNumber(data) && data == ""))
            //         return "*";
            // },
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: displayedPages,
                total: undefined
            },
            callServer: function(tableState, ctrl) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                whDataOrderDetailSvc.getAllEdit(vm.search).then(function(result) {
                    vm.grid.gridData = result.data.items;
                    tableState.pagination.totalItemCount = result.data.totalCount;
                    tableState.pagination.numberOfPages =
                        Math.ceil(result.data.totalCount / pagination.number) || 1;
                });
            },
            selectPage: function(pageIndex) {
                angular.element("st-pagination").isolateScope().selectPage(pageIndex);
            },
            checkBoxClikc: function(evt, data, item, itemKeyCk, itemKey, itemValKey) {
                item[itemKeyCk] = data;
                if (!item[itemKey]) {
                    item[itemKey] = item[itemValKey];
                }
            },
            onCheckboxShow: function(item, itemKeyCk, itemKey, data) {
                item[itemKeyCk] = item[itemKey] > 0;
            }
        };

        function initDatepicker() {
            vm.datepicker = {
                date: {}
            };

            init.call(vm.datepicker.date, "workDate");

            function init(searchKey) {
                var that = this;
                angular.extend(that, {
                    model: vm.search.workDate,
                    opened: false,
                    open: function() {
                        that.opened = !that.opened;
                    },
                    format: "yyyy-MM-dd",
                    options: {
                        showWeeks: false,
                        minMode: "day"
                    },
                    dateChanged: function() {
                        vm.search[searchKey] = that.model;
                        vm.grid.selectPage(1);
                    },
                    clear: function() {
                        vm.search[searchKey] = that.model = undefined;
                        vm.grid.selectPage(1);
                    }
                });
            }
        }

        function initDropdown() {
            vm.dropdonw = {
                warehouse: {}
            };

            init.call(vm.dropdonw.warehouse, "warehouseId", "getWarehouseOptions");

            function init(searchKey, apiName) {
                var that = this;

                baseInfoSvc[apiName]({}).then(function(result) {
                    that.selectItems = result.data;
                });

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function() {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        clearSelect();
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.id : "";
                    vm.grid.selectPage(1);
                }

                function clearSelect() {
                    vm.search[searchKey] = that.selected ? that.selected.id : undefined;
                    vm.grid.selectPage(1);
                }
            }
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    }
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("SaleChargeCtrl", SaleChargeCtrl);

    SaleChargeCtrl.$inject = [
        "$uibModal",
        "abp.services.app.baseInfo",
        "abp.services.app.clearing_W_Sale_Charge",
        "toastr",
        "editableOptions",
        "editableThemes",
        'dalogModal'
    ];

    /** @ngInject */
    function SaleChargeCtrl($uibModal, baseInfoSvc, wSaleChargeSvc, toastr, editableOptions, editableThemes, dalogModal) {
        var vm = this,
            displayedPages = 10;

        vm.search = {
            isActive: true,
            maxResultCount: 12
        };
        initDropdown();

        vm.grid = {
            gridData: [],
            addBtnDisabled: false,
            dropdonw: {
                // warehouse: {},
                // project: {},
                subject: {}
            },
            datepicker: {
                chargeDate: {}
            },
            add: function () {
                vm.grid.addBtnDisabled = true;
                vm.grid.inserted = {
                    id: undefined,
                    warehouseId: undefined,
                    warehouseName: undefined,
                    projectId: undefined,
                    projectName: undefined,
                    subjectId: undefined,
                    subjectName: undefined,
                    chargeDate: undefined,
                    quantity: undefined,
                    comment: undefined,
                    unitName: undefined,
                    unitDisplayName: undefined,
                    owner:undefined,
                    price: undefined
                };
                vm.grid.gridData.unshift(vm.grid.inserted);
            },
            cancel: function (index, item, rowform) {
                if (!item.id) {
                    vm.grid.gridData.splice(index, 1);
                }
                rowform.$cancel();
                vm.grid.addBtnDisabled = false;
            },
            update: function (index, data, item) {
                angular.extend(item, data);
                var apiName = "create",
                    msg = "创建成功！";
                if (item.id) {
                    apiName = "update";
                    msg = "更新成功！";
                }
                item.warehouseId = vm.search.warehouseId;
                item.projectId = vm.search.projectId;
                wSaleChargeSvc[apiName](item).then(function (result) {
                    vm.grid.addBtnDisabled = false;
                    toastr.success(msg);
                    vm.grid.selectPage(1);
                });
            },
            disabled: function (index) {
                var item = vm.grid.gridData[index];
                dalogModal
                    .confirm({
                        context: item.name,
                        optionName: item.isActive ? '是否禁用' : '是否启用',
                        title: item.isActive ? "禁用" : '启用'
                    })
                    .then(function (res) {
                        if (res) {
                            item.isActive = !item.isActive;
                            wSaleChargeSvc.update(item).then(function (res) {
                                toastr.success("操作成功");
                                vm.grid.selectPage(1);
                            });
                        }
                    });
            },
            checkTempEmpty: function (data) {
                if (!data) return "*";
            },
            pageSetting: {
                pageSize: vm.search.maxResultCount,
                displayedPages: displayedPages,
                total: undefined
            },
            callServer: function (tableState) {
                vm.grid.tableState = tableState;
                var pagination = tableState.pagination;
                vm.search.skipCount = pagination.start;
                // 只有同时选择了仓库和项目才去查询
                if (!vm.search.warehouseId || !vm.search.projectId) {
                    vm.grid.gridData = [];
                    tableState.pagination.totalItemCount = 0;
                    tableState.pagination.numberOfPages = 1;
                    vm.grid.addBtnDisabled = false;
                    return;
                }
                wSaleChargeSvc.getAll(vm.search).then(function (result) {
                    vm.grid.gridData = result.data.items.map(function (item) {
                        return angular.extend(item, {
                            subjectSelect: {
                                name: item.subjectName,
                                id: item.subjectId
                            }
                        });
                    });
                    tableState.pagination.totalItemCount = result.data.totalCount;
                    tableState.pagination.numberOfPages =
                        Math.ceil(result.data.totalCount / pagination.number) || 1;
                    vm.grid.addBtnDisabled = false;
                });
            },
            selectPage: function (pageIndex) {
                angular.element("st-pagination").isolateScope().selectPage(pageIndex);
            }
        };
        setGridDatepicker.call(vm.grid.datepicker.chargeDate);
        initGridDropdown.call(
            vm.grid.dropdonw.subject,
            "getSubjectOptions",
            "subjectId",
            "subjectName",
            "subjectSelect"
        );

        function initGridDropdown(apiName, feildKey, feildText, selected) {
            var that = this;
            angular.extend(that, {
                data: [],
                onShow: function () {
                    if (!that.data.length) {
                        baseInfoSvc[apiName]({}).then(function (result) {
                            that.data = result.data;
                        });
                    }
                },
                onChange: function (data, item) {
                    item[feildText] = data.name;
                    item[feildKey] = data.id;
                }
            });
        }

        function initDropdown() {
            vm.dropdonw = {
                project: {},
                warehouse: {},
                status: {}
            };

            init.call(vm.dropdonw.warehouse, "warehouseId", "getWarehouseOptions", 0);
            init.call(vm.dropdonw.project, "projectId", "getProjectOptions", 1);
            init.call(vm.dropdonw.status, "isActive");

            function init(searchKey, apiName, lavel) {
                var that = this;

                if (!apiName) {
                    that.selectItems = [{ id: false, text: "禁用" }, { id: true, text: "启用" }];
                    that.selected = that.selectItems[1];
                } else {
                    baseInfoSvc[apiName]({}).then(function (result) {
                        that.selectItems = result.data;
                    });
                }

                angular.extend(that, {
                    onSelected: selectedChange,
                    onRemove: selectedChange,
                    clearSelected: function () {
                        vm.search[searchKey] = undefined;
                        that.selected = undefined;
                        clearSelect();
                    }
                });

                function selectedChange($item, $model) {
                    vm.search[searchKey] = that.selected ? that.selected.id : "";
                    switch (lavel) {
                        case 0:
                            clearProject();
                            baseInfoSvc
                                .getProjectOptions({ warehouseId: that.selected.id })
                                .then(function (result) {
                                    vm.dropdonw.project.selectItems = result.data;
                                });
                            break;
                        case 1:
                            break;
                    }
                    vm.grid.selectPage(1);
                }

                function clearSelect() {
                    vm.search[searchKey] = that.selected ? that.selected.id : undefined;
                    switch (lavel) {
                        case 0:
                            clearProject();
                            baseInfoSvc.getProjectOptions({}).then(function (result) {
                                vm.dropdonw.project.selectItems = result.data;
                            });
                            baseInfoSvc.getWarehouseOptions({}).then(function (result) {
                                vm.dropdonw.warehouse.selectItems = result.data;
                            });
                            break;
                        case 1:
                            break;
                    }
                    vm.grid.selectPage(1);
                }
            }

            function clearProject() {
                vm.search.projectId = undefined;
                vm.dropdonw.project.selectItems = [];
                vm.dropdonw.project.selected = undefined;
            }
        }

        function setGridDatepicker() {
            var that = this;
            angular.extend(that, {
                opened: false,
                open: function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    that.opened = !that.opened;
                },
                options: {
                    showWeeks: false,
                    minMode: "day"
                },
                onShow: function (data, item) {
                    if (data && angular.isString(data)) {
                        item.chargeDate = new Date(Date.parse(data));
                    }
                }
            });
        }

        editableOptions.theme = "bs3";
        editableThemes["bs3"].submitTpl =
            '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes["bs3"].cancelTpl =
            '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('A56.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('A56.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
    "use strict";

    angular.module("A56.theme.components").provider("baSidebarService", baSidebarServiceProvider);

    /** @ngInject */
    function baSidebarServiceProvider() {
        var staticMenuItems = [];

        this.addStaticItem = function() {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        /** @ngInject */
        this.$get = [
            "$state",
            "layoutSizes",
            "userPermission",
            function($state, layoutSizes, permSvc) {
                return new _factory();

                function _factory() {
                    var isMenuCollapsed = shouldMenuBeCollapsed();

                    this.getMenuItems = function() {
                        var states = defineMenuItemStates();
                        var menuItems = states.filter(function(item) {
                            return item.level == 0;
                        });

                        menuItems.forEach(function(item) {
                            var children = states.filter(function(child) {
                                return child.level == 1 && child.name.indexOf(item.name) === 0;
                            });
                            item.subMenu = children.length ? children : null;
                            // 支持三级菜单
                            if (item.subMenu) {
                                item.subMenu.forEach(function(cItem) {
                                    var subChildren = states.filter(function(child) {
                                        return (
                                            child.level == 2 && child.name.indexOf(cItem.name) === 0
                                        );
                                    });
                                    cItem.subMenu = subChildren.length ? subChildren : null;
                                });
                            }
                        });

                        return menuItems.concat(staticMenuItems);
                    };

                    this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                    this.canSidebarBeHidden = canSidebarBeHidden;

                    this.setMenuCollapsed = function(isCollapsed) {
                        isMenuCollapsed = isCollapsed;
                    };

                    this.isMenuCollapsed = function() {
                        return isMenuCollapsed;
                    };

                    this.toggleMenuCollapsed = function() {
                        isMenuCollapsed = !isMenuCollapsed;
                    };

                    this.getAllStateRefsRecursive = function(item) {
                        var result = [];
                        _iterateSubItems(item);
                        return result;

                        function _iterateSubItems(currentItem) {
                            currentItem.subMenu &&
                                currentItem.subMenu.forEach(function(subItem) {
                                    subItem.stateRef && result.push(subItem.stateRef);
                                    _iterateSubItems(subItem);
                                });
                        }
                    };

                    function defineMenuItemStates() {
                        // console.log("菜单：", $state.get());
                        return $state
                            .get()
                            .filter(function(s) {
                                // return s.sidebarMeta;
                                return !!s.sidebarMeta && permSvc.isGrantedMenu(s);
                            })
                            .map(function(s) {
                                var meta = s.sidebarMeta;
                                return {
                                    name: s.name,
                                    title: s.title,
                                    level: (s.name.match(/\./g) || []).length,
                                    order: meta.order,
                                    icon: meta.icon,
                                    stateRef: s.name
                                };
                            })
                            .sort(function(a, b) {
                                return (a.level - b.level) * 100 + a.order - b.order;
                            });
                    }

                    function shouldMenuBeCollapsed() {
                        return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                    }

                    function canSidebarBeHidden() {
                        return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                    }
                }
            }
        ];
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    "use strict";

    angular.module("A56.theme.components").controller("BaSidebarCtrl", BaSidebarCtrl);

    BaSidebarCtrl.$inject = ["$scope", "baSidebarService", "AbpScriptsInitialized"];
    /** @ngInject */
    function BaSidebarCtrl($scope, baSidebarService, AbpScriptsInitialized) {
        AbpScriptsInitialized.scriptsInitialized().then(function() {
            $scope.menuItems = baSidebarService.getMenuItems();
            if ($scope.menuItems && $scope.menuItems.length) {
                $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
            }
        });

        $scope.hoverItem = function($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight = $event.currentTarget.clientHeight;
            var menuTopValue = 66;
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };

        $scope.$on("$stateChangeSuccess", function() {
            if (baSidebarService.canSidebarBeHidden()) {
                baSidebarService.setMenuCollapsed(true);
            }
        });
    }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('A56.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('A56.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('A56.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('A56.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
(function () {
    "use strict";

    angular.module("A56.theme").service("modal.form.ctrl.service", modalFormService);

    modalFormService.$inject = ["toastr"];

    /** @ngInject */
    function modalFormService(toastr) {

        this.initModal = function ($uibModalInstance, context) {
            var vm = this;
            vm.model = {};
            vm.myForm = "myForm";

            angular.extend(vm, context);

            vm.cancelBtnText = vm.cancelText || '取消';
            vm.okBtnText = vm.okBtnText || '确定';
            if (vm.optionEnum) {
                switch (vm.currentOption) {
                    case vm.optionEnum.add:
                        vm.title = vm.optionEnum.addName;
                        break;
                    case vm.optionEnum.update:
                        vm.title = vm.optionEnum.updateName;
                        break;
                }
            }

            if (!vm.title) {
                vm.title = context.title;
            }

            vm.cancel = function () {
                $uibModalInstance.close(false);
            };

            vm.ok = function () {
                if (vm.myForm) {
                    vm.myForm.$setSubmitted(true);
                    if (!vm.myForm.$valid) {
                        toastr.warning("请完善必填信息");
                        return;
                    }
                }
                $uibModalInstance.close(vm.model);
            };
        };

        this.initDropdown = function (text, key, model, onChange) {
            var that = this
            angular.extend(that, {
                onChange: function ($selected, $item, taget) {
                    model[text] = $selected.name;
                    model[key] = $selected.id;
                    if (onChange) {
                        onChange($selected, $item, taget);
                    }
                }
            });
        };
    };
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    "use strict";

    angular.module("A56.theme.components").controller("MsgCenterCtrl", MsgCenterCtrl);
    MsgCenterCtrl.$inject = ["$scope", "$sce", "$q", ];
    /** @ngInject */
    function MsgCenterCtrl($scope, $sce, $q) {
        var audio;
        function getAudio() {
            var defer = $q.defer();
            if (!!!audio) {
                audio = document.getElementById("audioFile");
                defer.resolve(audio);
            } else {
                defer.resolve(audio);
            }
            return defer.promise;
        }
        abp.event.on("playNotificationMp3", function(item) {
            getAudio().then(function(audioElem) {
                audioElem.play();
            });
        });

        $scope.users = {
            //   0: {
            //     name: 'Vlad',
            //   },
            //   1: {
            //     name: 'Kostya',
            //   },
            //   2: {
            //     name: 'Andrey',
            //   },
            //   3: {
            //     name: 'Nasta',
            //   }
        };

        $scope.notifications = [
            //   {
            //     userId: 0,
            //     template: '&name posted a new article.',
            //     time: '1 min ago'
            //   },
            //   {
            //     userId: 1,
            //     template: '&name changed his contact information.',
            //     time: '2 hrs ago'
            //   },
            //   {
            //     image: 'assets/img/shopping-cart.svg',
            //     template: 'New orders received.',
            //     time: '5 hrs ago'
            //   },
            //   {
            //     userId: 2,
            //     template: '&name replied to your comment.',
            //     time: '1 day ago'
            //   },
            //   {
            //     userId: 3,
            //     template: 'Today is &name\'s birthday.',
            //     time: '2 days ago'
            //   },
            //   {
            //     image: 'assets/img/comments.svg',
            //     template: 'New comments on your post.',
            //     time: '3 days ago'
            //   },
            //   {
            //     userId: 1,
            //     template: '&name invited you to join the event.',
            //     time: '1 week ago'
            //   }
        ];

        $scope.messages = [
            //   {
            //     userId: 3,
            //     text: 'After you get up and running, you can place Font Awesome icons just about...',
            //     time: '1 min ago'
            //   },
            //   {
            //     userId: 0,
            //     text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
            //     time: '2 hrs ago'
            //   },
            //   {
            //     userId: 1,
            //     text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
            //     time: '10 hrs ago'
            //   },
            //   {
            //     userId: 2,
            //     text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
            //     time: '1 day ago'
            //   },
            //   {
            //     userId: 3,
            //     text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
            //     time: '1 day ago'
            //   },
            //   {
            //     userId: 1,
            //     text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
            //     time: '2 days ago'
            //   },
            //   {
            //     userId: 0,
            //     text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
            //     time: '1 week ago'
            //   }
        ];

        $scope.getMessage = function(msg) {
            var text = msg.template;
            if (msg.userId || msg.userId === 0) {
                text = text.replace(
                    "&name",
                    "<strong>" + $scope.users[msg.userId].name + "</strong>"
                );
            }
            return $sce.trustAsHtml(text);
        };
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    "use strict";

    angular
        .module("A56.theme.components")
        .directive("pageTop", pageTop)
        .controller("pageTopCtrl", pageTopCtrl);

    /** @ngInject */
    function pageTop() {
        return {
            restrict: "E",
            templateUrl: "app/theme/components/pageTop/pageTop.html",
            controller: "pageTopCtrl"
        };
    }

    pageTopCtrl.$inject = ["$scope", "$http","appSession"];

    function pageTopCtrl($scope, $http,appSession) {
        $scope.appSession = appSession;
        $scope.singOut = function() {
            $http({
                method: "POST",
                url: abp.appPath + "/Account/Logout",
                data: {}
            })
                .then(function(res) {
                    // 回调函数
                    if (res.data == "success") {
                        abp.ng.http.handleUnAuthorizedRequest();
                    }
                })
                .catch(function(res) {});
        };
    }
})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('A56.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('A56.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function() {
    "use strict";

    angular
        .module("A56.theme")
        .filter("groupSelectpickerOptions", GroupSelectpickerOptions)
        .filter("filterSelected", FilterSelected);

    /** @ngInject */
    function GroupSelectpickerOptions() {
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {
                var keys = Object.keys(props);

                items.forEach(function(item) {
                    var itemMatches = false;

                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    }

    /** @ngInject */
    function FilterSelected() {
        return function(items, selectedItems, key) {
            var out = [];

            if (angular.isArray(items)) {
                out = items.filter(function(i) {
                    return (
                        !selectedItems ||
                        !selectedItems.length ||
                        !selectedItems.filter(function(j) {
                            return j[key] == i[key];
                        }).length
                    );
                });
            } else {
                // Let the output be the input untouched
                out = items.filter(function(i) {
                    return i.id != selectedItems[key];
                });
            }

            return out;
        };
    }
})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('A56.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("ModalFormCycleChargeCtrl", ModalFormCycleChargeCtrl);

    ModalFormCycleChargeCtrl.$inject = ['modal.form.ctrl.service', 'SaleTariff.FormModal.Dropdown', '$uibModalInstance', 'context'];

    /** @ngInject */
    function ModalFormCycleChargeCtrl(modalFormSvc, dropdownSvc, $uibModalInstance, context) {
        var vm = this;
        modalFormSvc.initModal.call(vm, $uibModalInstance, context);
        dropdownSvc.ruleDropdown.call(vm);
        dropdownSvc.subjectDropdown.call(vm);
        vm.model.priceRate = vm.model.priceRate || 1;
    };
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("ModalFormOrderCtrl", ModalFormOrderCtrl);

    ModalFormOrderCtrl.$inject = ['modal.form.ctrl.service', 'SaleTariff.FormModal.Dropdown', '$uibModalInstance', 'context'];

    /** @ngInject */
    function ModalFormOrderCtrl(modalFormSvc, dropdownSvc, $uibModalInstance, context) {
        var vm = this;
        modalFormSvc.initModal.call(vm, $uibModalInstance, context);
        dropdownSvc.ruleDropdown.call(vm);
        dropdownSvc.subjectDropdown.call(vm);
    };
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("ModalFormStockCtrl", ModalFormStockCtrl);

    ModalFormStockCtrl.$inject = ['modal.form.ctrl.service', 'SaleTariff.FormModal.Dropdown', '$uibModalInstance', 'context'];

    /** @ngInject */
    function ModalFormStockCtrl(modalFormSvc, dropdownSvc, $uibModalInstance, context) {
        var vm = this;
        modalFormSvc.initModal.call(vm, $uibModalInstance, context);
        dropdownSvc.ruleDropdown.call(vm);
        dropdownSvc.subjectDropdown.call(vm);
        vm.model.isApplyMaxQty = !!vm.model.isApplyMaxQty;
        vm.model.isApplyMonthAvg = !!vm.model.isApplyMonthAvg;
        vm.model.priceRate = vm.model.priceRate || 1;
    };
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").controller("ModalFormStockCellCtrl", ModalFormStockCellCtrl);

    ModalFormStockCellCtrl.$inject = ['modal.form.ctrl.service', 'SaleTariff.FormModal.Dropdown', '$uibModalInstance', 'context'];

    /** @ngInject */
    function ModalFormStockCellCtrl(modalFormSvc, dropdownSvc, $uibModalInstance, context) {
        var vm = this;
        modalFormSvc.initModal.call(vm, $uibModalInstance, context);
        dropdownSvc.ruleDropdown.call(vm);
        dropdownSvc.subjectDropdown.call(vm);
        vm.model.isApplyMaxQty = !!vm.model.isApplyMaxQty;
        vm.model.priceRate = vm.model.priceRate || 1;
    };
})();

(function () {
    "use strict";

    angular.module("A56.pages.settings").service("SaleTariff.FormModal.Dropdown", SaleTariffFormModalDropdown);

    SaleTariffFormModalDropdown.$inject = ['modal.form.ctrl.service'];

    /** @ngInject */
    function SaleTariffFormModalDropdown(modalFormSvc) {

        // 结算规则、商品名称 下拉列表
        this.ruleDropdown = function () {
            var vm = this;
            vm.dropdown.rule.onDataSourceLoaded = function (data, ddl) {
                if (vm.currentModal == vm.modalEnum.cycleCharge && vm.currentOption == vm.optionEnum.add) {
                    vm.dropdown.rule.selected = data[0];
                    ddl.onChange(vm.dropdown.rule.selected, vm.dropdown.rule.selected, 'rule');
                } else {
                    vm.dropdown.rule.selected = data.filter(function (item) {
                        return item.id == vm.model.ruleId;
                    })[0];
                }
            };
            modalFormSvc.initDropdown.call(vm.dropdown.rule, "ruleName", "ruleId", vm.model, function ($item, $model, target) {
                var arr = vm.dropdown.subject.data.filter(function (i) {
                    return i.id == $item.subjectId;
                });
                if (arr.length) {
                    vm.dropdown.subject.selected = arr[0];
                    vm.dropdown.subject.onChange(vm.dropdown.subject.selected, vm.dropdown.subject.selected);
                }
                vm.model.chargeName = $item.charegeName;
                vm.model.unitName = $item.unitName;
                vm.model.isApplyMaxQty = !!$item.isApplyMaxQty;
            });
        };

        this.subjectDropdown = function () {
            var vm = this;
            vm.dropdown.subject.onDataSourceLoaded = function (data, ddl) {
                vm.dropdown.subject.selected = data.filter(function (item) {
                    return item.id == vm.model.subjectId;
                })[0];
            };
            modalFormSvc.initDropdown.call(vm.dropdown.subject, "subjectName", "subjectId", vm.model);
        };
    };
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    "use strict";

    angular.module("A56.theme").directive("a56EditTable", a56EditTable);

    /** @ngInject */
    function a56EditTable($parse) {
        return {
            restrict: "AE",
            scope: false,
            template: function (ele, attrs) {
                var str = // button class --   pull-right
                    '<h3 class="with-line">{{vm[\'' + attrs.confName + '\'].title}}\
                        <button type="button" style="margin-top:10px;"\
                                ng-disabled="vm[\'' + attrs.confName + '\'].grid.addBtnDisabled"\
                                ng-click=\"vm[\'' + attrs.confName + '\'].grid.add()"\
                                class="btn btn-success btn-xs btn-with-icon save-profile">\
                            <i class="fa fa-plus-circle"></i>添加\
                        </button>\
                    </h3>\
                    <div class="table-edit">\
                        <table class="table table-hover"\
                            st-table="vm[\'' + attrs.confName + '\'].grid.rowCollection"\
                            st-safe-src="vm[\'' + attrs.confName + '\'].grid.gridData">\
                            <thead>\
                                <tr>\
                                    <th ng-repeat="item in vm[\'' + attrs.confName + '\'].tableHeaders track by $index">\
                                    {{item}}\
                                    </th>\
                                </tr>\
                            </thead>\
                            <tbody>\
                                <tr ng-repeat="item in vm[\'' + attrs.confName + '\'].grid.rowCollection"\
                                    class="editable-row"\
                                    ng-include="vm[\'' + attrs.confName + '\'].tdTemplateUrl"></tr>\
                            </tbody>\
                        </table>\
                    </div>';
                return str;
            }
        };
    }
})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('A56').run(['$templateCache', function($templateCache) {$templateCache.put('app/templates/modal.confirm.html','<div class="modal-content"><div class="modal-header" ng-class="vm.theme"><i class="ion-flame modal-icon"></i><span>{{vm.title}}</span></div><div class="modal-body text-center">{{vm.optionName}} &nbsp;{{vm.context}}</div><div class="modal-footer no-border"><button type="button" class="btn btn-danger" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.ok()">\u786E\u5B9A</button></div></div>');
$templateCache.put('app/pages/attendance/batchModal.html','<div class="modal-content kao-qin"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>\u6279\u91CF\u5DE5\u65F6\u4FEE\u6539</span></div><div class="modal-body text-center"><ul class="nav nav-pills"><li role="presentation"><a ng-class="{\'active\':vm.isRest}" href="javascript:void(0);" ng-click="vm.isRest = true;">\u4F11\u606F</a></li><li role="presentation"><a ng-class="{\'active\':!vm.isRest}" href="javascript:void(0);" ng-click="vm.isRest = false;">\u8003\u52E4</a></li></ul><div ng-show="!vm.isRest" class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label"></label><div class="col-sm-10 text-left"><label class="radio-label" ng-repeat="item in vm.ddlKaoQin" for="{{item.value}}"><input type="radio" id="{{item.value}}" ng-model="vm.model.kaoQin" name="kaoqin" ng-value="item.value" ng-change="vm.kaoqinChange()"> {{item.text}}</label></div></div><div class="form-group"><label for="timeOut" class="col-sm-2 control-label">\u8D85\u65F6</label><div class="col-sm-5"><div class="input-group"><input type="number" class="input-number form-control" id="timeOut" ng-model="vm.model.timeOut" placeholder="\u8D85\u65F6"><div class="input-group-addon">\u5C0F\u65F6</div></div></div><div class="col-sm-5 control-label text-left"><var>\u51FA\u52E4\u8D85\u51FA&nbsp;8&nbsp;\u5DE5\u65F6\u7684\u65F6\u957F</var></div></div><div class="form-group" ng-show="vm.model.kaoQin != vm.ddlKaoQin[0].value"><label for="leave" class="col-sm-2 control-label">\u8BF7\u5047</label><div class="col-sm-5"><div class="input-group"><input type="number" class="input-number form-control" id="leave" name="leave" ng-model="vm.model.leave" oninput="if(value>8){value=8}else if(value<0)value=0" ng-change="vm.leaveChange($event)" placeholder="\u8BF7\u5047"><div class="input-group-addon">\u5C0F\u65F6</div></div></div><div class="col-sm-5 control-label text-left"><var>\u7F3A\u52E4\u603B\u65F6\u957F\uFF0C\u6700\u591A&nbsp;8&nbsp;\u5C0F\u65F6</var></div></div><div class="form-group"><label for="work" class="col-sm-2 control-label">\u5DE5\u65F6</label><div class="col-sm-5"><div class="input-group"><input type="number" class="input-number form-control" id="work" disabled="disabled" ng-model="vm.model.work" placeholder="\u5DE5\u65F6"><div class="input-group-addon">\u5C0F\u65F6</div></div></div><div class="col-sm-5 control-label text-left"><var>\u6700\u591A&nbsp;8&nbsp;\u5C0F\u65F6</var></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.submit()">\u786E\u5B9A</button></div></div>');
$templateCache.put('app/pages/attendance/deleteModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>{{vm.title||\'\u5220\u9664\'}}</span></div><div class="modal-body text-center">{{vm.optionName||\'\u662F\u5426\u5220\u9664\'}} &nbsp;{{vm.context}}</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.ok()">\u786E\u5B9A</button></div></div>');
$templateCache.put('app/pages/attendance/timeSheetInput.html','<div ba-panel="" class="datepicker"><div class="form-horizontal"><div class="form-group"><label class="col-sm-3 control-label">\u671F\u95F4</label><div class="col-sm-9"><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datepicker.format}}" datepicker-options="vm.datepicker.options" ng-model="vm.search.attendanceDate" is-open="vm.datepicker.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="altInputFormats" show-button-bar="true" ng-change="vm.datepicker.dateChanged()"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.datepicker.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="control-label">\u4F11\u606F\u65E5 <input type="checkbox" ng-model="vm.search.isRestDay"></label></div><div class="form-group"><label class="col-sm-3 control-label">\u5355\u4F4D</label><div class="col-sm-9"><ui-select ng-model="vm.search.warehouse.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" on-select="vm.onWarehouseSelected($item, $model)" search-enabled="true"><ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="item in vm.selectWarehouseItems | filter: $select.search"><span ng-bind-html="item.label"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="control-label"><strong>\u7F16\u5236</strong>&nbsp;<span ng-bind="vm.search.inSystemEmployeeNum"></span>&nbsp;\u4EBA</div></div><div class="form-group"><div class="control-label"><strong>\u8D1F\u8D23\u4EBA</strong> <span ng-bind="vm.search.headName"></span></div></div><div class="form-group"><div class="control-label"><strong>\u5F53\u65E5\u4ED3\u5E93\u7ECF\u7406</strong> <a href="javascript:void(0);" editable-text="vm.search.whManagerName" onbeforesave="vm.setWhManager($data)">{{ vm.search.whManagerName || \'\u672A\u8BBE\u7F6E\' }}</a></div></div></div></div><div class="row"><div class="col-md-8" ba-panel="" ba-panel-title="\u5728\u7F16"><button class="btn btn-primary" ng-click="vm.batchClick()">\u6279\u91CF</button><table class="table table-hover kaoqin" st-table="vm.rpData"><thead><tr class="sortable"><th><input type="checkbox" class="form-control" ng-model="vm.checkBox.selectAll" ng-click="vm.checkBox.selectAllClick()"></th><th>\u59D3\u540D</th><th st-sort="lastName">\u8003\u52E4</th><th st-sort="username">\u8D85\u65F6</th><th st-sort="email">\u8BF7\u5047</th><th st-sort="age">\u5DE5\u65F6</th></tr></thead><tbody><tr ng-repeat="item in vm.rpData" class="editable-tr-wrap"><td class="table-id"><input type="checkbox" id="{{\'check_\'+$index}}" ng-model="item.checked" ng-init="item.checked=item.checked||false" ng-click="vm.checkBox.selectedOne(item,$index)" class="form-control"></td><td><span ng-bind="item.employeeName"></span></td><td><span editable-select="item.categoryCode" e-ng-options="s.value as s.text for s in vm.ddlKaoQin" onbeforesave="vm.onTableRowSaved($data,\'categoryCode\',item)" blur="cancel" ng-bind-html="vm.showKaoQin(item)"></span></td><td><span editable-number="item.overtime" e-class="input-number" onbeforesave="vm.onTableRowSaved($data,\'overtime\',item)" blur="cancel">{{item.overtime}}</span></td><td><span editable-number="item.leave" e-class="input-number" onbeforesave="vm.onTableRowSaved($data,\'leave\',item)" blur="cancel">{{item.leave}}</span></td><td><span editable-number="item.workingHours" e-class="input-number" onbeforesave="vm.onTableRowSaved($data,\'workingHours\',item)" blur="cancel">{{item.workingHours}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-page-change="vm.pageSetting1.pageChange(newPage)" st-items-by-page="vm.pageSetting1.pageSize" st-displayed-pages="vm.pageSetting1.displayedPages"></div></td></tr></tfoot></table></div><div class="col-md-4 table-edit" ba-panel="" ba-panel-title="\u4E34\u65F6"><button class="btn btn-primary btn-with-icon" ng-disabled="vm.tempDisabled" ng-click="vm.addTemp()"><i class="fa fa-plus-circle"></i>\u6DFB\u52A0</button><table class="table table-hover" st-table="vm.rowCollection" st-safe-src="vm.tempData"><thead><tr><th>\u540D\u79F0</th><th>\u5DE5\u65F6</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="user in vm.rowCollection" class="editable-row"><td><span editable-text="user.tEmployeeName" e-name="tEmployeeName" e-form="rowform" onbeforesave="vm.checkTempEmpty($data)" e-required="">{{user.tEmployeeName || \'\'}}</span></td><td><span editable-number="user.workingHours" e-class="input-number" e-name="workingHours" onbeforesave="vm.checkTempEmpty($data)" e-form="rowform" e-required="">{{ user.workingHours }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user" onbeforesave="vm.updateTemp($index,$data,user)"><button type="submit" ng-disabled="rowform.$waiting" class="btn-success fa fa-check"></button> <button type="button" ng-disabled="rowform.$waiting" class="btn-danger fa fa-ban" ng-click="vm.cancelTemp($index,rowform)"></button></form><div class="buttons eidt-btn" ng-show="!rowform.$visible"><button class="btn-success fa fa-pencil-square-o" ng-click="rowform.$show()"></button> <button class="btn-danger fa fa-trash-o" ng-click="vm.removeTemp($index)"></button></div></td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><div st-pagination="" st-page-change="vm.pageSetting2.pageChange(newPage)" st-items-by-page="vm.pageSetting2.pageSize" st-displayed-pages="vm.pageSetting2.displayedPages"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div ba-panel="" class="widgets"><div ng-include="\'app/templates/page/default.html\'" onload="vm.onIncludeLoad()"></div></div>');
$templateCache.put('app/pages/dashboard/pes.html','<div ba-panel="" class="datepicker"><div class="form-horizontal flex-box-1"><div class="form-group"><label class="col-sm-3 control-label">\u671F\u95F4</label><div class="col-sm-9"><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datepicker.format}}" datepicker-options="vm.datepicker.options" ng-model="vm.search.attendanceDate" is-open="vm.datepicker.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.datepicker.dateChanged()"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.datepicker.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label">\u5355\u4F4D</label><div class="col-sm-9"><ui-select ng-model="vm.search.warehouse.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" on-select="vm.onWarehouseSelected($item, $model)" search-enabled="true"><ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="item in vm.selectWarehouseItems | filter: $select.search"><span ng-bind-html="item.label"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="control-label"><strong>\u7F16\u5236</strong>&nbsp;<span ng-bind="vm.reportModel.empCount"></span>&nbsp;\u4EBA</div></div><div class="form-group"><div class="control-label"><strong>\u8D1F\u8D23\u4EBA</strong> <span ng-bind="vm.reportModel.manager"></span></div></div></div></div><div ba-panel=""><div class="row"><div class="col-md-12"><button class="btn btn-primary btn-with-icon pull-right" ng-click="vm.export()"><i class="fa fa-reply"></i> \u5BFC\u51FA</button><p>&nbsp;</p></div><p>&nbsp;</p></div><div class="row"><div class="col-md-12 table-report"><div class="report report-header"><table class="table table-bordered table-hover table-condensed"><thead><tr><th></th><th>\u79D1\u76EE</th><th>\u7D2F\u8BA1</th></tr></thead><tbody><tr ng-repeat="item in vm.reportModel.reportData" ng-init="preIndex = (($index-1)<0?0:($index-1)); data = item; groupCode = vm.reportModel.reportData[preIndex].groupCode;"><td rowspan="{{::data.rowCount}}" ng-bind="::data.groupCodeName" ng-if="$index == 0 || data.groupCode != groupCode">\u5728\u7F16</td><td ng-bind="::data.codeName"></td><td ng-bind="::data.total|number"></td></tr><tr><td colspan="2">\u5F53\u65E5\u4ED3\u5E93\u7ECF\u7406</td><td>&nbsp;</td></tr></tbody></table></div><div class="report report-content"><table class="table table-bordered table-hover table-condensed"><thead><tr><th ng-repeat="item in vm.reportModel.reportData[0].dayValues">{{item.day}}&nbsp;\u65E5</th></tr></thead><tbody><tr ng-repeat="item in vm.reportModel.reportData"><td ng-repeat="s in item.dayValues" ng-bind-html="(s.value|number)||\'&nbsp;\'"></td></tr><tr><td ng-repeat="item in vm.reportModel.manages" ng-bind-html="item.value||\'&nbsp;\'"></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/dashboard/tmsKpi.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="row"><div class="form-group col-md-3"><label for="beginDate" class="col-sm-3 control-label">\u5E74\u6708</label><div class="col-sm-9 inner-input"><div class="input-group datepicker-with-clear-btn"><input name="beginDate" id="beginDate" ng-required="true" type="text" class="form-control" uib-datepicker-popup="{{vm.datepicker.from.format}}" datepicker-options="vm.datepicker.from.options" ng-model="vm.datepicker.from.model" is-open="vm.datepicker.from.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="altInputFormats" show-button-bar="true" ng-change="vm.datepicker.from.dateChanged()" ng-click="vm.datepicker.from.open()" placeholder="\u9009\u62E9\u5E74\u6708"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.datepicker.from.clear()"><i class="fa fa-times"></i></button></span></div></div></div><div class="form-group col-md-9"><label class="col-sm-2 control-label">\u9879\u76EE</label><div class="col-sm-10"><div class="input-group"><ui-select multiple="" ng-model="vm.dropdonw.project.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.project.onSelected($item, $model)" on-remove="vm.dropdonw.project.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u9879\u76EE">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.project.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn input-group-btn-multiple"><button type="button" ng-click="vm.dropdonw.project.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div></div><div ba-panel=""><div class="row"><div class="col-md-12 table-report"><div class="report report-content"><table class="table table-bordered table-hover table-condensed"><thead><tr><th style="width: 150px;"></th><th>LTL (\u96F6\u62C5)</th><th>FTL (\u6574\u8F66)</th><th>Distnibution (\u914D\u9001)</th><th>Express (\u5FEB\u9012)</th></tr></thead><tbody><tr ng-repeat="item in vm.reportModel.reportData"><td>{{item.rowName}}</td><td>{{item.ltl|rowTypeBind:item.rowType}}</td><td>{{item.ftl|rowTypeBind:item.rowType}}</td><td>{{item.distribution|rowTypeBind:item.rowType}}</td><td>{{item.express|rowTypeBind:item.rowType}}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/home/home.html','<div class="jumbotron text-center text-success"><h2 class="text-success">Hello, \u6B22\u8FCE\u4F7F\u7528 A56.Net</h2></div>');
$templateCache.put('app/templates/page/default.html','<div class="row"><div class="col-md-4"><div class="form-group"><ui-select ng-model="vm.dropdownYear.model.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" on-select="vm.onYearSelected($item, $model)"><ui-select-match placeholder="year"><span>year {{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="yearsItem in vm.dropdownYear.data | filter: $select.search"><span ng-bind-html="yearsItem.label"></span></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><ui-select multiple="" ng-model="vm.dropdownCustomer.model.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control" on-select="vm.onCustomerSelected($item, $model)" on-remove="vm.onCustomerSelected($item, $model)"><ui-select-match placeholder="Project">{{$item.label}}</ui-select-match><ui-select-choices repeat="customerItem in vm.dropdownCustomer.data | filter: $select.search">{{customerItem.label}}</ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><ui-select multiple="" ng-model="vm.dropdownWarehouse.model.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control" on-select="vm.onWarehouseSelected($item, $model)" on-remove="vm.onWarehouseSelected($item, $model)"><ui-select-match placeholder="DC">{{$item.label}}</ui-select-match><ui-select-choices repeat="warehouseItem in vm.dropdownWarehouse.data | filter: $select.search">{{warehouseItem.label}}</ui-select-choices></ui-select></div></div></div><div class="row amchart-title"><div class="col-xs-10 amchart-title-left"><h1 class="col-xs-6" ng-bind="vm.reportName">Total Order Shipped</h1><h1 class="col-xs-6" ng-bind="vm.decActual">Dec Actual</h1></div><div class="col-xs-2 amchart-title-right"><h1 ng-bind="vm.barCharData[vm.barCharData.length-1][vm.barChart.graphs.valueField]|currency:\'&nbsp;\'"></h1></div></div><div class="row"><div id="legend" class="inner-amchar-legend"></div></div><div class="row inner-char"><div class="col-xs-10 no-padding"><div id="orderReport" class="a56-chart left-char"></div></div><div class="col-xs-2 no-padding"><div id="orderBarChart" class="a56-chart right-chart"></div></div></div><div class="row inner-char-legend"><div class="col-xs-10"><div class="col-md-12" ng-repeat="fItem in vm.lineChart.graphs" repeat-finish="" repeat-finish-parent="this" repeat-finish-on-repeat="vm.onRepeatFinished"><div id="legend{{$index+1}}"></div><div class="items"><div ng-repeat="item in vm.reportData"><div ng-bind="item[fItem.valueField]|currency:\'&nbsp;\'"></div></div></div></div></div><div class="col-xs-2 right-chart-legend"><div class="col-md-12" ng-repeat="item in vm.barCharData"><div class="items"><div><div ng-bind="item[vm.barChart.graphs.valueField]|currency:\'&nbsp;\'"></div></div></div></div></div><div class="col-md-12" ng-if="vm.reportFormula"><p ng-bind="vm.reportFormula"></p></div></div><p>&nbsp;</p><div class="row"><dl ng-class="item.className" ng-repeat="item in vm.comments"><dt><h3 ng-bind="item.title">Gaps Identified</h3></dt><dd ng-repeat="t in item.items"><i class="fa fa-paper-plane-o" aria-hidden="true">&nbsp;&nbsp;&nbsp;&nbsp;</i> <span ng-bind="t">N/A</span></dd></dl></div>');
$templateCache.put('app/pages/attendance/inhouseStaff/inhouseStaff.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u8003\u52E4\u6708</label><div class="col-sm-9"><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datepicker.format}}" datepicker-options="vm.datepicker.options" ng-model="vm.search.attendanceDate" is-open="vm.datepicker.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u672C\u6708" alt-input-formats="altInputFormats" show-button-bar="true" ng-change="vm.datepicker.dateChanged()"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.datepicker.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u4ED3\u5E93</label><div class="col-sm-9"><div class="input-group"><ui-select ng-model="vm.dropdonw.warehouse.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.warehouse.onSelected($item, $model)" on-remove="vm.dropdonw.warehouse.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.warehouse.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.warehouse.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-5"><label class="col-sm-3 control-label">\u9879\u76EE</label><div class="col-sm-9"><div class="input-group"><ui-select ng-model="vm.dropdonw.project.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.project.onSelected($item, $model)" on-remove="vm.dropdonw.project.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u9879\u76EE">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.project.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.project.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div><div class="report-grid table-edit" ba-panel=""><div><button type="button" class="btn btn-primary btn-with-icon pull-right" style="margin-right:15px;" ng-click="vm.saveData()"><i class="ion-android-checkmark-circle"></i>\u5168\u90E8\u4FDD\u5B58</button> <button uib-dropdown="" class="btn btn-default btn-with-icon pull-right" on-toggle="vm.uiDropdown.onToggle(vm.uiDropdown.isopen)" is-open="vm.uiDropdown.isopen" style="margin-right:15px;"><a href="javascript:void(0);" uib-dropdown-toggle=""><i class="ion-android-checkmark-circle"></i>\u6279\u91CF\u4FEE\u6539</a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"></div><div class="msg-list"><form name="vm.myForm"><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.customer.$invalid && (vm.myForm.customer.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u5355\u8BC1\u5458(\u4EBA)</label><div class="col-sm-9"><div class="input-group no-bottom"><input type="number" ng-model="vm.model.dQuantity" class="input-number form-control"></div></div></div><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.project.$invalid && (vm.myForm.project.partnerId.$dirty || vm.myForm.$submitted)}"><label class="col-sm-3 control-label">\u64CD\u4F5C\u5DE5(\u4EBA)</label><div class="col-sm-9"><div class="input-group no-bottom"><input type="number" ng-model="vm.model.oQuantity" class="input-number form-control"></div></div></div><div class="form-group clearfix"><div class="col-md-12"><a class="btn btn-success btn-with-icon pull-right" ng-click="vm.uiDropdown.confirm()"><i class="ion-android-checkmark-circle"></i>\u786E\u5B9A</a> <span class="pull-right">&nbsp;&nbsp;&nbsp;&nbsp;</span> <a class="btn btn-danger btn-with-icon pull-right" ng-click="vm.uiDropdown.cancel()"><i class="fa fa-ban" aria-hidden="true"></i>\u53D6\u6D88</a></div></div></form></div></div></button></div><table class="table table-hover"><thead><tr><th style="width:150px;">\u65E5\u671F</th><th>\u5355\u8BC1\u5458(\u4EBA)</th><th>\u64CD\u4F5C\u5DE5(\u4EBA)</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td>{{item.attendanceDate|date:\'yyyy-MM-dd EEE\'}}</td><td><a editable-number="item.dQuantity" e-class="input-number">{{ item.dQuantity||\'&nbsp;&nbsp;&nbsp;&nbsp;\' }}&nbsp;&nbsp;&nbsp;&nbsp;</a></td><td><a editable-number="item.oQuantity">{{ item.oQuantity||\'&nbsp;&nbsp;&nbsp;&nbsp;\' }}&nbsp;&nbsp;&nbsp;&nbsp;</a></td><td><button type="button" title="\u6E05\u7A7A\u6570\u636E" class="btn btn-danger fa fa-trash-o" ng-click="vm.grid.clearItem(item)"></button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/dashboard/DCBI/dcbi.html','<div class="dcbi" ng-class="{\'fullscreen\':vm.isFullscreen,\'dcbi-pc\':!vm.isFullscreen}"><div ba-panel=""><div class="form-group col-md-3 col-sm-4"><ui-select ng-model="vm.warehouseItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="vm.disabledWarehouse" append-to-body="true" search-enabled="true"><ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="item in vm.selectWarehouseItems | filter: $select.search"><span ng-bind-html="item.label"></span></ui-select-choices></ui-select></div><div class="form-group col-md-9 col-sm-8"><span class="form-control time" ng-bind="vm.dateNow|date:\'M\u6708d\u65E5 EEEE HH:mm:ss\'">2019-01-11</span></div></div><div class="row" ng-if="vm.warehouseItem.selected.value == \'HEQ\'" ng-include="\'app/pages/dashboard/DCBI/widgets/mei-long.html\'" ng-controller="ShaCtrl as ctrl"></div><div class="row" ng-if="vm.warehouseItem.selected.value == \'SHA\'" ng-include="\'app/pages/dashboard/DCBI/widgets/mei-long.html\'" ng-controller="ShaCtrl as ctrl"></div><div class="row" ng-if="vm.warehouseItem.selected.value == \'PEK\'" ng-include="\'app/pages/dashboard/DCBI/widgets/mei-long.html\'" ng-controller="ShaCtrl as ctrl"></div><div class="row" ng-if="vm.warehouseItem.selected.value == \'SH001\'" ng-include="\'app/pages/dashboard/DCBI/widgets/he-qing.html\'" ng-controller="HeqCtrl as ctrl"></div></div>');
$templateCache.put('app/pages/settings/cleaingRule/cleaingRule.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u8BA1\u6570\u7EC4</label><div class="col-sm-9"><div class="input-group"><ui-select ng-model="vm.dropdonw.groupCount.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.groupCount.onSelected($item, $model)" on-remove="vm.dropdonw.groupCount.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u8BA1\u6570\u7EC4">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.groupCount.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.groupCount.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u72B6\u6001</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="status" ng-model="vm.dropdonw.status.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.status.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u72B6\u6001">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.status.selectItems | filter: $select.search"><span ng-bind-html="item.text"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.status.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div><div ba-panel="" class="report-grid table-edit"><button class="btn btn-primary btn-with-icon pull-right" ng-disabled="vm.grid.addBtnDisabled" ng-click="vm.grid.add()"><i class="fa fa-plus-circle"></i>\u6DFB\u52A0\u89C4\u5219</button><table class="table table-hover" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th>\u8BA1\u6570\u7EC4</th><th>\u79D1\u76EE</th><th>\u5B50\u540D\u79F0-\u7F16\u7801</th><th>\u670D\u52A1\u9879\u76EE</th><th>\u5355\u4F4D</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td class="ui-select"><div ng-init="item.groupSelect={id:item.groupCode,name:item.groupName}" editable-ui-select="item.groupSelect" data-e-form="rowform" data-e-name="groupSelect" name="group" theme="bootstrap" data-e-ng-model="item.groupSelect" onshow="vm.grid.dropdonw.group.onShow()" e-ng-change="vm.grid.dropdonw.group.onChange($data,item)" onbeforesave="vm.grid.checkTempEmpty($data)" e-required=""><editable-ui-select-match placeholder="\u9009\u62E9\u8BA1\u6570\u7EC4">{{$select.selected.name || \'\u9009\u62E9\u8BA1\u6570\u7EC4\'}}</editable-ui-select-match><editable-ui-select-choices repeat="t in vm.grid.dropdonw.group.data | filter: $select.search"><span ng-bind-html="t.name| highlight: $select.search"></span></editable-ui-select-choices><span class="over-hidden">{{item.groupSelect.name}}</span></div></td><td class="ui-select"><div ng-init="item.subjectSelect={id:item.subjectId,name:item.subjectName}" editable-ui-select="item.subjectSelect" data-e-form="rowform" data-e-name="subjectSelect" name="subjectName" theme="bootstrap" data-e-ng-model="item.subjectSelect" onshow="vm.grid.dropdonw.subject.onShow()" e-ng-change="vm.grid.dropdonw.subject.onChange($data,item)" onbeforesave="vm.grid.checkTempEmpty($data)" e-required=""><editable-ui-select-match placeholder="\u9009\u62E9\u79D1\u76EE">{{$select.selected.name || \'\u9009\u62E9\u79D1\u76EE\'}}</editable-ui-select-match><editable-ui-select-choices repeat="t in vm.grid.dropdonw.subject.data | filter: $select.search"><span ng-bind-html="t.name| highlight: $select.search"></span></editable-ui-select-choices><span class="over-hidden">{{item.subjectSelect.name}}</span></div></td><td class="ui-select"><div ng-init="item.subSelect={id:item.subCode,name:item.subName}" editable-ui-select="item.subSelect" data-e-form="rowform" data-e-name="subSelect" name="sub" theme="bootstrap" data-e-ng-model="item.subSelect" onshow="vm.grid.dropdonw.sub.onShow()" e-ng-change="vm.grid.dropdonw.sub.onChange($data,item)" onbeforesave="vm.grid.checkTempEmpty($data)" e-required=""><editable-ui-select-match placeholder="\u9009\u62E9\u5B50\u540D\u79F0\u7F16\u7801">{{$select.selected.name || \'\u9009\u62E9\u5B50\u540D\u79F0\u7F16\u7801\'}}</editable-ui-select-match><editable-ui-select-choices repeat="t in vm.grid.dropdonw.sub.data | filter: $select.search"><span ng-bind-html="t.name| highlight: $select.search"></span></editable-ui-select-choices><span class="over-hidden">{{item.subSelect.name}}</span></div></td><td><div editable-text="item.chargeName" e-name="chargeName" class="over-hidden" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform">{{item.chargeName}}</div></td><td><div editable-text="item.unitName" e-name="unitName" class="over-hidden" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform">{{item.unitName}}</div></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="vm.grid.inserted == item" onbeforesave="vm.grid.update($index,$data,item)"><button type="submit" ng-disabled="rowform.$waiting" class="btn-success fa fa-check"></button> <button type="button" ng-disabled="rowform.$waiting" class="btn-danger fa fa-ban" ng-click="vm.grid.cancel($index,item,rowform)"></button></form><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.addBtnDisabled = true;rowform.$show()"><i class="fa fa-pencil-square-o"></i> \u7F16\u8F91</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.disabled($index);"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{ item.isActive?\'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><st-pagination class="col-md-11" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-1 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{(vm.grid.tableState.pagination.start/vm.grid.tableState.pagination.number)+1}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/settings/customer/customer.form.html','<div class="userinfo"><form name="vm.myForm" autocomplete="off"><div ng-if="vm.optionEnum.add == vm.currentOption"><h3 class="with-line">\u8D26\u53F7</h3><div class="row"><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.account.$invalid && (vm.myForm.account.$dirty || vm.myForm.$submitted)}"><label for="account">\u8D26\u53F7</label> <input class="form-control" id="account" name="account" ng-model="vm.model.account" placeholder="\u8D26\u53F7" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.password.$invalid && (vm.myForm.password.$dirty || vm.myForm.$submitted)}"><label for="password">\u5BC6\u7801</label> <input class="form-control" id="password" name="password" ng-minlength="6" ng-model="vm.model.password" placeholder="\u6700\u5C11\u8F93\u51656\u4E2A\u5B57\u7B26" required="" type="password"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.model.password != vm.model.confirmPassword || vm.myForm.confirmPassword.$invalid && (vm.myForm.confirmPassword.$dirty || vm.myForm.$submitted)}"><label for="confirmPassword">\u786E\u8BA4\u5BC6\u7801</label> <input class="form-control" id="confirmPassword" name="confirmPassword" ng-minlength="6" placeholder="\u6700\u5C11\u8F93\u51656\u4E2A\u5B57\u7B26" ng-model="vm.model.confirmPassword" required="" type="password"></div></div><h3 class="with-line">\u5BA2\u6237\u4FE1\u606F</h3></div><div class="row"><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.name.$invalid && (vm.myForm.name.$dirty || vm.myForm.$submitted)}"><label for="name">\u540D\u79F0</label> <input class="form-control" id="name" name="name" ng-model="vm.model.name" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.code.$invalid && (vm.myForm.code.$dirty || vm.myForm.$submitted)}"><label for="code">\u7F16\u7801</label> <input class="form-control" id="code" name="code" ng-model="vm.model.code" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.contactName.$invalid && (vm.myForm.contactName.$dirty || vm.myForm.$submitted)}"><label for="contactName">\u8054\u7CFB\u4EBA</label> <input class="form-control" maxlength="32" id="contactName" name="contactName" ng-required="true" ng-model="vm.model.contactName" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.contactMobile.$invalid && (vm.myForm.contactMobile.$dirty || vm.myForm.$submitted)}"><label for="contactMobile">\u8054\u7CFB\u4EBA\u624B\u673A\u53F7</label> <input class="form-control" ng-model="vm.model.contactMobile" required="" id="contactMobile" name="contactMobile" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.email.$invalid && (vm.myForm.email.$dirty || vm.myForm.$submitted)}"><label for="email">Email</label> <input class="form-control" id="email" name="email" ng-model="vm.model.email" required="" type="email"></div></div><div class="row"><div class="form-group clearfix col-md-2" ng-class="{\'has-error\': vm.myForm.phoneArea.$invalid && (vm.myForm.phoneArea.$dirty || vm.myForm.$submitted)}"><label for="phoneArea">\u533A\u53F7</label> <input class="form-control" id="phoneArea" name="phoneArea" ng-model="vm.model.phoneArea" required="" type="tel"></div><div class="form-group clearfix col-md-4" ng-class="{\'has-error\': vm.myForm.phone.$invalid && (vm.myForm.phone.$dirty || vm.myForm.$submitted)}"><label for="phone">\u53F7\u7801</label> <input class="form-control" id="phone" name="phone" ng-model="vm.model.phone" required="" type="tel"></div><div class="form-group clearfix col-md-2" ng-class="{\'has-error\': vm.myForm.phoneExtension.$invalid && (vm.myForm.phoneExtension.$dirty || vm.myForm.$submitted)}"><label for="phoneExtension">\u5206\u673A\u53F7</label> <input class="form-control" id="phoneExtension" name="phoneExtension" ng-model="vm.model.phoneExtension" required="" type="tel"></div></div><div class="row"><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.regionId.$invalid && (vm.myForm.regionId.$dirty || vm.myForm.$submitted)}"><label for="regionId">\u5730\u533A</label><div region-picker="" name="regionId" ng-required="true" ng-model="vm.model.regionId"></div></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.address.$invalid && (vm.myForm.address.$dirty || vm.myForm.$submitted)}"><label for="address">\u8BE6\u7EC6\u5730\u5740</label> <input class="form-control" id="address" name="address" ng-model="vm.model.address" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.bankName.$invalid && (vm.myForm.bankName.$dirty || vm.myForm.$submitted)}"><label for="bankName">\u94F6\u884C\u540D\u79F0</label> <input class="form-control" id="bankName" name="bankName" ng-model="vm.model.bankName" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.bankAccount.$invalid && (vm.myForm.bankAccount.$dirty || vm.myForm.$submitted)}"><label for="bankAccount">\u94F6\u884C\u8D26\u6237</label> <input class="form-control" id="bankAccount" name="bankAccount" ng-model="vm.model.bankAccount" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.bankAccountHolder.$invalid && (vm.myForm.bankAccountHolder.$dirty || vm.myForm.$submitted)}"><label for="bankAccountHolder">\u6301\u5361\u4EBA</label> <input class="form-control" id="bankAccountHolder" name="bankAccountHolder" ng-model="vm.model.bankAccountHolder" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.taxNumber.$invalid && (vm.myForm.taxNumber.$dirty || vm.myForm.$submitted)}"><label for="taxNumber">\u7A0E\u53F7</label> <input class="form-control" id="taxNumber" name="taxNumber" ng-model="vm.model.taxNumber" required="" type="text"></div></div><div class="row"><div class="form-group clearfix col-md-12"><label for="price">\u8BF4\u660E</label> <textarea class="form-control" style="height:auto;" rows="2" ng-model="vm.model.comment" name="comment">\r\n            </textarea></div></div></form></div>');
$templateCache.put('app/pages/settings/customer/customer.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u540D\u79F0</label><div class="col-sm-9"><div class="input-group"><input class="form-control" placeholder="\u540D\u79F0" ng-model="vm.search.name" ng-keyup="vm.onKeyup($event)"> <span class="input-group-btn"><button type="button" ng-click="vm.onClear(\'name\')" class="btn btn-default"><span class="fa fa-times"></span></button></span></div></div></div><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u7F16\u7801</label><div class="col-sm-9"><div class="input-group"><input class="form-control" placeholder="\u7F16\u7801" ng-model="vm.search.code" ng-keyup="vm.onKeyup($event)"> <span class="input-group-btn"><button type="button" ng-click="vm.onClear(\'code\')" class="btn btn-default"><span class="fa fa-times"></span></button></span></div></div></div><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u72B6\u6001</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="status" ng-model="vm.dropdonw.status.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.status.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u72B6\u6001">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.status.selectItems | filter: $select.search"><span ng-bind-html="item.text"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.status.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div><div ba-panel="" class="report-grid table-edit"><button class="btn btn-primary btn-with-icon pull-right" ng-disabled="vm.grid.addBtnDisabled" ng-click="vm.grid.options(null,vm.grid.optionEnum.add);"><i class="fa fa-plus-circle"></i>\u6DFB\u52A0\u5BA2\u6237</button><table class="table table-hover" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th>\u540D\u79F0</th><th>\u7F16\u7801</th><th>\u72B6\u6001</th><th>\u5907\u6CE8</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td><span>{{ item.name }}</span></td><td><span>{{ item.code }}</span></td><td class="editable-radiolist"><span>{{ item.isActive?\'\u542F\u7528\':\'\u7981\u7528\' }}</span></td><td><span>{{ item.comment}}</span></td><td><div class="dropdown"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.options(item,vm.grid.optionEnum.update);"><i class="fa fa-pencil-square-o"></i> \u7F16\u8F91</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.options(item,vm.grid.optionEnum.updatePwd);"><i class="fa fa-pencil-square-o"></i> \u91CD\u7F6E\u5BC6\u7801</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.options(item,vm.grid.optionEnum.active);"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{ item.isActive?\'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><st-pagination class="col-md-11" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-1 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{(vm.grid.tableState.pagination.start/vm.grid.tableState.pagination.number)+1}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/settings/customer/customer.pwd.form.html','<div class="userinfo"><form name="vm.myForm" autocomplete="off"><div class="row"><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.account.$invalid && (vm.myForm.account.$dirty || vm.myForm.$submitted)}"><label for="account">\u8D26\u53F7</label> <input class="form-control" id="account" name="account" ng-model="vm.model.account" placeholder="\u8D26\u53F7" ng-disabled="true" readonly="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.password.$invalid && (vm.myForm.password.$dirty || vm.myForm.$submitted)}"><label for="password">\u5BC6\u7801</label> <input class="form-control" id="password" name="password" ng-minlength="6" ng-model="vm.model.password" placeholder="\u6700\u5C11\u8F93\u51656\u4E2A\u5B57\u7B26" required="" type="password"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.model.password != vm.model.confirmPassword || vm.myForm.confirmPassword.$invalid && (vm.myForm.confirmPassword.$dirty || vm.myForm.$submitted)}"><label for="confirmPassword">\u786E\u8BA4\u5BC6\u7801</label> <input class="form-control" id="confirmPassword" name="confirmPassword" ng-minlength="6" placeholder="\u6700\u5C11\u8F93\u51656\u4E2A\u5B57\u7B26" ng-model="vm.model.confirmPassword" required="" type="password"></div></div></form></div>');
$templateCache.put('app/pages/settings/department/department.html','<div ba-panel="" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-5" include-with-scope="app/pages/settings/widgets/tree.html"></div><div class="profile-page col-sm-7"><h3 class="with-line">\u5F53\u524D\u9009\u62E9\u8282\u70B9 &nbsp;&nbsp;<span class="text-danger" ng-bind="vm.model.text||\'\u65B0\u5EFA\u90E8\u95E8\'"></span></h3><form name="vm.myForm" autocomplete="off"><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.mcode.$invalid && (vm.myForm.mcode.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u7F16\u7801</label><div class="col-sm-9"><input name="mcode" ng-required="true" type="text" class="form-control" id="inputRoom" ng-model="vm.model.code" placeholder="\u7F16\u7801"></div></div><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.mname.$invalid && (vm.myForm.mname.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u540D\u79F0</label><div class="col-sm-9"><input name="mname" ng-required="true" type="text" class="form-control" ng-model="vm.model.text" placeholder="\u540D\u79F0"></div></div><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.employee.$invalid && (vm.myForm.employee.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u8D1F\u8D23\u4EBA</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="employee" ng-model="vm.dropdonw.employee.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.employee.onSelected($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u8D1F\u8D23\u4EBA">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.employee.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.employee.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.comment.$invalid && (vm.myForm.comment.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u5907\u6CE8</label><div class="col-sm-9"><textarea name="comment" class="form-control" ng-model="vm.model.comment" placeholder="\u5907\u6CE8">\r\n                        </textarea></div></div></form><button type="button" ng-disabled="vm.grid.addBtnDisabled" class="btn btn-primary btn-with-icon save-profile pull-right" ng-click="vm.saveTreeNode()"><i class="ion-android-checkmark-circle"></i>\u4FDD\u5B58</button></div></div></div>');
$templateCache.put('app/pages/settings/project/project.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u540D\u79F0</label><div class="col-sm-9"><div class="input-group"><input class="form-control" placeholder="\u540D\u79F0" ng-model="vm.search.name" ng-keyup="vm.onKeyup($event)"> <span class="input-group-btn"><button type="button" ng-click="vm.onClear(\'name\')" class="btn btn-default"><span class="fa fa-times"></span></button></span></div></div></div><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u7F16\u7801</label><div class="col-sm-9"><div class="input-group"><input class="form-control" placeholder="\u7F16\u7801" ng-model="vm.search.code" ng-keyup="vm.onKeyup($event)"> <span class="input-group-btn"><button type="button" ng-click="vm.onClear(\'code\')" class="btn btn-default"><span class="fa fa-times"></span></button></span></div></div></div><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u72B6\u6001</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="status" ng-model="vm.dropdonw.status.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.status.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u72B6\u6001">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.status.selectItems | filter: $select.search"><span ng-bind-html="item.text"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.status.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div><div ba-panel="" class="report-grid table-edit"><button class="btn btn-primary btn-with-icon pull-right" ng-disabled="vm.grid.addBtnDisabled" ng-click="vm.grid.add()"><i class="fa fa-plus-circle"></i>\u6DFB\u52A0\u9879\u76EE</button><table class="table table-hover" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th>\u540D\u79F0</th><th>\u7F16\u7801</th><th>\u6240\u5C5E\u5BA2\u6237</th><th>\u4ED3\u5E93</th><th>\u72B6\u6001</th><th>\u5907\u6CE8</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td><span editable-text="item.name" e-name="name" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform" e-placeholder="\u540D\u79F0" class="over-hidden" e-required="">{{ item.name }}</span></td><td><span editable-text="item.code" e-name="code" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform" e-placeholder="\u7F16\u7801" class="over-hidden" e-required="">{{ item.code }}</span></td><td class="ui-select"><div ng-init="item.customerSelected={id:item.customerId, name:item.customerName}" editable-ui-select="item.customerSelected" data-e-form="rowform" data-e-name="customerSelected" name="customerName" theme="bootstrap" data-e-ng-model="item.customerSelected" onshow="vm.grid.dropdown.customer.onShow()" e-ng-change="vm.grid.dropdown.customer.onChange($data,item)" onbeforesave="vm.grid.checkTempEmpty($data)" e-required=""><editable-ui-select-match placeholder="\u6240\u5C5E\u5BA2\u6237">{{$select.selected.name || \'\u6240\u5C5E\u5BA2\u6237\'}}</editable-ui-select-match><editable-ui-select-choices repeat="t in vm.grid.dropdown.customer.data | filterSelected:$select.selected:\'id\'"><span ng-bind-html="t.name"></span></editable-ui-select-choices><span class="over-hidden">{{item.customerSelected.name}}</span></div></td><td class="ui-select"><div editable-ui-select="item.warehouseSelected" data-e-multiple="true" data-e-form="rowform" data-e-name="warehouseSelected" name="warehouseName" theme="bootstrap" data-e-ng-model="item.warehouseSelected" onshow="vm.grid.dropdown.warehouse.onShow()" e-ng-change="vm.grid.dropdown.warehouse.onChange($data,item)" onbeforesave="vm.grid.checkTempEmpty($data)" e-required=""><editable-ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$item.name || \'\u9009\u62E9\u4ED3\u5E93\'}}</editable-ui-select-match><editable-ui-select-choices repeat="t in vm.grid.dropdown.warehouse.data | filterSelected:$select.selected:\'id\'"><span ng-bind-html="t.name | highlight: $select.search"></span></editable-ui-select-choices><span ng-repeat="w in item.warehouseSelected" class="over-hidden">{{w.name}}&nbsp;&nbsp;</span></div></td><td class="editable-radiolist"><span ng-init="item.isActive=(item.isActive===true?true:false)" editable-radiolist="item.isActive" data-e-form="rowform" data-e-name="isActive" class="over-hidden" e-ng-options="s.value as s.text for s in ::vm.grid.radioList.status.data track by s.value">{{ item.isActive?\'\u542F\u7528\':\'\u7981\u7528\' }}</span></td><td><span editable-textarea="item.comment" data-e-form="rowform" data-e-name="comment" e-rows="7" class="over-hidden" e-cols="40">{{ item.comment}}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="vm.grid.inserted == item" onbeforesave="vm.grid.update($index,$data,item)"><button type="submit" title="\u63D0\u4EA4" ng-disabled="rowform.$waiting" class="btn-success fa fa-check"></button> <button type="button" title="\u53D6\u6D88" ng-disabled="rowform.$waiting" class="btn-danger fa fa-ban" ng-click="vm.grid.cancel($index,item,rowform)"></button></form><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.addBtnDisabled = true;rowform.$show()"><i class="fa fa-pencil-square-o"></i> \u7F16\u8F91</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.disabled($index);"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{ item.isActive?\'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><st-pagination class="col-md-11" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-1 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{(vm.grid.tableState.pagination.start/vm.grid.tableState.pagination.number)+1}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/settings/roles/company.html','<div><h3>&nbsp;</h3><div class="row"><div class="col-md-6"><label class="control-label form-control" for="ck-all"><input type="checkbox" id="ck-all" ng-model="vm.company.selectedAll" ng-click="vm.company.selectedAllClick()"> &nbsp;<span>\u5168\u9009</span></label></div></div><div class="row"><div class="col-md-6" ng-repeat="item in vm.company.data"><label class="control-label form-control" for="ck-{{item.id}}"><input type="checkbox" id="ck-{{item.id}}" ng-model="item.state.selected" ng-click="vm.company.itemClick(item.state.selected)"> &nbsp;<span>{{item.name}}</span></label></div></div><h3>&nbsp;</h3></div>');
$templateCache.put('app/pages/settings/roles/roleInfo.html','<div class="userinfo"><form name="vm.myForm" autocomplete="off"><h3>&nbsp;</h3><div class="row"><div class="col-md-12"><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.displayName.$invalid && (vm.myForm.displayName.$dirty || vm.myForm.$submitted)}"><label for="displayName">\u89D2\u8272\u540D\u79F0</label> <input class="form-control" maxlength="32" ng-model="vm.model.role.displayName" name="displayName" type="text" required=""></div><div class="checkbox"><label class="checkbox-inline custom-checkbox nowrap" for="isDefault"><input type="checkbox" id="isDefault" ng-model="vm.model.role.isDefault"> <span>&nbsp;&nbsp;&nbsp;&nbsp;\u9ED8\u8BA4</span></label><p><var>\u65B0\u7528\u6237\u5C06\u9ED8\u8BA4\u62E5\u6709\u6B64\u89D2\u8272.</var></p></div></div></div></form></div>');
$templateCache.put('app/pages/settings/roles/roleModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{vm.title}}</h4></div><div class="modal-body"><div class="modal-body-content"><ul class="nav nav-tabs"><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.name}"><a ng-click="vm.menuClick(vm.menu.name)">\u89D2\u8272\u540D\u79F0</a></li><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.prem}"><a ng-click="vm.menuClick(vm.menu.prem)">\u6743\u9650</a></li><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.department}"><a ng-click="vm.menuClick(vm.menu.department)">\u90E8\u95E8</a></li><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.project}"><a ng-click="vm.menuClick(vm.menu.project)">\u9879\u76EE</a></li><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.company}"><a ng-click="vm.menuClick(vm.menu.company)">\u516C\u53F8</a></li></ul><section ng-show="vm.currentMenu == vm.menu.name" include-with-scope="app/pages/settings/roles/roleInfo.html"></section><section ng-show="vm.currentMenu == vm.menu.prem"><div class="col-md-12"><h3>&nbsp;</h3><div js-tree="vm.tree.prem.basicConfig" ng-model="vm.tree.prem.treeData" tree="vm.tree.prem.basicTree" tree-events-obj="vm.tree.prem.treeEventsObj"></div><h3>&nbsp;</h3></div></section><section ng-show="vm.currentMenu == vm.menu.department"><div class="col-md-12"><h3>&nbsp;</h3><div js-tree="vm.tree.department.basicConfig" ng-model="vm.tree.department.treeData" tree="vm.tree.department.basicTree" tree-events-obj="vm.tree.department.treeEventsObj"></div><h3>&nbsp;</h3></div></section><section ng-show="vm.currentMenu == vm.menu.project"><div class="col-md-12"><h3>&nbsp;</h3><div js-tree="vm.tree.project.basicConfig" ng-model="vm.tree.project.treeData" tree="vm.tree.project.basicTree" tree-events-obj="vm.tree.project.treeEventsObj"></div><h3>&nbsp;</h3></div></section><section ng-show="vm.currentMenu == vm.menu.company" include-with-scope="app/pages/settings/roles/company.html"></section></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.ok()">\u4FDD\u5B58</button></div></div>');
$templateCache.put('app/pages/settings/roles/roles.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u540D\u79F0</label><div class="col-sm-9"><div class="input-group"><input class="form-control" placeholder="\u540D\u79F0" ng-model="vm.search.name" ng-keyup="vm.onKeyup($event)"> <span class="input-group-btn"><button type="button" ng-click="vm.onClear(\'name\')" class="btn btn-default"><span class="fa fa-times"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u72B6\u6001</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="status" ng-model="vm.dropdonw.status.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.status.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u72B6\u6001">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.status.selectItems | filter: $select.search"><span ng-bind-html="item.text"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.status.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div><div ba-panel="" class="report-grid table-edit"><button class="btn btn-primary btn-with-icon pull-right" ng-disabled="vm.grid.addBtnDisabled" ng-click="vm.grid.options(null,vm.grid.optionEnum.add)"><i class="fa fa-plus-circle"></i>\u6DFB\u52A0\u89D2\u8272</button><table class="table table-hover" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th>\u89D2\u8272\u540D\u79F0</th><th>\u521B\u5EFA\u65F6\u95F4</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td><span class="over-hidden">{{ item.displayName }}</span></td><td><span class="over-hidden">{{ item.creationTime|date:\'yyyy-MM-dd\' }}</span></td><td><div class="dropdown"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.options(item,vm.grid.optionEnum.update);"><i class="fa fa-pencil-square-o"></i>\u7F16\u8F91</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.options(item,vm.grid.optionEnum.del);"><i class="fa fa-trash-o"></i>\u5220\u9664</a></li></ul></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><st-pagination class="col-md-11" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-1 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{vm.grid.tableState.pagination.pageindex}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/settings/roles/treeTemp.html','<div class="col-md-12"><h3>&nbsp;</h3><div js-tree="vm.basicConfig" ng-model="vm.treeData" tree="vm.basicTree" tree-events-obj="vm.treeEventsObj"></div><h3>&nbsp;</h3></div>');
$templateCache.put('app/pages/settings/saleTariff/saleTariff.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u5BA2\u6237</label><div class="col-sm-9"><div class="input-group"><ui-select ng-model="vm.dropdonw.customer.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.customer.onSelected($item, $model)" on-remove="vm.dropdonw.customer.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u5BA2\u6237">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.customer.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.customer.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u9879\u76EE</label><div class="col-sm-9"><div class="input-group"><ui-select ng-model="vm.dropdonw.project.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.project.onSelected($item, $model)" on-remove="vm.dropdonw.project.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u9879\u76EE">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.project.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.project.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u4ED3\u5E93</label><div class="col-sm-9"><div class="input-group"><ui-select ng-model="vm.dropdonw.warehouse.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.warehouse.onSelected($item, $model)" on-remove="vm.dropdonw.warehouse.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.warehouse.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.warehouse.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u72B6\u6001</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="status" ng-model="vm.dropdonw.status.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.status.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u72B6\u6001">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.status.selectItems | filter: $select.search"><span ng-bind-html="item.text"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.status.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div><div ba-panel="" class="report-grid table-edit"><button class="btn btn-primary btn-with-icon pull-right" ui-state="\'Settings.SaleTariffDetail\'"><i class="fa fa-plus-circle"></i>&nbsp;&nbsp;\u6DFB\u52A0</button><table class="table table-hover" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th>\u540D\u79F0</th><th>\u7F16\u7801</th><th>\u5BA2\u6237</th><th>\u9879\u76EE</th><th>\u4ED3\u5E93</th><th>\u6709\u6548\u671F(\u5F00\u59CB)</th><th>\u6709\u6548\u671F(\u7ED3\u675F)</th><th>\u6709\u6548\u671F(\u5929\u6570)</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td><span ng-bind="item.name" class="over-hidden"></span></td><td><span ng-bind="item.code" class="over-hidden"></span></td><td><span ng-bind="item.customerName" class="over-hidden"></span></td><td><span ng-bind="item.projectName" class="over-hidden"></span></td><td><span ng-bind="item.warehouseName" class="over-hidden"></span></td><td><span ng-bind="item.validityFrom|date:\'yyyy-MM-dd\'" class="over-hidden"></span></td><td><span ng-bind="item.validityTo|date:\'yyyy-MM-dd\'" class="over-hidden"></span></td><td><span ng-bind="item.validityDuration" class="over-hidden"></span></td><td><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" ui-state="\'Settings.SaleTariffDetail\'" ui-state-params="{id:item.id}"><i class="fa fa-eye"></i> \u67E5\u770B</a> <a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.disabled($index);"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{item.isActive? \'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><st-pagination class="col-md-11" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-1 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{(vm.grid.tableState.pagination.start/vm.grid.tableState.pagination.number)+1}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/settings/saleTariff/saleTariffDetail.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content sale-tariff-detail"><button type="button" class="btn btn-default btn-with-icon" ui-state="\'Settings.SaleTariff\'"><i class="ion-chevron-left"></i>\u8FD4\u56DE</button> <button type="button" ng-disabled="vm.order.grid.addBtnDisabled || vm.cycleCharge.grid.addBtnDisabled" class="btn btn-primary btn-with-icon save-profile pull-right" ng-click="vm.submitDate()"><i class="ion-android-checkmark-circle"></i>\u4FDD\u5B58\u4EF7\u683C\u6587\u4EF6</button><h3 class="with-line">\u4EF7\u683C\u6587\u4EF6</h3><form name="vm.myForm"><div class="row"><div class="form-group clearfix col-md-4" ng-class="{\'has-error\': vm.myForm.mcode.$invalid && (vm.myForm.mcode.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u7F16\u7801</label><div class="col-sm-9"><input name="mcode" ng-required="true" type="text" class="form-control" id="mcode" ng-model="vm.model.code" placeholder="\u7F16\u7801"></div></div><div class="form-group clearfix col-md-4" ng-class="{\'has-error\': vm.myForm.mname.$invalid && (vm.myForm.mname.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u540D\u79F0</label><div class="col-sm-9"><input name="mname" ng-required="true" type="text" class="form-control" id="mname" ng-model="vm.model.name" placeholder="\u540D\u79F0"></div></div><div class="form-group clearfix col-md-4" ng-class="{\'has-error\': vm.myForm.customer.$invalid && (vm.myForm.customer.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u5BA2\u6237</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="customer" ng-required="true" ng-model="vm.dropdown.customer.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdown.customer.onSelected($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u5BA2\u6237">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.customer.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div></div></div><div class="form-group clearfix col-md-4" ng-class="{\'has-error\': vm.myForm.project.$invalid && (vm.myForm.project.partnerId.$dirty || vm.myForm.$submitted)}"><label class="col-sm-3 control-label">\u9879\u76EE</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="project" ng-required="true" ng-model="vm.dropdown.project.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdown.project.onSelected($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u9879\u76EE">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.project.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div></div></div><div class="form-group clearfix col-md-4" ng-class="{\'has-error\': vm.myForm.warehouse.$invalid && (vm.myForm.warehouse.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputPhone" class="col-sm-3 control-label">\u4ED3\u5E93</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="warehouse" ng-required="true" ng-model="vm.dropdown.warehouse.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdown.warehouse.onSelected($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.warehouse.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div></div></div><div class="form-group clearfix col-md-4" ng-class="{\'has-error\': ((vm.myForm.beginDate.$invalid && (vm.myForm.beginDate.partnerId.$dirty || vm.myForm.$submitted))||(vm.myForm.endDate.$invalid && (vm.myForm.endDate.partnerId.$dirty || vm.myForm.$submitted)))}"><label for="inputEmail3" class="col-sm-3 control-label">\u6709\u6548\u671F</label><div class="col-sm-9 inner-input"><div class="input-group"><input name="beginDate" ng-required="true" type="text" class="form-control" uib-datepicker-popup="{{vm.datepickerBegin.format}}" datepicker-options="vm.datepickerBegin.options" ng-model="vm.model.validityFrom" is-open="vm.datepickerBegin.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="altInputFormats" show-button-bar="true" ng-change="vm.datepickerBegin.dateChanged()" ng-click="vm.datepickerBegin.open()" placeholder="\u5F00\u59CB\u65E5\u671F"> <span class="input-group-addon">~</span> <input name="endDate" ng-required="true" type="text" class="form-control" uib-datepicker-popup="{{vm.datepickerEnd.format}}" datepicker-options="vm.datepickerEnd.options" ng-model="vm.model.validityTo" is-open="vm.datepickerEnd.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="altInputFormats" show-button-bar="true" ng-change="vm.datepickerEnd.dateChanged()" ng-click="vm.datepickerEnd.open()" placeholder="\u7ED3\u675F\u65E5\u671F"></div></div></div></div></form><div class="row"><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u660E\u7EC6\u72B6\u6001</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="status" ng-model="vm.dropdonw.status.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.status.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u72B6\u6001">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.status.selectItems | filter: $select.search"><span ng-bind-html="item.text"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.status.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div><a56-edit-table ctrl="vm" conf-name="order"></a56-edit-table><a56-edit-table ctrl="vm" conf-name="stock"></a56-edit-table><a56-edit-table ctrl="vm" conf-name="cycleCharge"></a56-edit-table><a56-edit-table ctrl="vm" conf-name="stockCell"></a56-edit-table><button type="button" ng-disabled="vm.order.grid.addBtnDisabled" class="btn btn-primary btn-with-icon save-profile pull-right" ng-click="vm.submitDate()"><i class="ion-android-checkmark-circle"></i>\u4FDD\u5B58\u4EF7\u683C\u6587\u4EF6</button></div></div>');
$templateCache.put('app/pages/settings/subject/subject.html','<div ba-panel="" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-5" include-with-scope="app/pages/settings/widgets/tree.html"></div><div class="profile-page col-sm-7"><h3 class="with-line">\u5F53\u524D\u9009\u62E9\u8282\u70B9 &nbsp;&nbsp;<span class="text-danger" ng-bind="vm.model.text||\'\u65B0\u5EFA\u79D1\u76EE\'"></span></h3><form name="vm.myForm" autocomplete="off"><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.mcode.$invalid && (vm.myForm.mcode.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u7F16\u7801</label><div class="col-sm-9"><input name="mcode" ng-required="true" type="text" class="form-control" id="inputRoom" ng-model="vm.model.code" placeholder="\u7F16\u7801"></div></div><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.mname.$invalid && (vm.myForm.mname.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u540D\u79F0</label><div class="col-sm-9"><input name="mname" ng-required="true" type="text" class="form-control" ng-model="vm.model.text" placeholder="\u540D\u79F0"></div></div><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.comment.$invalid && (vm.myForm.comment.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u5907\u6CE8</label><div class="col-sm-9"><textarea name="comment" class="form-control" ng-model="vm.model.comment" placeholder="\u5907\u6CE8">\r\n                        </textarea></div></div></form><button type="button" ng-disabled="vm.grid.addBtnDisabled" class="btn btn-primary btn-with-icon save-profile pull-right" ng-click="vm.saveTreeNode()"><i class="ion-android-checkmark-circle"></i>\u4FDD\u5B58</button></div></div></div>');
$templateCache.put('app/pages/settings/users/userInfo.html','<div class="userinfo"><form name="vm.myForm" autocomplete="off"><h3>&nbsp;</h3><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.myForm.uName.$invalid && (vm.myForm.uName.$dirty || vm.myForm.$submitted)}"><label for="uName">\u540D\u5B57 *</label> <input class="form-control" maxlength="32" ng-model="vm.model.user.name" name="uName" required="" type="text"></div><div class="form-group" ng-class="{\'has-error\': vm.myForm.surname.$invalid && (vm.myForm.surname.$dirty || vm.myForm.$submitted)}"><label for="surname">\u59D3\u6C0F *</label> <input class="form-control" maxlength="32" ng-model="vm.model.user.surname" name="surname" required="" type="text"></div><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.emailAddress.$invalid && (vm.myForm.emailAddress.$dirty || vm.myForm.$submitted)}"><label for="emailAddress">\u90AE\u7BB1\u5730\u5740 *</label> <input class="form-control" maxlength="32" name="emailAddress" ng-model="vm.model.user.emailAddress" required="" type="text"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group clearfix"><label for="phoneNumber">\u7535\u8BDD\u53F7\u7801</label> <input class="form-control" maxlength="32" ng-model="vm.model.user.phoneNumber" name="phoneNumber" type="text"></div><div ng-if="vm.model.user.id" class="form-group clearfix"><label for="userName">\u7528\u6237\u540D</label><div class="form-control" ng-disabled="true">{{ vm.model.user.userName}}</div><var class="help-block">\u7BA1\u7406\u7528\u6237\uFF0C\u4E0D\u80FD\u4FEE\u6539\u7528\u6237\u540D.</var></div><div ng-if="!vm.model.user.id" class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.emailAddress.$invalid && (vm.myForm.emailAddress.$dirty || vm.myForm.$submitted)}"><label for="userName">\u7528\u6237\u540D*</label> <input class="form-control" maxlength="32" ng-model="vm.model.user.userName" name="userName" type="text"></div><div class="form-group clearfix" ng-class="{\'has-error\': (!vm.model.user.id || !!vm.model.user.passwordConfirm) && vm.myForm.password.$invalid && (vm.myForm.password.$dirty || vm.myForm.$submitted)}"><label for="Npasswordme">\u5BC6\u7801</label> <input class="form-control" maxlength="32" name="password" ng-required="!vm.model.user.id || !!vm.model.user.passwordConfirm" ng-model="vm.model.user.password" type="password"></div><div class="form-group clearfix" ng-class="{\'has-error\': vm.model.user.passwordConfirm != vm.model.user.password && (vm.myForm.passwordConfirm.$dirty || vm.myForm.password.$dirty || vm.myForm.$submitted)}"><label for="passwordConfirm">\u786E\u8BA4\u5BC6\u7801</label> <input class="form-control" maxlength="32" ng-model="vm.model.user.passwordConfirm" ng-required="vm.model.user.password" name="passwordConfirm" type="password"> <var ng-show="vm.model.user.passwordConfirm != vm.model.user.password" style="color:red;">\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u4E00\u81F4</var></div><div class="checkbox"><label class="checkbox-inline custom-checkbox nowrap" for="isActive"><input type="checkbox" id="isActive" ng-model="vm.model.user.isActive"> <span>&nbsp;&nbsp;&nbsp;&nbsp;\u6FC0\u6D3B</span></label></div><div class="checkbox"><label class="checkbox-inline custom-checkbox nowrap" for="isLockoutEnabled"><input type="checkbox" id="isLockoutEnabled" ng-model="vm.model.user.isLockoutEnabled"> <span>&nbsp;&nbsp;&nbsp;&nbsp;\u662F\u5426\u542F\u7528\u9501\u5B9A\uFF1F</span></label></div></div></div></form></div>');
$templateCache.put('app/pages/settings/users/userModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{vm.title}}</h4></div><div class="modal-body"><div class="modal-body-content"><ul class="nav nav-tabs"><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.userInfo}"><a ng-click="vm.menuClick(vm.menu.userInfo)">\u7528\u6237\u4FE1\u606F</a></li><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.role}"><a ng-click="vm.menuClick(vm.menu.role)">\u89D2\u8272</a></li><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.prem}"><a ng-click="vm.menuClick(vm.menu.prem)">\u6743\u9650</a></li><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.department}"><a ng-click="vm.menuClick(vm.menu.department)">\u90E8\u95E8</a></li><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.project}"><a ng-click="vm.menuClick(vm.menu.project)">\u9879\u76EE</a></li><li role="presentation" ng-class="{\'active\':vm.currentMenu == vm.menu.company}"><a ng-click="vm.menuClick(vm.menu.company)">\u516C\u53F8</a></li></ul><section ng-show="vm.currentMenu == vm.menu.userInfo" include-with-scope="app/pages/settings/users/userInfo.html"></section><section ng-show="vm.currentMenu == vm.menu.role" include-with-scope="app/pages/settings/users/userRole.html"></section><section ng-show="vm.currentMenu == vm.menu.prem"><div class="col-md-12"><h3>&nbsp;</h3><div js-tree="vm.tree.prem.basicConfig" ng-model="vm.tree.prem.treeData" tree="vm.tree.prem.basicTree" tree-events-obj="vm.tree.prem.treeEventsObj"></div><h3>&nbsp;</h3></div></section><section ng-show="vm.currentMenu == vm.menu.department"><div class="col-md-12"><h3>&nbsp;</h3><div js-tree="vm.tree.department.basicConfig" ng-model="vm.tree.department.treeData" tree="vm.tree.department.basicTree" tree-events-obj="vm.tree.department.treeEventsObj"></div><h3>&nbsp;</h3></div></section><section ng-show="vm.currentMenu == vm.menu.project"><div class="col-md-12"><h3>&nbsp;</h3><div js-tree="vm.tree.project.basicConfig" ng-model="vm.tree.project.treeData" tree="vm.tree.project.basicTree" tree-events-obj="vm.tree.project.treeEventsObj"></div><h3>&nbsp;</h3></div></section><section ng-show="vm.currentMenu == vm.menu.company" include-with-scope="app/pages/settings/roles/company.html"></section></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.ok()">\u4FDD\u5B58</button></div></div>');
$templateCache.put('app/pages/settings/users/userRole.html','<div class="userinfo"><h3>&nbsp;</h3><div class="row"><div class="col-md-12"><div class="checkbox" ng-repeat="item in vm.model.roles"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="item.isAssigned"> <span>&nbsp;&nbsp;&nbsp;&nbsp;{{item.roleDisplayName}}</span></label></div></div></div></div>');
$templateCache.put('app/pages/settings/users/users.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u540D\u79F0</label><div class="col-sm-9"><div class="input-group"><input class="form-control" placeholder="\u540D\u79F0" ng-model="vm.search.name" ng-keyup="vm.onKeyup($event)"> <span class="input-group-btn"><button type="button" ng-click="vm.onClear(\'name\')" class="btn btn-default"><span class="fa fa-times"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u89D2\u8272</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="role" ng-model="vm.dropdonw.role.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.role.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u89D2\u8272">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.role.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.role.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u72B6\u6001</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="status" ng-model="vm.dropdonw.status.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.status.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u72B6\u6001">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.status.selectItems | filter: $select.search"><span ng-bind-html="item.text"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.status.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div><div ba-panel="" class="report-grid table-edit"><button class="btn btn-primary btn-with-icon pull-right" ng-disabled="vm.grid.addBtnDisabled" ng-click="vm.grid.options(null,vm.grid.optionEnum.add)"><i class="fa fa-plus-circle"></i>\u6DFB\u52A0\u7528\u6237</button><table class="table table-hover" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th>\u7528\u6237\u540D</th><th>\u540D\u5B57</th><th>\u59D3\u6C0F</th><th>\u89D2\u8272</th><th>\u6FC0\u6D3B</th><th>\u521B\u5EFA\u65F6\u95F4</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td><span class="over-hidden">{{ item.userName }}</span></td><td><span class="over-hidden">{{ item.name }}</span></td><td><span class="over-hidden">{{ item.surname }}</span></td><td><span ng-repeat="r in item.roles" class="over-hidden">{{ r.roleName }}&nbsp;</span></td><td><span class="over-hidden">{{ item.isActive?\'\u662F\':\'\u5426\' }}</span></td><td><span class="over-hidden">{{ item.creationTime|date:\'yyyy-MM-dd\' }}</span></td><td><div class="dropdown"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.options(item,vm.grid.optionEnum.update);"><i class="fa fa-pencil-square-o"></i>\u7F16\u8F91</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.options(item,vm.grid.optionEnum.del);"><i class="fa fa-trash-o"></i>\u5220\u9664</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.options(item,vm.grid.optionEnum.active);"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{ item.isActive?\'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><st-pagination class="col-md-11" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-1 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{(vm.grid.tableState.pagination.start/vm.grid.tableState.pagination.number)+1}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/settings/warehouse/warehouse.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u540D\u79F0</label><div class="col-sm-9"><div class="input-group"><input class="form-control" placeholder="\u4ED3\u5E93\u540D\u79F0" ng-model="vm.search.name" ng-keyup="vm.onKeyup($event)"> <span class="input-group-btn"><button type="button" ng-click="vm.onClear(\'name\')" class="btn btn-default"><span class="fa fa-times"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u4ED3\u5E93\u7F16\u7801</label><div class="col-sm-9"><div class="input-group"><input class="form-control" placeholder="\u4ED3\u5E93\u7F16\u7801" ng-model="vm.search.code" ng-keyup="vm.onKeyup($event)"> <span class="input-group-btn"><button type="button" ng-click="vm.onClear(\'code\')" class="btn btn-default"><span class="fa fa-times"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u4ED3\u5E93\u72B6\u6001</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="status" ng-model="vm.dropdonw.status.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.status.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u4ED3\u5E93\u72B6\u6001">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.status.selectItems | filter: $select.search"><span ng-bind-html="item.text"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.status.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div><div ba-panel="" class="report-grid table-edit"><button class="btn btn-primary btn-with-icon pull-right" ng-disabled="vm.grid.addBtnDisabled" ng-click="vm.grid.add()"><i class="fa fa-plus-circle"></i>\u6DFB\u52A0\u4ED3\u5E93</button><table class="table table-hover" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th>\u540D\u79F0</th><th>\u7F16\u7801</th><th>\u8D1F\u8D23\u4EBA</th><th>\u6240\u5C5E\u90E8\u95E8</th><th>\u72B6\u6001</th><th>\u5907\u6CE8</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td><span editable-text="item.name" e-name="name" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform" e-placeholder="\u4ED3\u5E93\u540D\u79F0" class="over-hidden" e-required="">{{ item.name }}</span></td><td><span editable-text="item.code" e-name="code" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform" class="over-hidden" e-placeholder="\u4ED3\u5E93\u7F16\u7801" e-required="">{{ item.code }}</span></td><td><span ng-init="item.employeeSelected={name:item.employeeName,id:item.employeeId}" editable-text="item.employeeSelected" data-e-form="rowform" name="employeeName" e-name="employeeSelected" onbeforesave="vm.grid.checkTempEmpty($data)" e-typeahead-wait-ms="500" e-ng-change="vm.grid.typeahead.employee.onInput($data)" e-typeahead-select-on-exact="true" e-typeahead-show-hint="true" e-typeahead-on-select="vm.grid.typeahead.employee.onSelect($item, $model, $label, item)" e-required="" e-ng-model="item.employeeSelected" e-placeholder="\u8D1F\u8D23\u4EBA" e-uib-typeahead="s as s.name for s in vm.grid.typeahead.employee.data | filter:{name:$viewValue} | limitTo:8"><span class="over-hidden">{{ item.employeeName }}</span></span></td><td class="ui-select"><div ng-init="item.departmentSelected={id:item.departmentId, name:item.departmentName}" editable-ui-select="item.departmentSelected" data-e-form="rowform" data-e-name="departmentSelected" name="departmentName" theme="bootstrap" data-e-ng-model="item.departmentSelected" onshow="vm.grid.dropdown.department.onShow()" e-ng-change="vm.grid.dropdown.department.onChange($data,item)" onbeforesave="vm.grid.checkTempEmpty($data)" e-required=""><editable-ui-select-match placeholder="\u9009\u62E9\u90E8\u95E8">{{$select.selected.name || \'\u9009\u62E9\u90E8\u95E8\'}}</editable-ui-select-match><editable-ui-select-choices repeat="t in vm.grid.dropdown.department.data | filter: $select.search"><span ng-bind-html="t.name"></span></editable-ui-select-choices><span class="over-hidden">{{item.departmentSelected.name}}</span></div></td><td class="editable-radiolist"><span ng-init="item.isActive=(item.isActive===true?true:false)" editable-radiolist="item.isActive" data-e-form="rowform" class="over-hidden" data-e-name="isActive" e-ng-options="s.value as s.text for s in ::vm.grid.radioList.status.data track by s.value">{{ item.isActive?\'\u542F\u7528\':\'\u7981\u7528\'}}</span></td><td><span editable-textarea="item.comment" data-e-form="rowform" data-e-name="comment" class="over-hidden" e-rows="7" e-cols="40">{{ item.comment}}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="vm.grid.inserted == item" onbeforesave="vm.grid.update($index,$data,item)"><button type="submit" title="\u63D0\u4EA4" ng-disabled="rowform.$waiting" class="btn-success fa fa-check"></button> <button type="button" title="\u53D6\u6D88" ng-disabled="rowform.$waiting" class="btn-danger fa fa-ban" ng-click="vm.grid.cancel($index,item,rowform)"></button></form><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.addBtnDisabled = true;rowform.$show()"><i class="fa fa-pencil-square-o"></i> \u7F16\u8F91</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.disabled($index);"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{ item.isActive?\'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td></tr></tbody><tfoot><tr><td colspan="10" class="text-center"><st-pagination class="col-md-11" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-1 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{(vm.grid.tableState.pagination.start/vm.grid.tableState.pagination.number)+1}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/settings/widgets/tree.html','<div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-warning btn-with-icon" ng-disabled="vm.btnNewDisabled" ng-click="deselectAll()"><i class="fa fa-times" aria-hidden="true"></i> \u6E05\u9664\u9009\u62E9</button></div><div><button class="btn btn-primary btn-with-icon" ng-disabled="vm.btnNewDisabled || vm.disabeldAddBtn" ng-click="addNewNode()"><i class="fa fa-plus-circle" aria-hidden="true"></i>\u6DFB\u52A0</button></div><div><button class="btn btn-danger btn-with-icon" ng-disabled="vm.btnNewDisabled" ng-click="deleteNode()"><i class="fa fa-trash-o" aria-hidden="true"></i>\u5220\u9664</button></div><div><button class="btn btn-primary btn-with-icon" ng-disabled="vm.btnNewDisabled" ng-click="collapse()"><i class="fa fa-caret-up" aria-hidden="true"></i>\u6298\u53E0\u6240\u6709</button></div><div><button class="btn btn-primary btn-with-icon" ng-disabled="vm.btnNewDisabled" ng-click="expand()"><i class="fa fa-caret-down" aria-hidden="true"></i>\u5C55\u5F00\u6240\u6709</button></div><div><button class="btn btn-primary btn-with-icon" ng-disabled="vm.btnNewDisabled" ng-click="refresh()"><i class="fa fa-refresh" aria-hidden="true"></i>\u5237\u65B0</button></div><div><button type="button" ng-disabled="vm.btnNewDisabled" class="btn btn-primary btn-with-icon" ng-click="vm.saveTree()"><i class="ion-android-checkmark-circle"></i>\u4FDD\u5B58</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events-obj="treeEventsObj"></div></div>');
$templateCache.put('app/pages/settleAccount/customer/customerDetail.html','<div ba-panel="" class="report-grid"><div class="row"><div class="col-md-12 table-report"><div class="report report-header"><table class="table table-bordered table-hover table-condensed"><thead><tr><th>\u5BA2\u6237</th><th>\u9879\u76EE</th></tr></thead><tbody><tr ng-repeat="item in vm.data" ng-init="data = vm.onRepeat($index,item,vm.data)"><td rowspan="{{::data.rowspan}}" ng-if="::data.isShow" ng-bind="::item.customerName"></td><td ng-bind="::item.projectName"></td></tr></tbody></table></div><div class="report report-content"><table class="table table-bordered table-hover table-condensed" st-table="vm.data"><thead><tr><th>{{vm.search.year}}&nbsp;\u5E74\u7D2F\u8BA1</th><th>1\u6708</th><th>2\u6708</th><th>3\u6708</th><th>4\u6708</th><th>5\u6708</th><th>6\u6708</th><th>7\u6708</th><th>8\u6708</th><th>9\u6708</th><th>10\u6708</th><th>11\u6708</th><th>12\u6708</th></tr></thead><tbody><tr ng-repeat="item in vm.data"><td>{{(item.revenueTotal|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueJan|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueFeb|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueMar|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueApr|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueMay|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueJun|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueJul|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueAug|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueSept|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueOct|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueNov|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueDec|currency)||\'&nbsp;\'}}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/settleAccount/customer/customerTotal.html','<div ba-panel="" class="report-grid customer-report"><table class="table table-hover" st-table="vm.data"><thead><tr class="sortable"><th>\u5BA2\u6237</th><th>\u9879\u76EE</th><th st-sort="today">\u4ECA\u65E5\u5B9E\u65F6\u8425\u6536</th><th st-sort="monthTotal">\u672C\u6708\u7D2F\u8BA1</th><th st-sort="yearTotal">{{vm.search.year}}&nbsp;\u5E74\u7D2F\u8BA1</th></tr></thead><tbody><tr ng-repeat="item in vm.data" ng-init="data = vm.onRepeat($index,item,vm.data)" class="editable-tr-wrap"><td class="table-id" rowspan="{{::data.rowspan}}" ng-if="::data.isShow"><span ng-bind="::item.customerName"></span></td><td><span ng-bind="::item.projectName"></span></td><td>{{(item.revenueCD|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueCM|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueCY|currency)||\'&nbsp;\'}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/settleAccount/department/departmentDetail.html','<div ba-panel="" class="report-grid"><div class="row"><div class="col-md-12 table-report"><div class="report report-header"><table class="table table-bordered table-hover table-condensed"><thead><tr><th>\u90E8\u95E8</th></tr></thead><tbody><tr ng-repeat="item in vm.data" ng-init="data = item"><td ng-bind="::data.name"></td></tr></tbody></table></div><div class="report report-content"><table class="table table-bordered table-hover table-condensed" st-table="vm.data"><thead><tr><th>{{vm.search.year}}&nbsp;\u5E74\u7D2F\u8BA1</th><th>1\u6708</th><th>2\u6708</th><th>3\u6708</th><th>4\u6708</th><th>5\u6708</th><th>6\u6708</th><th>7\u6708</th><th>8\u6708</th><th>9\u6708</th><th>10\u6708</th><th>11\u6708</th><th>12\u6708</th></tr></thead><tbody><tr ng-repeat="item in vm.data"><td>{{(item.revenueTotal|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueJan|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueFeb|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueMar|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueApr|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueMay|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueJun|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueJul|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueAug|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueSept|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueOct|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueNov|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueDec|currency)||\'&nbsp;\'}}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/settleAccount/department/departmentTotal.html','<div ba-panel="" class="report-grid"><table class="table table-hover" st-table="vm.data"><thead><tr class="sortable"><th>\u90E8\u95E8</th><th>\u4ECA\u65E5\u5B9E\u65F6\u8425\u6536</th><th>\u672C\u6708\u7D2F\u8BA1</th><th>{{vm.search.year}}&nbsp;\u5E74\u7D2F\u8BA1</th></tr></thead><tbody><tr ng-repeat="item in vm.data" class="editable-tr-wrap"><td class="table-id"><span ng-bind="::item.name"></span></td><td><span ng-bind="::item.revenueCD|currency"></span></td><td><span ng-bind="::item.revenueCM|currency"></span></td><td><span ng-bind="::item.revenueCY|currency"></span></td></tr></tbody></table></div>');
$templateCache.put('app/pages/settleAccount/report/report.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-3"><div class="col-sm-12"><div class="input-group"><ui-select ng-model="vm.panelDropdown.selected" class="bootstrap-select form-control" append-to-body="true" search-enabled="false" on-select="vm.panelDropdown.onSelected($item, $model)"><ui-select-match placeholder="-- \u9009\u62E9\u7EDF\u8BA1 --">{{$select.selected.name || \'-- \u9009\u62E9\'}}{{ $select.selected.name?\'\u7EDF\u8BA1\': \'\u7EDF\u8BA1 --\'}}</ui-select-match><ui-select-choices repeat="item in vm.panelDropdown.selectItems | filter: $select.search"><span>{{item.name}}\u7EDF\u8BA1</span></ui-select-choices></ui-select></div></div></div><div class="form-group col-md-3"><div class="col-sm-12"><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datepicker.format}}" datepicker-options="vm.datepicker.options" ng-model="vm.datepicker.model" is-open="vm.datepicker.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5E74" alt-input-formats="altInputFormats" show-button-bar="false" ng-change="vm.datepicker.dateChanged()" ng-click="vm.datepicker.open()"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.datepicker.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group col-md-5"><div class="col-sm-12"><div class="input-group"><ui-select multiple="" ng-model="vm.dropdown.customer.selected" class="form-control" ng-disabled="false" append-to-body="true" search-enabled="false" on-select="vm.dropdown.customer.onSelected($item, $model)" on-remove="vm.dropdown.customer.onRemove($item, $model)"><ui-select-match placeholder="-- \u9009\u62E9{{vm.dropdownPlaceholder}} --">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown[vm.panelDropdown.selected.code].selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdown.customer.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-1"><buton class="btn btn-success btn-with-icon" ng-click="vm.refresh()"><i class="fa fa-building-o" aria-hidden="true"></i>\u8BA1\u7B97</buton></div></div></div><div ng-include="vm.panelDropdown.selected.templateUrl"></div>');
$templateCache.put('app/pages/settleAccount/panel/panel.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-4"><div class="col-sm-12"><div class="input-group"><ui-select ng-model="vm.panelDropdown.selected" class="bootstrap-select form-control" append-to-body="true" search-enabled="false" on-select="vm.panelDropdown.onSelected($item, $model)"><ui-select-match placeholder="-- \u9009\u62E9\u770B\u677F --">{{$select.selected.name || \'-- \u9009\u62E9\'}}{{ $select.selected.name?\'\u770B\u677F\': \'\u770B\u677F --\'}}</ui-select-match><ui-select-choices repeat="item in vm.panelDropdown.selectItems | filter: $select.search"><span>{{item.name}}\u770B\u677F</span></ui-select-choices></ui-select></div></div></div><div class="form-group col-md-7"><div class="col-sm-12"><div class="input-group"><ui-select multiple="" ng-model="vm.dropdown.customer.selected" class="form-control" ng-disabled="false" append-to-body="true" search-enabled="false" on-select="vm.dropdown.customer.onSelected($item, $model)" on-remove="vm.dropdown.customer.onRemove($item, $model)"><ui-select-match placeholder="-- \u9009\u62E9{{vm.dropdownPlaceholder}} --">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown[vm.panelDropdown.selected.code].selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdown.customer.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-1"><buton class="btn btn-success btn-with-icon" ng-click="vm.refresh()"><i class="fa fa-building-o" aria-hidden="true"></i>\u8BA1\u7B97</buton></div></div></div><div ng-include="vm.panelDropdown.selected.templateUrl"></div>');
$templateCache.put('app/pages/settleAccount/saleBilling/modal.form.create.html','<h3>&nbsp;</h3><form name="vm.myForm" autocomplete="off"><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.customer.$invalid && (vm.myForm.customer.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u5BA2\u6237</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="customer" ng-required="true" ng-model="vm.dropdown.customer.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdown.customer.onSelected($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u5BA2\u6237">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.customer.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><a ng-click="vm.dropdown.customer.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></a></span></div></div></div><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.project.$invalid && (vm.myForm.project.partnerId.$dirty || vm.myForm.$submitted)}"><label class="col-sm-3 control-label">\u9879\u76EE</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="project" ng-required="true" ng-model="vm.dropdown.project.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdown.project.onSelected($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u9879\u76EE">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.project.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><a ng-click="vm.dropdown.project.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></a></span></div></div></div><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.warehouse.$invalid && (vm.myForm.warehouse.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputPhone" class="col-sm-3 control-label">\u4ED3\u5E93</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="warehouse" ng-required="true" ng-model="vm.dropdown.warehouse.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdown.warehouse.onSelected($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.warehouse.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><a ng-click="vm.dropdown.warehouse.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></a></span></div></div></div><div class="form-group clearfix"><label for="inputPhone" class="col-sm-3 control-label">\u8D27\u4E3B</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select multiple="" name="owner" ng-model="vm.dropdown.owner.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdown.owner.onSelected($item, $model)" on-remove="vm.dropdown.owner.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u8D27\u4E3B">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.owner.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn input-group-btn-multiple"><a ng-click="vm.dropdown.owner.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></a></span></div></div></div><div class="form-group clearfix" ng-class="{\'has-error\': ((vm.myForm.beginDate.$invalid && (vm.myForm.beginDate.partnerId.$dirty || vm.myForm.$submitted))||(vm.myForm.endDate.$invalid && (vm.myForm.endDate.partnerId.$dirty || vm.myForm.$submitted)))}"><label for="inputEmail3" class="col-sm-3 control-label">\u8D26\u671F</label><div class="col-sm-9 inner-input"><div class="input-group no-bottom"><input name="beginDate" ng-required="true" type="text" class="form-control" uib-datepicker-popup="{{vm.datepickerBegin.format}}" datepicker-options="vm.datepickerBegin.options" ng-model="vm.model.periodFrom" is-open="vm.datepickerBegin.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="vm.datepickerBegin.altInputFormats" show-button-bar="true" ng-change="vm.datepickerBegin.dateChanged()" ng-click="vm.datepickerBegin.open()" placeholder="\u5F00\u59CB\u65E5\u671F"> <span class="input-group-addon">~</span> <input name="endDate" ng-required="true" type="text" class="form-control" uib-datepicker-popup="{{vm.datepickerEnd.format}}" datepicker-options="vm.datepickerEnd.options" ng-model="vm.model.periodTo" is-open="vm.datepickerEnd.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="vm.datepickerEnd.altInputFormats" show-button-bar="true" ng-change="vm.datepickerEnd.dateChanged()" ng-click="vm.datepickerEnd.open()" placeholder="\u7ED3\u675F\u65E5\u671F"></div></div></div><div class="form-group clearfix on-bottom" ng-class="{\'has-error\': vm.myForm.period.$invalid && (vm.myForm.period.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u6708\u5EA6</label><div class="col-sm-9 inner-input"><div class="input-group no-bottom"><input name="period" ng-required="true" type="text" class="form-control" uib-datepicker-popup="{{vm.period.format}}" datepicker-options="vm.period.options" ng-model="vm.model.period" is-open="vm.period.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="altInputFormats" show-button-bar="true" ng-change="vm.period.dateChanged()" ng-click="vm.period.open()" placeholder="\u6708\u5EA6"></div></div></div></form>');
$templateCache.put('app/pages/settleAccount/saleBilling/modal.form.detail.html','<div class="table-edit"><table class="table table-hover" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th ng-if="vm.isNotTuoPanWei">{{vm.numberCell}}</th><th ng-if="vm.isNotTuoPanWei">{{vm.cell2Name}}</th><th>\u5355\u636E\u65F6\u95F4</th><th>\u6570\u91CF</th><th style="width:auto;">\u5355\u4F4D</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td ng-if="vm.isNotTuoPanWei">{{::item.orderNumber}}</td><td ng-if="vm.isNotTuoPanWei">{{::item.dn}}</td><td>{{::item.workDate|date:\'yyyy-MM-dd\'}}</td><td>{{::item.quantity|number:3}}</td><td style="width:auto;">{{::item.unitName}}</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><st-pagination class="col-md-10" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-2 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{(vm.grid.tableState.pagination.start/vm.grid.tableState.pagination.number)+1}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/settleAccount/saleBilling/modal.form.submit.html','<div>&nbsp;</div><form name="vm.myForm" autocomplete="off"><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.billingName.$invalid && (vm.myForm.billingName.partnerId.$dirty || vm.myForm.$submitted)}"><label for="inputEmail3" class="col-sm-3 control-label">\u8D26\u5355\u540D\u79F0</label><div class="col-sm-9"><div class="input-group no-bottom"><input type="text" class="form-control" ng-model="vm.model.name" name="billingName" required="true" placeholder="\u8D26\u5355\u540D\u79F0"></div></div></div><div class="form-group clearfix"><label class="col-sm-3 control-label">\u8BF4\u660E</label><div class="col-sm-9"><div class="input-group no-bottom"><textarea class="form-control" style="width:100%" name="comment" ng-model="vm.model.comment" placeholder="\u8BF4\u660E"></textarea></div></div></div></form>');
$templateCache.put('app/pages/settleAccount/saleBilling/saleBilling.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="row"><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u53D1\u7968\u62AC\u5934</label><div class="col-sm-9"><div class="input-group"><ui-select ng-model="vm.dropdonw.customer.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.customer.onSelected($item, $model)" on-remove="vm.dropdonw.customer.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u5BA2\u6237">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.customer.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.customer.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u9879\u76EE</label><div class="col-sm-9"><div class="input-group"><ui-select ng-model="vm.dropdonw.project.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.project.onSelected($item, $model)" on-remove="vm.dropdonw.project.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u9879\u76EE">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.project.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.project.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u4ED3\u5E93</label><div class="col-sm-9"><div class="input-group"><ui-select ng-model="vm.dropdonw.warehouse.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.warehouse.onSelected($item, $model)" on-remove="vm.dropdonw.warehouse.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.warehouse.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.warehouse.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u8D27\u4E3B</label><div class="col-sm-9"><div class="input-group"><ui-select multiple="" ng-model="vm.dropdonw.owner.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.owner.onSelected($item, $model)" on-remove="vm.dropdonw.owner.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u8D27\u4E3B">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.owner.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn input-group-btn-multiple"><button type="button" ng-click="vm.dropdonw.owner.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div><div class="row"><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u8D26\u5355\u540D\u79F0</label><div class="col-sm-9"><div class="input-group"><input type="text" class="form-control" ng-model="vm.search.name" placeholder="\u8D26\u5355\u540D\u79F0" ng-keyup="vm.onNameKeyup($event)"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.onNameChange(true)"><i class="fa fa-times"></i></button></span></div></div></div><div class="form-group col-md-3"><label for="inputEmail3" class="col-sm-3 control-label">\u8D26\u671F\u5F00\u59CB</label><div class="col-sm-9 inner-input"><div class="input-group datepicker-with-clear-btn"><input name="beginDate" ng-required="true" type="text" class="form-control" uib-datepicker-popup="{{vm.datepicker.from.format}}" datepicker-options="vm.datepicker.from.options" ng-model="vm.datepicker.from.model" is-open="vm.datepicker.from.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="altInputFormats" show-button-bar="true" ng-change="vm.datepicker.from.dateChanged()" ng-click="vm.datepicker.from.open()" placeholder="\u5F00\u59CB\u65E5\u671F"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.datepicker.from.clear()"><i class="fa fa-times"></i></button></span></div></div></div><div class="form-group col-md-3"><label for="inputEmail3" class="col-sm-3 text-center">&nbsp;</label><div class="col-sm-9 inner-input"><div class="input-group datepicker-with-clear-btn"><input name="beginDate" ng-required="true" type="text" class="form-control" uib-datepicker-popup="{{vm.datepicker.to.format}}" datepicker-options="vm.datepicker.to.options" ng-model="vm.datepicker.to.model" is-open="vm.datepicker.to.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="altInputFormats" show-button-bar="true" ng-change="vm.datepicker.to.dateChanged()" ng-click="vm.datepicker.to.open()" placeholder="\u7ED3\u675F\u65E5\u671F"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.datepicker.to.clear()"><i class="fa fa-times"></i></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u72B6\u6001</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="status" ng-model="vm.dropdonw.status.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.status.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u72B6\u6001">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.status.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.status.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div></div><div ba-panel="" class="report-grid table-edit"><button class="btn btn-primary btn-with-icon pull-right" ng-click="vm.createSaleBilling();"><i class="fa fa-plus-circle"></i>\u751F\u6210\u8D26\u5355</button><table class="table table-hover" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th>\u8D26\u5355\u7F16\u53F7</th><th>\u8D26\u5355\u540D\u79F0</th><th>\u5BA2\u6237</th><th>\u9879\u76EE</th><th>\u4ED3\u5E93</th><th>\u8D27\u4E3B</th><th>\u6708\u5EA6</th><th>\u603B\u8D39\u7528</th><th>\u5B9E\u9645\u8D39\u7528</th><th>\u72B6\u6001</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td><span ng-bind="item.number" class="over-hidden"></span></td><td><span ng-bind="item.name" class="over-hidden"></span></td><td><span ng-bind="item.customerName" class="over-hidden"></span></td><td><span ng-bind="item.projectName" class="over-hidden"></span></td><td><span ng-bind="item.warehouseName" class="over-hidden"></span></td><td><span ng-bind="item.owner.join(\',\')" class="over-hidden"></span></td><td><span ng-bind="item.period|date:\'yyyy-MM\'" class="over-hidden"></span></td><td><span>{{item.price|currency}}</span></td><td><span>{{item.actualPrice|currency}}</span></td><td><span ng-bind="item.statusStr" class="over-hidden"></span></td><td><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" ui-state="\'SettleAccount.SaleBillingDetail\'" ui-state-params="{id:item.id}"><i class="fa fa-eye"></i> \u67E5\u770B</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.exportExcel(item)"><i class="fa fa-file-excel-o"></i> \u5BFC\u51FA</a></li></ul></div></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center"><st-pagination class="col-md-11" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-1 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{(vm.grid.tableState.pagination.start/vm.grid.tableState.pagination.number)+1}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/settleAccount/saleBilling/saleBillingDetail.html','<div ba-panel="" id="page" ba-panel-class="profile-page salebilling-detail"><div class="panel-content"><div class="row"><div class="col-md-1"><button type="button" class="btn btn-default btn-with-icon" ui-state="\'SettleAccount.SaleBilling\'"><i class="ion-chevron-left"></i>\u8D26\u5355</button></div><div class="col-md-10 form-group" style="line-height: 34px;"><span><label class="control-label">\u8D26\u5355\u7F16\u53F7\uFF1A</label> <span>{{vm.model.number}}</span></span> &nbsp;&nbsp;&nbsp;&nbsp; <span><label class="control-label">\u53D1\u7968\u62AC\u5934\uFF1A</label> <span>{{vm.model.customerName}}</span></span> &nbsp;&nbsp;&nbsp;&nbsp; <span class="pull-right"><label class="control-label">\u8D26\u5355\u72B6\u6001\uFF1A</label> <span>{{vm.model.statusStr}}</span></span></div><div class="col-md-1"><div class="dropdown pull-right"><button class="btn btn-primary btn-with-icon" type="button" id="btnOpt" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\u6267\u884C&nbsp;&nbsp; <i class="fa fa-caret-down" aria-hidden="true"></i></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="btnOpt"><li ng-if="vm.model.status < 2"><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.opt.reCreate();"><i class="fa fa-calculator" aria-hidden="true"></i> \u91CD\u65B0\u751F\u6210</a></li><li ng-if="vm.model.status < 2"><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.opt.saveBilling();"><i class="fa fa-floppy-o" aria-hidden="true"></i> \u4FDD\u5B58\u8D26\u5355</a></li><li ng-if="vm.model.status < 2"><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.opt.submitBilling();"><i class="fa fa-paper-plane-o" aria-hidden="true"></i> \u63D0\u4EA4\u8D26\u5355</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.opt.confimBilling();"><i class="fa fa-print" aria-hidden="true"></i> \u786E\u8BA4\u5F00\u7968</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.opt.confimReceipt();"><i class="fa fa-money" aria-hidden="true"></i> \u786E\u8BA4\u6536\u6B3E</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.opt.finish();"><i class="fa fa-check-square-o" aria-hidden="true"></i> \u786E\u8BA4\u7ED3\u5355</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.opt.exportExcel();"><i class="fa fa-file-excel-o"></i> \u5BFC\u51FA\u8D26\u5355</a></li></ul></div></div></div><hr><div class="row"><div class="col-md-7 row"><div class="row"><div class="col-md-12"><span class="form-group col-md-4"><label class="control-label">\u8D26\u5355\u540D\u79F0\uFF1A</label><br><span>{{vm.model.name}}</span></span> <span class="form-group col-md-5"><label class="control-label">\u8D26\u671F\uFF1A</label><br><span>{{vm.model.periodFrom|date:\'yyyy-MM-dd\'}}&nbsp;~&nbsp;{{vm.model.periodTo|date:\'yyyy-MM-dd\'}}</span></span> <span class="form-group col-md-3"><label class="control-label">\u6708\u5EA6\uFF1A</label><br><span>{{vm.model.period|date:\'yyyy-MM\'}}</span></span></div><div>&nbsp;</div><div class="col-md-12"><span class="form-group col-md-4"><label class="control-label">\u9879\u76EE\uFF1A</label><br><span>{{vm.model.projectName}}</span></span> <span class="form-group col-md-5"><label class="control-label">\u4ED3\u5E93\uFF1A</label><br><span>{{vm.model.warehouseName}}</span></span> <span class="form-group col-md-3"><label class="control-label">\u8D27\u4E3B\uFF1A</label><br><span>{{vm.model.owner.join(\',\')}}</span></span></div><div>&nbsp;</div><div class="col-md-12"><span class="form-group col-md-12"><label class="control-label">\u63D0\u4EA4\u8BF4\u660E\uFF1A</label><br><span>{{vm.model.comment}}</span></span></div></div></div><div class="a56-form-inline form-inline col-md-5"><div class="form-group col-xs-3 clearfix"><label class="control-label">\u6700\u7EC8\u4EF7\u683C</label><div class="input-group"><div class="form-control text-control" ng-bind="(vm.model.price|currency)||\'&nbsp;\'"></div></div></div><div class="form-group col-xs-1 clearfix"><label class="control-label">&nbsp;</label><div class="form-control text-control text-center">+</div></div><div class="form-group col-xs-4"><label for="adjustmentPrice" class="control-label">\u6574\u4F53\u8C03\u6574</label><br><div class="input-group"><input class="input-number form-control" name="adustmentPrice" type="number" id="adjustmentPrice" ng-model="vm.model.adjustmentPrice" ng-change="vm.adjustmentPriceChange()" placeholder="\u8C03\u6574\u4EF7\u683C"><div class="input-group-addon" style="padding: 6px 3px;">\uFFE5</div></div></div><div class="form-group col-xs-1"><label for="inputEmail3" class="control-label">&nbsp;</label><div class="form-control text-control">=</div></div><div class="form-group col-xs-3"><label class="control-label">\u5B9E\u9645\u603B\u989D</label><div class="input-gruop"><div class="form-control text-control" ng-bind="(vm.model.actualPrice|currency)||\'&nbsp;\'"></div></div></div><div ng-show="vm.model.adjustmentPrice"><div class="form-group" style="width:100%;"><label for="adjustmentReason" class="control-label">\u6574\u4F53\u8C03\u6574\u5907\u6CE8</label> <input class="form-control" name="adjustmentReason" id="adjustmentReason" ng-model="vm.model.adjustmentReason" placeholder="\u6574\u4F53\u8C03\u6574\u5907\u6CE8"></div></div></div></div><h3 class="with-line">\u8D26\u5355\u660E\u7EC6</h3><div class="table-edit"><table class="table table-hover" st-table="vm.grid.rowCollection" st-safe-src="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th>\u79D1\u76EE</th><th>\u670D\u52A1\u9879\u76EE</th><th>\u8D39\u7387</th><th>\u6570\u91CF</th><th>\u5355\u4F4D</th><th>\u91D1\u989D</th><th>\u8C03\u6574\u4EF7\u683C</th><th>\u8C03\u6574\u539F\u56E0</th><th>\u6700\u7EC8\u4EF7\u683C</th><th>\u8BF4\u660E</th><th>\u660E\u7EC6</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.rowCollection" class="editable-row"><td>{{::item.subjectName}}</td><td>{{::item.chargeName}}</td><td>{{::item.price|currency}}</td><td>{{::item.quantity|number:3}}</td><td>{{::item.unitName}}</td><td>{{::item.amount|currency}}</td><td><span editable-number="item.adjustmentPrice" e-class="input-number editable-input" onaftersave="vm.grid.ajustmentPriceUpdate(item)" blur="cancel">{{item.adjustmentPrice|currency}}&nbsp;&nbsp;&nbsp;&nbsp;</span></td><td><span editable-text="item.adjustmentReason" e-class="input-number editable-input" blur="cancel">{{item.adjustmentReason}}&nbsp;&nbsp;&nbsp;&nbsp;</span></td><td>{{item.finalPrice|currency}}</td><td style="width:auto;max-width: 200px;"><span editable-text="item.comment" e-class="input-number editable-input" blur="cancel">{{item.comment}}&nbsp;&nbsp;&nbsp;&nbsp;</span></td><td><a href="javascript:void(0)" ng-click="vm.viewDetail(item)">\u660E\u7EC6</a></td></tr></tbody><tfoot><tr><td colspan="11" class="text-center">&nbsp;</td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/settleAccount/subject/subjectDetail.html','<div ba-panel="" class="report-grid"><div class="row"><div class="col-md-12 table-report"><div class="report report-header"><table class="table table-bordered table-hover table-condensed"><thead><tr><th>\u79D1\u76EE</th></tr></thead><tbody><tr ng-repeat="item in vm.data" ng-init="data = item"><td ng-bind="::data.name"></td></tr></tbody></table></div><div class="report report-content"><table class="table table-bordered table-hover table-condensed" st-table="vm.data"><thead><tr><th>{{vm.search.year}}&nbsp;\u5E74\u7D2F\u8BA1</th><th>1\u6708</th><th>2\u6708</th><th>3\u6708</th><th>4\u6708</th><th>5\u6708</th><th>6\u6708</th><th>7\u6708</th><th>8\u6708</th><th>9\u6708</th><th>10\u6708</th><th>11\u6708</th><th>12\u6708</th></tr></thead><tbody><tr ng-repeat="item in vm.data"><td>{{(item.revenueTotal|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueJan|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueFeb|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueMar|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueApr|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueMay|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueJun|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueJul|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueAug|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueSept|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueOct|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueNov|currency)||\'&nbsp;\'}}</td><td>{{(item.revenueDec|currency)||\'&nbsp;\'}}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/settleAccount/subject/subjectTotal.html','<div ba-panel="" class="report-grid"><table class="table table-hover" st-table="vm.data"><thead><tr class="sortable"><th>\u79D1\u76EE</th><th st-sort="today">\u4ECA\u65E5\u5B9E\u65F6\u8425\u6536</th><th st-sort="monthTotal">\u672C\u6708\u7D2F\u8BA1</th><th st-sort="yearTotal">{{vm.search.year}}&nbsp;\u5E74\u7D2F\u8BA1</th></tr></thead><tbody><tr ng-repeat="item in vm.data" class="editable-tr-wrap"><td class="table-id"><span ng-bind="::item.name"></span></td><td><span ng-bind="::item.revenueCD|currency"></span></td><td><span ng-bind="::item.revenueCM|currency"></span></td><td><span ng-bind="::item.revenueCY|currency"></span></td></tr></tbody></table></div>');
$templateCache.put('app/pages/settleAccount/warehouse/orderDetail.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u4ED3\u5E93</label><div class="col-sm-9"><div class="input-group"><ui-select ng-model="vm.dropdonw.warehouse.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.warehouse.onSelected($item, $model)" on-remove="vm.dropdonw.warehouse.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.warehouse.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.warehouse.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-3"><label class="col-sm-3 control-label">\u65E5\u671F</label><div class="col-sm-9"><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datepicker.date.format}}" datepicker-options="vm.datepicker.date.options" ng-model="vm.datepicker.date.model" is-open="vm.datepicker.date.opened" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="altInputFormats" show-button-bar="true" ng-change="vm.datepicker.date.dateChanged($event)" ng-click="vm.datepicker.date.open()"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.datepicker.date.clear()"><i class="fa fa-times"></i></button></span></div></div></div><div class="form-group col-md-5"><label class="col-sm-3 control-label">\u5355\u53F7</label><div class="col-sm-9"><div class="input-group"><input type="text" class="form-control" ng-model="vm.search.number" placeholder="\u51FA\u5165\u5E93\u5355\u53F7/DN/\u8FD0\u5355\u53F7" ng-keyup="vm.onNoKeyup($event)"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.onNoChange(true)"><i class="fa fa-times"></i></button></span></div></div></div></div></div><div ba-panel="" class="report-grid table-edit"><table class="table table-hover order-detail" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th class="no">\u5355\u53F7</th><th class="no">DN/\u8FD0\u5355\u53F7</th><th class="no">\u7C7B\u578B</th><th class="no" style="min-width:100px;">\u65E5\u671F</th><th class="tuo">\u6258</th><th class="tuo">\u6258\u76D8\u5316</th><th class="tuo">\u7F20\u7ED5\u819C</th><th class="xiang">\u7BB1</th><th class="xiang">\u5851\u6599\u5C01\u88C5</th><th class="xiang">\u5916\u7BB1\u6807\u7B7E</th><th class="xiang">\u66FF\u6362\u6807\u7B7E</th><th class="jian">\u4EF6</th><th class="jian">\u6C14\u6CE1\u819C</th><th class="jian">\u7EC4\u88C5</th><th class="options">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td>{{ item.number }}</td><td><span>{{ item.dn }}</span></td><td><span>{{ item.flowName }}</span></td><td><span>{{ item.workDate|date:\'yyyy-MM-dd\' }}</span></td><td><span>{{ item.palletQuantity || \'\' }}</span></td><td><div class="ck-input"><div editable-number="item.palletzationQuantity" class="text-input" e-class="input-number" e-name="palletzationQuantity" e-form="rowform">{{ item.palletzationQuantity || \'\' }}</div></div></td><td><div class="ck-input"><div editable-number="item.palletStretchFilmQuantity" class="text-input" e-class="input-number" e-name="palletStretchFilmQuantity" e-form="rowform">{{ item.palletStretchFilmQuantity || \'\' }}</div></div></td><td><span>{{ item.packageQuantity || \'\' }}</span></td><td><div class="ck-input"><div editable-number="item.packagePlasticQuantity" class="text-input" e-class="input-number" e-name="packagePlasticQuantity" e-form="rowform">{{ item.packagePlasticQuantity || \'\' }}</div></div></td><td><div class="ck-input"><div editable-number="item.packageLabelQuantity" class="text-input" e-class="input-number" e-name="packageLabelQuantity" e-form="rowform">{{ item.packageLabelQuantity || \'\' }}</div></div></td><td><div class="ck-input"><div editable-number="item.packageLabelReplaceQuantity" class="text-input" e-class="input-number" e-name="packageLabelReplaceQuantity" e-form="rowform">{{ item.packageLabelReplaceQuantity || \'\'}}</div></div></td><td><span>{{ item.pieceQuantity || \'\'}}</span></td><td><div class="ck-input"><div editable-number="item.pieceAirBubbleFilmQuantity" class="text-input" e-class="input-number" e-name="pieceAirBubbleFilmQuantity" e-form="rowform">{{ item.pieceAirBubbleFilmQuantity || \'\'}}</div></div></td><td><div class="ck-input"><div editable-number="item.assemblyQuantity" class="text-input" e-class="input-number" e-name="assemblyQuantity" e-form="rowform">{{ item.assemblyQuantity || \'\'}}</div></div></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="vm.grid.inserted == item" onbeforesave="vm.grid.update($index,$data,item)"><button type="submit" ng-disabled="rowform.$waiting" class="btn-success fa fa-check"></button> <button type="button" ng-disabled="rowform.$waiting" class="btn-danger fa fa-ban" ng-click="vm.grid.cancel($index,item,rowform)"></button></form><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.addBtnDisabled = true;rowform.$show()"><i class="fa fa-pencil-square-o"></i> \u7F16\u8F91</a></li></ul></div></td></tr></tbody><tfoot><tr><td colspan="15" class="text-center"><st-pagination class="col-md-11" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-1 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{(vm.grid.tableState.pagination.start/vm.grid.tableState.pagination.number)+1}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/settleAccount/warehouse/saleCharge.html','<div ba-panel="" class="grid-search"><div class="form-horizontal"><div class="form-group col-md-4"><label class="col-sm-2 control-label">\u4ED3\u5E93</label><div class="col-sm-10"><div class="input-group"><ui-select ng-model="vm.dropdonw.warehouse.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.warehouse.onSelected($item, $model)" on-remove="vm.dropdonw.warehouse.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u4ED3\u5E93">{{$select.selected.name || \'\u9009\u62E9\u4ED3\u5E93\'}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.warehouse.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.warehouse.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-4"><label class="col-sm-2 control-label">\u9879\u76EE</label><div class="col-sm-10"><div class="input-group"><ui-select ng-model="vm.dropdonw.project.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.project.onSelected($item, $model)" on-remove="vm.dropdonw.project.onRemove($item, $model)"><ui-select-match placeholder="\u9009\u62E9\u9879\u76EE">{{vm.dropdonw.project.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.project.selectItems | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.project.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div><div class="form-group col-md-4"><label class="col-sm-3 control-label">\u72B6\u6001</label><div class="col-sm-9"><div class="input-group no-bottom"><ui-select name="status" ng-model="vm.dropdonw.status.selected" class="form-control bootstrap-select" ng-disabled="false" append-to-body="true" search-enabled="true" on-select="vm.dropdonw.status.onSelected($item, $model)"><ui-select-match placeholder="\u6240\u6709\u72B6\u6001">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="item in vm.dropdonw.status.selectItems | filter: $select.search"><span ng-bind-html="item.text"></span></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="vm.dropdonw.status.clearSelected()" class="btn btn-default"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div></div></div><div ba-panel="" class="report-grid table-edit top-panel"><button type="button" ng-disabled="!(!vm.grid.addBtnDisabled && vm.search.warehouseId && vm.search.projectId)" ng-click="vm.grid.add()" class="btn btn-primary btn-with-icon save-profile pull-right"><i class="fa fa-plus-circle"></i>\u6DFB\u52A0</button><table class="table table-hover" st-table="vm.grid.gridData" st-pipe="vm.grid.callServer"><thead><tr><th>\u79D1\u76EE</th><th>\u670D\u52A1\u9879\u76EE</th><th>\u8D39\u7528\u53D1\u751F\u65E5\u671F</th><th>\u8D27\u4E3B</th><th>\u6570\u91CF</th><th>\u8D39\u7387</th><th>\u5355\u4F4D</th><th>\u5907\u6CE8</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.grid.gridData" class="editable-row"><td class="ui-select"><div editable-ui-select="item.subjectSelect" data-e-form="rowform" data-e-name="subjectSelect" name="subjectName" theme="bootstrap" data-e-ng-model="item.subjectId" onshow="vm.grid.dropdonw.subject.onShow()" e-ng-change="vm.grid.dropdonw.subject.onChange($data,item)" onbeforesave="vm.grid.checkTempEmpty($data)" e-required=""><editable-ui-select-match placeholder="\u9009\u62E9\u79D1\u76EE">{{$select.selected.name || \'\u9009\u62E9\u79D1\u76EE\'}}</editable-ui-select-match><editable-ui-select-choices repeat="t in vm.grid.dropdonw.subject.data | filter: $select.search"><span ng-bind-html="t.name| highlight: $select.search"></span></editable-ui-select-choices><span class="over-hidden">{{item.subjectSelect.name}}</span></div></td><td><span editable-text="item.chargeName" e-name="chargeName" class="over-hidden" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform">{{ item.chargeName }}</span></td><td><span editable-bsdate="item.chargeDate" e-name="chargeDate" e-is-open="vm.grid.datepicker.chargeDate.opened" e-ng-click="vm.grid.datepicker.chargeDate.open($event)" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform" e-datepicker-popup="yyyy-MM-dd" e-close-text="\u5173\u95ED" e-clear-text="\u6E05\u7A7A" e-current-text="\u4ECA\u5929" e-show-calendar-button="false" e-datepicker-options="vm.grid.datepicker.chargeDate.options" onshow="vm.grid.datepicker.chargeDate.onShow($data,item)" e-required=""><span class="over-hidden">{{ item.chargeDate|date:\'yyyy-MM-dd\'}}</span></span></td><td><span editable-text="item.owner" e-name="owner" class="over-hidden" e-form="rowform">{{ item.owner }}</span></td><td><span editable-number="item.quantity" e-name="quantity" class="over-hidden" e-class="input-number" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform" e-required="">{{ item.quantity }}</span></td><td><span editable-number="item.price" e-name="price" class="over-hidden" e-class="input-number" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform" e-required="">{{ item.price|currency }}</span></td><td><span editable-text="item.unitName" e-name="unitName" class="over-hidden" onbeforesave="vm.grid.checkTempEmpty($data)" e-form="rowform" e-required="">{{ item.unitName }}</span></td><td><span editable-text="item.comment" e-rows="1" class="over-hidden" e-name="comment" e-form="rowform">{{ item.comment }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="vm.grid.inserted == item" onbeforesave="vm.grid.update($index,$data,item)"><button type="submit" ng-disabled="rowform.$waiting" class="btn-success fa fa-check"></button> <button type="button" ng-disabled="rowform.$waiting" class="btn-danger fa fa-ban" ng-click="vm.grid.cancel($index,item,rowform)"></button></form><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.addBtnDisabled = true;rowform.$show()"><i class="fa fa-pencil-square-o"></i> \u7F16\u8F91</a></li><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.grid.disabled($index);"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{ item.isActive?\'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td></tr></tbody><tfoot><tr><td colspan="9" class="text-center"><st-pagination class="col-md-11" mid-range="3" edge-range="3" st-displayed-pages="vm.grid.pageSetting.displayedPages" st-items-by-page="vm.grid.pageSetting.pageSize"></st-pagination><div class="col-md-1 text-right">{{vm.grid.tableState.pagination.totalItemCount}} ({{(vm.grid.tableState.pagination.start/vm.grid.tableState.pagination.number)+1}}/{{vm.grid.tableState.pagination.numberOfPages}})</div></td></tr></tfoot></table></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/modalForm/modal.form.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{vm.title}}</h4></div><div class="modal-body"><div class="modal-body-content"><section ng-include="vm.includeTemp"></section></div></div><div class="modal-footer"><div>&nbsp;</div><button type="button" class="btn btn-default btn-with-icon" ng-click="vm.cancel()"><i class="fa fa-ban"></i> {{vm.cancelBtnText}}</button> &nbsp;&nbsp; <button type="button" class="btn btn-success btn-with-icon" ng-click="vm.ok()"><i class="fa fa-check" aria-hidden="true"></i> {{vm.okBtnText}}</button></div></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>0</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>\u901A\u77E5</strong></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>0</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>\u6D88\u606F</strong></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div></div></li></ul><audio id="audioFile"><source src="./assets/notification.mp3" type="audio/mpeg"></audio>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span>A56</span></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="search"></div><div ng-if="appSession.user" class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><i class="fa fa-user" style="color:#fff;width:45px;font-size:40px;height: 45px;border-radius: 50%;vertical-align: middle;background-color: #cecece;text-align: center;" aria-hidden="true"></i></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="" class="signout" ng-click="singOut()"><i class="fa fa-power-off"></i>\u9000\u51FA</a></li></ul></div><msg-center></msg-center></div><div class="questions-section">{{appSession.user.surname || \'\'}}</div><div ng-if="!appSession.user" class="questions-section pull-right-loinlink"><a href="./auth.html" style="color:#fff;">\u767B\u5F55</a></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/dashboard/DCBI/widgets/he-qing.html','<div class="col-lg-6 col-md-12 col-sm-12" ng-class="{\'f-s\':ctrl.isMobile}" ba-panel="" ba-panel-title="\u5230\u8D27" ba-panel-class="medium-panel traffic-panel"><div class="table-responsive"><table class="table"><tr><th>\u767B\u8BB0\u53F7</th><th>\u59D3\u540D</th><th>\u8F66\u724C</th><th>\u65F6\u95F4</th></tr></table></div></div><div class="col-lg-6 col-md-12 col-sm-12" ng-class="{\'f-s\':ctrl.isMobile}" ba-panel="" ba-panel-title="\u5165\u5E93\u8BA2\u5355" ba-panel-class="medium-panel traffic-panel"><div class="channels-block traffic-flex" ng-class="{\'transparent\': ctrl.transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="into-storage" data-ng-init="ctrl.initIntoStorage(\'into-storage\',true)" width="280" height="280"></canvas><div class="traffic-text">{{ctrl.intoStorage.sum}}&nbsp;<sub>\u5355</sub> <span>\u603B\u8BA1</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in ctrl.intoStorage.labels" ng-init="i = $index; data = ctrl.intoStorage.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">{{ctrl.intoStorage.datasets[0].percentage[i]}}&nbsp;<sub>\u5355</sub></span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width:{{item.percentage}}%"></div></div></div></div></div></div></div><div class="col-lg-6 col-md-12 col-sm-12" ng-class="{\'f-s\':ctrl.isMobile}" ba-panel="" ba-panel-title="\u6025\u6599" ba-panel-class="medium-panel traffic-panel"><table class="table table-item table-bordered"><thead><tr><th>Item No.</th><th>Qty</th><th>Uom</th></tr></thead></table></div><div class="col-lg-6 col-md-12 col-sm-12" ng-class="{\'f-s\':ctrl.isMobile}" ba-panel="" ba-panel-title="\u9886\u6599\u5355" ba-panel-class="medium-panel traffic-panel"><div class="channels-block traffic-flex" ng-class="{\'transparent\': ctrl.transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="out-storage" data-ng-init="ctrl.initOutStorage(\'out-storage\',true)" width="280" height="280"></canvas><div class="traffic-text">{{ctrl.outStorage.sum.rowNum}}&nbsp;<sub>\u884C</sub> <span>{{ctrl.outStorage.sum.typeNum}}&nbsp;<sub>\u79CD</sub></span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in ctrl.outStorage.labels track by $index" ng-init="i = $index; data = ctrl.outStorage.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}} <span class="channel-number">{{ctrl.outStorage.datasets[0].percentage[i].typeNum}}&nbsp;<sub>\u79CD</sub></span> &nbsp;&nbsp;&nbsp;&nbsp; <span class="channel-number">{{ctrl.outStorage.datasets[0].percentage[i].rowNum}}&nbsp;<sub>\u884C</sub></span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width:{{item.percentage}}%"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/DCBI/widgets/mei-long.html','<div class="col-lg-6 col-md-12 col-sm-12" ng-class="{\'f-s\':ctrl.isMobile}" ba-panel="" ba-panel-title="\u5230\u8D27" ba-panel-class="medium-panel traffic-panel"><div class="table-responsive"><table class="table"><tr><th>\u767B\u8BB0\u53F7</th><th>\u59D3\u540D</th><th>\u8F66\u724C</th><th>\u65F6\u95F4</th></tr></table></div></div><div class="col-lg-6 col-md-12 col-sm-12" ng-class="{\'f-s\':ctrl.isMobile}" ba-panel="" ba-panel-title="\u5165\u5E93\u8BA2\u5355" ba-panel-class="medium-panel traffic-panel"><div class="channels-block traffic-flex" ng-class="{\'transparent\': ctrl.transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="into-storage" data-ng-init="ctrl.initIntoStorage(\'into-storage\',true)" width="280" height="280"></canvas><div class="traffic-text">{{ctrl.intoStorage.sum}}&nbsp;<sub>\u5355</sub> <span>\u603B\u8BA1</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in ctrl.intoStorage.labels" ng-init="i = $index; data = ctrl.intoStorage.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">{{ctrl.intoStorage.datasets[0].percentage[i]}}&nbsp;<sub>\u5355</sub></span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width:{{item.percentage}}%"></div></div></div></div></div></div></div><div class="col-lg-6 col-md-12 col-sm-12" ng-class="{\'f-s\':ctrl.isMobile,\'empty-panel\':ctrl.isMobile}">&nbsp;</div><div class="col-lg-6 col-md-12 col-sm-12" ng-class="{\'f-s\':ctrl.isMobile}" ba-panel="" ba-panel-title="\u51FA\u5E93\u8BA2\u5355" ba-panel-class="medium-panel traffic-panel"><div class="channels-block traffic-flex" ng-class="{\'transparent\': ctrl.transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="out-storage" data-ng-init="ctrl.initOutStorage(\'out-storage\',true)" width="280" height="280"></canvas><div class="traffic-text">{{ctrl.outStorage.sum}}&nbsp;<sub>\u5355</sub> <span>\u603B\u8BA1</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in ctrl.outStorage.labels" ng-init="i = $index; data = ctrl.outStorage.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">{{ctrl.outStorage.datasets[0].percentage[i]}}&nbsp;<sub>\u5355</sub></span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width:{{item.percentage}}%"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/settings/saleTariff/modalForm/modal.form.cycleCharge.html','<div class="userinfo"><form name="vm.myForm" autocomplete="off"><div class="row"><div class="col-md-4"><div class="form-group"><label for="ruleSelect">\u5546\u54C1\u540D\u79F0</label><ui-select ng-model="vm.dropdown.rule.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="true" name="ruleSelect" ng-required="true" on-select="vm.dropdown.rule.onChange($item, $model, \'rule\')"><ui-select-match placeholder="-- \u9009\u62E9\u5546\u54C1\u540D\u79F0 --">{{$select.selected.name || \'-- \u9009\u62E9\u5546\u54C1\u540D\u79F0 --\'}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.rule.data | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><label>\u9ED8\u8BA4\u79D1\u76EE</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.parentName}}</div></div></div><div class="col-md-4"><div class="form-group"><label>\u9ED8\u8BA4\u5355\u4F4D</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.unitName}}</div></div></div><div class="col-md-4"><div class="form-group"><label>\u5546\u54C1\u8BF4\u660E</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.comment}}</div></div></div></div><hr><div class="row"><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.subjectSelect.$invalid && (vm.myForm.subjectSelect.$dirty || vm.myForm.$submitted)}"><label for="subjectSelect">\u79D1\u76EE</label><ui-select ng-model="vm.dropdown.subject.selected" class="btn-group bootstrap-select form-control" append-to-body="true" name="subjectSelect" search-enabled="true" ng-required="true" on-select="vm.dropdown.subject.onChange($item, $model, \'subject\')"><ui-select-match placeholder="-- \u9009\u62E9\u79D1\u76EE --">{{$select.selected.name || \'-- \u9009\u62E9\u79D1\u76EE --\'}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.subject.data | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.chargeName.$invalid && (vm.myForm.chargeName.$dirty || vm.myForm.$submitted)}"><label for="chargeName">\u670D\u52A1\u9879\u76EE</label> <input class="form-control" id="chargeName" name="chargeName" ng-model="vm.model.chargeName" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.price.$invalid && (vm.myForm.price.$dirty || vm.myForm.$submitted)}"><label for="price">\u8D39\u7387</label> <input class="input-number form-control" maxlength="32" id="price" name="price" ng-required="true" ng-model="vm.model.price" type="number"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.unitName.$invalid && (vm.myForm.unitName.$dirty || vm.myForm.$submitted)}"><label for="unitName">\u5355\u4F4D</label> <input class="form-control" maxlength="32" id="unitName" name="unitName" ng-required="true" ng-model="vm.model.unitName" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.quantity.$invalid && (vm.myForm.quantity.$dirty || vm.myForm.$submitted)}"><label for="quantity">\u6570\u91CF</label> <input class="input-number form-control" maxlength="32" name="quantity" ng-required="true" ng-model="vm.model.quantity" type="number"></div></div><div class="row"><div class="form-group clearfix col-md-6"><label>\u9891\u7387</label><div class="form-control"><label for="radio_day"><input id="radio_day" name="priceRate" type="radio" value="1" ng-model="vm.model.priceRate"> &nbsp;\u5929</label> &nbsp;&nbsp; <label for="radio_month"><input id="radio_month" name="priceRate" type="radio" value="2" ng-model="vm.model.priceRate"> &nbsp;\u6708</label></div></div></div><div class="row"></div><div class="row"><div class="form-group clearfix col-md-12"><label for="comment">\u8BF4\u660E</label> <textarea class="form-control" style="height:auto;" rows="2" ng-model="vm.model.comment" name="comment"></textarea></div></div></form></div>');
$templateCache.put('app/pages/settings/saleTariff/modalForm/modal.form.order.html','<div class="userinfo"><form name="vm.myForm" autocomplete="off"><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.myForm.ruleSelect.$invalid && (vm.myForm.ruleSelect.$dirty || vm.myForm.$submitted)}"><label for="ruleSelect">\u5546\u54C1\u540D\u79F0</label><ui-select ng-model="vm.dropdown.rule.selected" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" name="ruleSelect" ng-required="true" on-select="vm.dropdown.rule.onChange($item, $model, \'rule\')"><ui-select-match placeholder="-- \u9009\u62E9\u5546\u54C1\u540D\u79F0 --">{{$select.selected.name || \'-- \u9009\u62E9\u5546\u54C1\u540D\u79F0 --\'}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.rule.data | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><label>\u9ED8\u8BA4\u79D1\u76EE</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.parentName}}</div></div></div><div class="col-md-4"><div class="form-group"><label>\u9ED8\u8BA4\u5355\u4F4D</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.unitName}}</div></div></div><div class="col-md-4"><div class="form-group"><label>\u5546\u54C1\u8BF4\u660E</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.comment}}</div></div></div></div><hr><div class="row"><div class="form-group clearfix col-md-6"><label>\u8BA2\u5355\u7C7B\u578B</label><div class="form-control"><label for="all"><input id="all" name="orderType" type="radio" ng-model="vm.model.groupType" ng-checked="true"> &nbsp;\u5168\u90E8</label> &nbsp;&nbsp; <label for="inbound"><input id="inbound" name="orderType" type="radio" value="1" ng-model="vm.model.groupType"> &nbsp;\u5165\u5E93</label> &nbsp;&nbsp; <label for="outbound"><input id="outbound" name="orderType" type="radio" value="2" ng-model="vm.model.groupType"> &nbsp;\u51FA\u5E93</label></div></div></div><div class="row"><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.subjectSelect.$invalid && (vm.myForm.subjectSelect.$dirty || vm.myForm.$submitted)}"><label for="subjectSelect">\u79D1\u76EE</label><ui-select ng-model="vm.dropdown.subject.selected" class="btn-group bootstrap-select form-control" append-to-body="true" name="subjectSelect" search-enabled="true" ng-required="true" on-select="vm.dropdown.subject.onChange($item, $model, \'subject\')"><ui-select-match placeholder="-- \u9009\u62E9\u79D1\u76EE --">{{$select.selected.name || \'-- \u9009\u62E9\u79D1\u76EE --\'}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.subject.data | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.chargeName.$invalid && (vm.myForm.chargeName.$dirty || vm.myForm.$submitted)}"><label for="chargeName">\u670D\u52A1\u9879\u76EE</label> <input class="form-control" id="chargeName" name="chargeName" ng-model="vm.model.chargeName" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.price.$invalid && (vm.myForm.price.$dirty || vm.myForm.$submitted)}"><label for="price">\u8D39\u7387</label> <input class="input-number form-control" maxlength="32" id="price" name="price" ng-required="true" ng-model="vm.model.price" type="number"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.unitName.$invalid && (vm.myForm.unitName.$dirty || vm.myForm.$submitted)}"><label for="unitName">\u5355\u4F4D</label> <input class="form-control" maxlength="32" id="unitName" name="unitName" ng-required="true" ng-model="vm.model.unitName" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.minAmount.$invalid && (vm.myForm.minAmount.$dirty || vm.myForm.$submitted)}"><label for="minAmount">\u6700\u4F4E\u4EF7\u683C&nbsp;(\u6BCF\u5355)</label> <input class="input-number form-control" maxlength="32" ng-model="vm.model.minAmount" required="" id="minAmount" name="minAmount" type="number"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.minQty.$invalid && (vm.myForm.minQty.$dirty || vm.myForm.$submitted)}"><label for="minQty">\u6700\u4F4E\u6570\u91CF&nbsp;(\u6BCF\u5355\u5355\u4F4D)</label> <input class="input-number form-control" maxlength="32" id="minQty" name="minQty" ng-model="vm.model.minQty" required="" type="number"></div></div><div class="row"><div class="form-group clearfix col-md-12"><label for="price">\u8BF4\u660E</label> <textarea class="form-control" style="height:auto;" rows="2" ng-model="vm.model.comment" name="comment">\r\n            </textarea></div></div></form></div>');
$templateCache.put('app/pages/settings/saleTariff/modalForm/modal.form.stock.html','<div class="userinfo"><form name="vm.myForm" autocomplete="off"><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.myForm.ruleSelect.$invalid && (vm.myForm.ruleSelect.$dirty || vm.myForm.$submitted)}"><label for="ruleSelect">\u5546\u54C1\u540D\u79F0</label><ui-select ng-model="vm.dropdown.rule.selected" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" name="ruleSelect" ng-required="true" on-select="vm.dropdown.rule.onChange($item, $model, \'rule\')"><ui-select-match placeholder="-- \u9009\u62E9\u5546\u54C1\u540D\u79F0 --">{{$select.selected.name || \'-- \u9009\u62E9\u5546\u54C1\u540D\u79F0 --\'}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.rule.data | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><label>\u9ED8\u8BA4\u79D1\u76EE</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.parentName}}</div></div></div><div class="col-md-4"><div class="form-group"><label>\u9ED8\u8BA4\u5355\u4F4D</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.unitName}}</div></div></div><div class="col-md-4"><div class="form-group"><label>\u5546\u54C1\u8BF4\u660E</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.comment}}</div></div></div></div><hr><div class="row"><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.subjectSelect.$invalid && (vm.myForm.subjectSelect.$dirty || vm.myForm.$submitted)}"><label for="subjectSelect">\u79D1\u76EE</label><ui-select ng-model="vm.dropdown.subject.selected" class="btn-group bootstrap-select form-control" append-to-body="true" name="subjectSelect" search-enabled="true" ng-required="true" on-select="vm.dropdown.subject.onChange($item, $model, \'subject\')"><ui-select-match placeholder="-- \u9009\u62E9\u79D1\u76EE --">{{$select.selected.name || \'-- \u9009\u62E9\u79D1\u76EE --\'}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.subject.data | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.chargeName.$invalid && (vm.myForm.chargeName.$dirty || vm.myForm.$submitted)}"><label for="chargeName">\u670D\u52A1\u9879\u76EE</label> <input class="form-control" id="chargeName" name="chargeName" ng-model="vm.model.chargeName" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.mPrice.$invalid && (vm.myForm.mPrice.$dirty || vm.myForm.$submitted)}"><label for="mPrice">\u8D39\u7387</label> <input class="input-number form-control" maxlength="32" id="mPrice" name="mPrice" ng-required="true" ng-model="vm.model.price" type="number"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.unitName.$invalid && (vm.myForm.unitName.$dirty || vm.myForm.$submitted)}"><label for="unitName">\u5355\u4F4D</label> <input class="form-control" maxlength="32" id="unitName" name="unitName" ng-required="true" ng-model="vm.model.unitName" type="text"></div></div><div class="row"><div class="form-group clearfix col-md-6"><label>\u9891\u7387</label><div class="form-control"><label for="radio_day"><input id="radio_day" name="priceRate" type="radio" value="1" ng-model="vm.model.priceRate"> &nbsp;\u5929</label> &nbsp;&nbsp; <label for="radio_month"><input id="radio_month" name="priceRate" type="radio" value="2" ng-model="vm.model.priceRate"> &nbsp;\u6708</label></div></div><div ng-if="vm.model.priceRate == 2" class="form-group clearfix col-md-6"><label>\u6708\u5EA6\u8BA1\u6570\u89C4\u5219</label><div class="form-control"><label for="isApplyMonthAvg_f"><input id="isApplyMonthAvg_f" name="isApplyMonthAvg" type="radio" ng-value="false" ng-model="vm.model.isApplyMonthAvg"> &nbsp;\u6700\u9AD8\u503C</label> &nbsp;&nbsp; <label for="isApplyMonthAvg_t"><input id="isApplyMonthAvg_t" name="isApplyMonthAvg" type="radio" ng-value="true" ng-model="vm.model.isApplyMonthAvg"> &nbsp;\u5E73\u5747\u503C</label></div></div></div><div class="row"><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.minAmount.$invalid && (vm.myForm.minAmount.$dirty || vm.myForm.$submitted)}"><label for="minAmount">\u6BCF<strong class="text-danger">{{vm.model.priceRate == 1 ? \'\u5929\':\'\u6708\'}}</strong>\u6700\u4F4E\u4EF7\u683C</label><input class="input-number form-control" maxlength="32" ng-model="vm.model.minAmount" id="minAmount" name="minAmount" type="number"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.minQty.$invalid && (vm.myForm.minQty.$dirty || vm.myForm.$submitted)}"><label for="minQty">\u6BCF<strong class="text-danger">{{vm.model.priceRate == 1 ? \'\u5929\':\'\u6708\'}}</strong>\u6700\u4F4E\u6570\u91CF</label><input class="input-number form-control" maxlength="32" id="minQty" name="minQty" ng-model="vm.model.minQty" type="number"></div></div><div class="row"><div class="form-group clearfix col-md-6"><label>\u5E94\u7528\u5CF0\u503C</label><div class="form-control"><label for="radio_isApplyMaxQty_y"><input id="radio_isApplyMaxQty_y" name="isApplyMaxQty" type="radio" ng-value="true" ng-model="vm.model.isApplyMaxQty"> &nbsp;\u662F</label> &nbsp;&nbsp; <label for="radio_isApplyMaxQty_n"><input id="radio_isApplyMaxQty_n" name="isApplyMaxQty" type="radio" ng-value="false" ng-model="vm.model.isApplyMaxQty"> &nbsp;\u5426</label></div></div></div><div class="row"><div class="col-md-12"><div class="form-group clearfix" ng-class="{\'has-error\': vm.myForm.price.$invalid && (vm.myForm.price.$dirty || vm.myForm.$submitted)}"><label for="price">\u8BF4\u660E</label> <textarea class="form-control" style="height:auto;" rows="2" ng-model="vm.model.comment" name="price">\r\n                    </textarea></div></div></div></form></div>');
$templateCache.put('app/pages/settings/saleTariff/modalForm/modal.form.stockCell.html','<div class="userinfo"><form name="vm.myForm" autocomplete="off"><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': vm.myForm.ruleSelect.$invalid && (vm.myForm.ruleSelect.$dirty || vm.myForm.$submitted)}"><label for="ruleSelect">\u5546\u54C1\u540D\u79F0</label><ui-select ng-model="vm.dropdown.rule.selected" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" name="ruleSelect" ng-required="true" on-select="vm.dropdown.rule.onChange($item, $model, \'rule\')"><ui-select-match placeholder="-- \u9009\u62E9\u5546\u54C1\u540D\u79F0 --">{{$select.selected.name || \'-- \u9009\u62E9\u5546\u54C1\u540D\u79F0 --\'}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.rule.data | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><label>\u9ED8\u8BA4\u79D1\u76EE</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.parentName}}</div></div></div><div class="col-md-4"><div class="form-group"><label>\u9ED8\u8BA4\u5355\u4F4D</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.unitName}}</div></div></div><div class="col-md-4"><div class="form-group"><label>\u5546\u54C1\u8BF4\u660E</label><div class="form-control" ng-disabled="true">{{vm.dropdown.rule.selected.comment}}</div></div></div></div><hr><div class="row"><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.subjectSelect.$invalid && (vm.myForm.subjectSelect.$dirty || vm.myForm.$submitted)}"><label for="subjectSelect">\u79D1\u76EE</label><ui-select ng-model="vm.dropdown.subject.selected" class="btn-group bootstrap-select form-control" append-to-body="true" name="subjectSelect" search-enabled="true" ng-required="true" on-select="vm.dropdown.subject.onChange($item, $model, \'subject\')"><ui-select-match placeholder="-- \u9009\u62E9\u79D1\u76EE --">{{$select.selected.name || \'-- \u9009\u62E9\u79D1\u76EE --\'}}</ui-select-match><ui-select-choices repeat="item in vm.dropdown.subject.data | filter: $select.search"><span ng-bind-html="item.name"></span></ui-select-choices></ui-select></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.chargeName.$invalid && (vm.myForm.chargeName.$dirty || vm.myForm.$submitted)}"><label for="chargeName">\u670D\u52A1\u9879\u76EE</label> <input class="form-control" id="chargeName" name="chargeName" ng-model="vm.model.chargeName" required="" type="text"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.price.$invalid && (vm.myForm.price.$dirty || vm.myForm.$submitted)}"><label for="price">\u8D39\u7387</label> <input class="input-number form-control" maxlength="32" id="price" name="price" ng-required="true" ng-model="vm.model.price" type="number"></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.unitName.$invalid && (vm.myForm.unitName.$dirty || vm.myForm.$submitted)}"><label for="unitName">\u5355\u4F4D</label> <input class="form-control" maxlength="32" id="unitName" name="unitName" ng-required="true" ng-model="vm.model.unitName" type="text"></div></div><div class="row"><div class="form-group clearfix col-md-6"><label for="percentQuantity">\u57FA\u6570</label> <input class="input-number form-control" maxlength="32" ng-model="vm.model.percentQuantity" name="percentQuantity" type="number"></div><div class="form-group clearfix col-md-6"><label for="percentValue">\u589E\u5E45&nbsp;<sub class="text-danger" style="color:#a94442;">(\u8BF7\u8F93\u5165\u767E\u5206\u6BD4\u5C0F\u6570,\u4F8B\u5982 10% \u5E94\u8F93\u5165 0.1)</sub></label> <input class="input-number form-control" maxlength="32" ng-model="vm.model.percentValue" name="percentValue" type="number"></div></div><div class="row"><div class="form-group clearfix col-md-6"><label>\u9891\u7387</label><div class="form-control"><label for="radio_day"><input id="radio_day" name="priceRate" type="radio" value="1" ng-model="vm.model.priceRate"> &nbsp;\u5929</label> &nbsp;&nbsp; <label for="radio_month"><input id="radio_month" name="priceRate" type="radio" value="2" ng-model="vm.model.priceRate"> &nbsp;\u6708</label></div></div><div class="form-group clearfix col-md-6" ng-class="{\'has-error\': vm.myForm.minQty.$invalid && (vm.myForm.minQty.$dirty || vm.myForm.$submitted)}"><label for="minQty">\u6BCF<strong class="text-danger">{{vm.model.priceRate == 1 ? \'\u5929\':\'\u6708\'}}</strong>\u6700\u4F4E\u6570\u91CF</label> <input class="input-number form-control" maxlength="32" id="minQty" name="minQty" ng-model="vm.model.minQty" required="" type="number"></div></div><div class="row"><div class="form-group clearfix col-md-6"><label>\u5E94\u7528\u5CF0\u503C</label><div class="form-control"><label for="radio_isApplyMaxQty_y"><input id="radio_isApplyMaxQty_y" name="isApplyMaxQty" type="radio" ng-value="true" ng-model="vm.model.isApplyMaxQty"> &nbsp;\u662F</label> &nbsp;&nbsp; <label for="radio_isApplyMaxQty_n"><input id="radio_isApplyMaxQty_n" name="isApplyMaxQty" type="radio" ng-value="false" ng-model="vm.model.isApplyMaxQty"> &nbsp;\u5426</label></div></div></div><div class="row"><div class="col-md-12"><div class="form-group clearfix"><label for="price">\u8BF4\u660E</label> <textarea class="form-control" style="height:auto;" rows="2" ng-model="vm.model.comment" name="comment">\r\n                    </textarea></div></div></div></form></div>');
$templateCache.put('app/pages/settings/saleTariff/widgets/table.td.cycleCharge.html','<td class="ui-select" ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{item.subjectName}}</span></td><td class="ui-select" ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{item.chargeName}}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.price|currency }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.unitName }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.quantity }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{item.priceRate|a56Enum:vm.priceRateEnum:\'key\':\'text\'}}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{item.comment}}</span></td><td><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.cycleCharge.grid.update(item)"><i class="fa fa-pencil-square-o"></i> \u7F16\u8F91</a></li><li ng-if="!!item.id"><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.cycleCharge.grid.disabled($index)"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{ item.isActive?\'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td>');
$templateCache.put('app/pages/settings/saleTariff/widgets/table.td.order.html','<td class="ui-select" ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{item.subjectName}}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.chargeName }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.price |currency}}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.unitName }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.comment }}</span></td><td><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.order.grid.update(item)"><i class="fa fa-pencil-square-o"></i> \u7F16\u8F91</a></li><li ng-if="!!item.id"><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.order.grid.disabled($index)"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{ item.isActive?\'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td>');
$templateCache.put('app/pages/settings/saleTariff/widgets/table.td.stock.html','<td class="ui-select" ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{item.subjectName}}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.chargeName }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.price|currency }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.unitName }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{item.priceRate|a56Enum:vm.priceRateEnum:\'key\':\'text\'}}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.comment }}</span></td><td><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.stock.grid.update(item)"><i class="fa fa-pencil-square-o"></i> \u7F16\u8F91</a></li><li ng-if="!!item.id"><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.stock.grid.disabled($index)"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{ item.isActive?\'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td>');
$templateCache.put('app/pages/settings/saleTariff/widgets/table.td.stockCell.html','<td class="ui-select" ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{item.subjectName}}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.chargeName }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.price|currency }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.unitName }}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{item.priceRate|a56Enum:vm.priceRateEnum:\'key\':\'text\'}}</span></td><td ng-class="{\'item-disabled\':!item.isActive}"><span class="over-hidden">{{ item.comment }}</span></td><td><div class="dropdown" ng-show="!rowform.$visible"><button style="border-radius: 5px; width: auto;" class="btn btn-default btn-with-icon dropdown-toggle" type="button" id="{{\'opration\'+$index}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></button><ul class="dropdown-menu table-option-menu btn-dropdown-menu-left" aria-labelledby="{{\'opration\'+$index}}"><li><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.stockCell.grid.update(item)"><i class="fa fa-pencil-square-o"></i> \u7F16\u8F91</a></li><li ng-if="!!item.id"><a class="btn-with-icon" href="javascript:void(0);" ng-click="vm.stockCell.grid.disabled($index)"><i class="fa" ng-class="{\'fa-check\':!item.isActive,\'fa-ban\':item.isActive}"></i> {{ item.isActive?\'\u7981\u7528\':\'\u542F\u7528\'}}</a></li></ul></div></td>');}]);